const translations = {
  fr: {
    // Navbar
    nav_search: 'Trouver un médecin',
    nav_about: 'À propos',
    nav_favorites: 'Favoris',
    nav_my_favorites: 'Mes favoris',
    nav_settings: 'Paramètres',
    nav_login: 'Se connecter',
    nav_register: "S'inscrire",
    nav_logout: 'Déconnexion',
    nav_admin: 'Administration',
    nav_doctor_cabinet: 'Mon cabinet',
    nav_appointments: 'Mes rendez-vous',
    nav_dashboard: 'Tableau de bord',
    role_admin: 'Administrateur',
    role_doctor: 'Médecin',
    role_patient: 'Patient',

    // Home Hero
    hero_badge: 'médecins disponibles',
    hero_title_1: 'Trouvez votre médecin en ',
    hero_title_highlight: 'Algérie',
    hero_subtitle: 'Prenez rendez-vous en ligne avec des médecins qualifiés dans les 69 wilayas. Simple, rapide et gratuit.',
    hero_search_btn: 'Rechercher un médecin',
    hero_free: 'Gratuit',
    hero_24h: '24h/24',
    hero_verified: 'Vérifié',
    hero_next_rdv: 'Prise de rendez-vous',
    hero_today: "24h/24 et 7j/7",
    hero_reviews: 'Avis patients',
    hero_excellent: 'Excellent',

    // Téléconsultation - mise en avant page d'accueil
    home_video_badge: 'Nouveau',
    home_video_title: 'Consultez un médecin par vidéo, sans quitter chez vous',
    home_video_desc: "La téléconsultation vous permet d'échanger en direct avec un médecin par appel vidéo sécurisé, quand un déplacement n'est pas nécessaire. Réservez un créneau vidéo en quelques clics.",
    home_video_cta: 'Trouver un médecin en téléconsultation',
    home_video_benefit1_title: 'Gagnez du temps',
    home_video_benefit1_desc: "Pas de trajet ni de salle d'attente : consultez depuis chez vous, à l'heure de votre rendez-vous.",
    home_video_benefit2_title: 'Appel vidéo sécurisé',
    home_video_benefit2_desc: 'La consultation se déroule dans un appel vidéo privé, accessible uniquement à vous et au médecin.',
    home_video_benefit3_title: 'Selon les médecins',
    home_video_benefit3_desc: "La téléconsultation est proposée par les médecins qui l'activent sur leur profil.",

    // Home Search Form
    search_specialty: 'Spécialité',
    search_all_specialties: 'Toutes',
    search_wilaya: 'Wilaya',
    search_all_wilayas: 'Toutes',
    search_doctor_name: 'Nom du médecin',
    search_daira: 'Daïra',
    search_all_dairas: 'Toutes',
    search_btn: 'Rechercher un médecin',

    // Home Stats
    stats_wilayas: 'Wilayas couvertes',
    stats_doctors: 'Médecins inscrits',
    stats_specialties: 'Spécialités',
    stats_available: 'Disponible',

    // Home How it works
    how_title: 'Comment ça marche ?',
    how_subtitle: 'Trois étapes simples pour prendre rendez-vous',
    how_step1_title: 'Recherchez',
    how_step1_desc: 'Trouvez un médecin par spécialité, wilaya ou nom',
    how_step2_title: 'Réservez',
    how_step2_desc: 'Choisissez un créneau disponible et confirmez',
    how_step3_title: 'Consultez',
    how_step3_desc: 'Rendez-vous chez votre médecin le jour J',

    // Home Featured
    featured_title: 'Nos médecins',
    featured_subtitle: 'Les meilleurs praticiens à votre service',
    featured_see_all: 'Voir tous les médecins',

    // Home Doctor CTA
    cta_doctor_title: 'Vous êtes médecin ?',
    cta_doctor_subtitle: 'Rejoignez la plus grande plateforme médicale en Algérie et développez votre cabinet.',
    cta_free: 'Inscription gratuite',
    cta_online: 'Gestion des rendez-vous en ligne',
    cta_visibility: 'Visibilité dans les 69 wilayas',
    cta_teleconsultation: 'Nouveau : proposez la téléconsultation par vidéo à vos patients',
    cta_btn: 'Créer mon profil médecin',

    // Footer
    footer_desc: 'La plateforme de prise de rendez-vous médicaux en Algérie. Simple, rapide et fiable.',
    footer_patients: 'Pour les patients',
    footer_find: 'Trouver un médecin',
    footer_create_account: 'Créer un compte',
    footer_login: 'Se connecter',
    footer_doctors: 'Pour les médecins',
    footer_register: "S'inscrire",
    footer_access: 'Accéder au cabinet',
    footer_contact: 'Contact',
    footer_rights: 'Tous droits réservés',

    // Search Page
    search_page_placeholder: 'Rechercher un médecin...',
    search_page_btn: 'Rechercher',
    search_page_filters: 'Filtres',
    search_page_all_specialties: 'Toutes les spécialités',
    search_page_all_wilayas: 'Toutes les wilayas',
    search_page_daira: 'Daïra',
    search_page_all_dairas: 'Toutes les daïras',
    search_page_online_only: 'En ligne uniquement',
    search_page_video_only: 'Téléconsultation disponible',
    search_page_sort: 'Trier par',
    search_page_relevance: 'Pertinence',
    search_page_best_rating: 'Meilleure note',
    search_page_name_az: 'Nom (A-Z)',
    search_page_clear: 'Effacer les filtres',
    search_page_searching: 'Recherche...',
    search_page_found: 'trouvé',
    search_page_found_plural: 'trouvés',
    search_page_doctor: 'médecin',
    search_page_doctors: 'médecins',
    search_page_no_results: 'Aucun médecin trouvé',
    search_page_try_different: 'Essayez de modifier vos critères de recherche',
    search_page_prev: 'Précédent',
    search_page_next: 'Suivant',
    search_page_online: 'En ligne',

    // Doctor Card
    card_online: 'En ligne',
    card_video_consultation: 'Téléconsultation',
    card_phone: 'Téléphone',
    card_book: 'Prendre rendez-vous',
    card_profile: 'Profil',

    // Login
    login_title: 'Bienvenue',
    login_subtitle: 'Connectez-vous à votre compte',
    login_email: 'Email',
    login_password: 'Mot de passe',
    login_btn: 'Se connecter',
    login_loading: 'Connexion...',
    login_or: 'ou',
    login_google: 'Continuer avec Google',
    login_no_account: 'Pas encore de compte ?',
    login_register: "S'inscrire",
    login_forgot: 'Mot de passe oublié ?',
    login_doctor: 'Vous êtes médecin ? Inscrivez-vous ici',
    login_success: 'Connexion réussie !',
    login_error: "Une erreur s'est produite. Veuillez réessayer.",

    // Register
    register_title: 'Créer un compte',
    register_subtitle: 'Inscrivez-vous pour prendre vos rendez-vous en ligne',
    register_name: 'Nom complet',
    register_name_placeholder: 'Votre nom',
    register_first_name: 'Prénom',
    register_first_name_placeholder: 'Votre prénom',
    register_last_name: 'Nom',
    register_last_name_placeholder: 'Votre nom',
    register_names_identical: 'Le prénom et le nom ne peuvent pas être identiques',
    register_phone_invalid: 'Numéro de téléphone invalide',
    register_email: 'Email',
    register_phone: 'Téléphone',
    register_password: 'Mot de passe',
    register_confirm: 'Confirmer le mot de passe',
    register_btn: "S'inscrire",
    register_loading: 'Inscription...',
    register_or: 'ou',
    register_google: 'Continuer avec Google',
    register_has_account: 'Déjà un compte ?',
    register_login: 'Se connecter',
    register_success: 'Inscription réussie !',
    register_password_mismatch: 'Les mots de passe ne correspondent pas',
    register_password_short: 'Le mot de passe doit contenir au moins 8 caractères',
    register_password_no_uppercase: 'Le mot de passe doit contenir au moins une majuscule',
    register_password_no_lowercase: 'Le mot de passe doit contenir au moins une minuscule',
    register_password_no_digit: 'Le mot de passe doit contenir au moins un chiffre',
    register_password_rules: 'Min. 8 caractères, avec 1 majuscule, 1 minuscule et 1 chiffre',

    // Favorites
    fav_title: 'Mes médecins favoris',
    fav_subtitle: 'Retrouvez facilement vos praticiens préférés',
    fav_login: 'Connectez-vous',
    fav_login_desc: 'Créez un compte pour sauvegarder vos médecins favoris',
    fav_empty: 'Aucun favori',
    fav_empty_desc: 'Ajoutez des médecins en cliquant sur le coeur sur leur profil',
    fav_toggle_error: "Une erreur est survenue, réessayez.",

    // About
    about_badge: 'Notre histoire',
    about_title_1: 'Rendre la santé accessible à ',
    about_title_highlight: 'tous les Algériens',
    about_subtitle: "Tabbibak.dz est né d'un constat simple : trouver un bon médecin en Algérie ne devrait pas être un parcours du combattant. Notre mission est de connecter chaque patient avec le bon praticien, dans sa wilaya, en quelques clics.",
    about_search_btn: 'Trouver un médecin',
    about_doctor_btn: 'Rejoindre comme médecin',
    about_mission_title: 'Notre Mission',
    about_mission_desc: "Démocratiser l'accès aux soins de santé en Algérie en offrant une plateforme moderne et gratuite qui permet à chaque citoyen de trouver, évaluer et prendre rendez-vous avec un médecin qualifié, peu importe sa wilaya.",
    about_vision_title: 'Notre Vision',
    about_vision_desc: "Devenir la référence de la santé numérique en Algérie d'ici 2030. Un pays où chaque patient peut accéder à des soins de qualité en quelques minutes, et chaque médecin dispose d'outils modernes pour gérer son cabinet.",
    about_values_title: 'Nos valeurs',
    about_values_subtitle: 'Ce qui nous guide au quotidien',
    about_val1_title: 'Bienveillance',
    about_val1_desc: 'Chaque patient mérite attention et respect dans son parcours de soin.',
    about_val2_title: 'Confiance',
    about_val2_desc: 'Médecins vérifiés, avis authentiques, données protégées.',
    about_val3_title: 'Proximité',
    about_val3_desc: "Un réseau de médecins dans les 69 wilayas d'Algérie.",
    about_val4_title: 'Simplicité',
    about_val4_desc: 'Trouvez et réservez en moins de 2 minutes, sans appel téléphonique.',
    about_stats_wilayas: 'Wilayas couvertes',
    about_stats_specialties: 'Spécialités médicales',
    about_stats_free: 'Gratuit pour les patients',
    about_stats_online: 'Disponible en ligne',
    about_faq_title: 'Questions fréquentes',
    about_faq1_q: 'Est-ce que Tabbibak.dz est gratuit ?',
    about_faq1_a: "Oui, la plateforme est entièrement gratuite pour les patients. Les médecins bénéficient aussi d'une inscription gratuite.",
    about_faq2_q: 'Comment sont vérifiés les médecins ?',
    about_faq2_a: 'Chaque médecin inscrit passe par un processus de vérification par notre équipe. Nous vérifions le numéro de licence et les qualifications.',
    about_faq3_q: 'Puis-je annuler un rendez-vous ?',
    about_faq3_a: 'Oui, vous pouvez annuler ou reprogrammer un rendez-vous à tout moment depuis votre tableau de bord.',
    about_faq4_q: 'Quelles wilayas sont couvertes ?',
    about_faq4_a: "Tabbibak.dz couvre les 69 wilayas d'Algérie. Nous ajoutons de nouveaux médecins chaque semaine.",
    about_cta_title: 'Prêt à trouver votre médecin ?',
    about_cta_subtitle: "Rejoignez des milliers d'Algériens qui utilisent Tabbibak.dz pour prendre soin de leur santé.",
    about_cta_search: 'Rechercher un médecin',
    about_cta_register: 'Créer un compte gratuit',
    about_footer_desc: 'La plateforme de prise de rendez-vous médicaux en Algérie.',

    // Admin Dashboard
    admin_title: "Panneau d'administration",
    admin_subtitle: 'Gérez les médecins et utilisateurs',
    admin_add_doctor: 'Ajouter un médecin',
    admin_patients: 'Patients',
    admin_registered: 'Médecins inscrits',
    admin_listed: 'Médecins listés',
    admin_pending: 'En attente',
    admin_tab_pending: 'En attente',
    admin_tab_doctors: 'Tous les médecins',
    admin_tab_users: 'Utilisateurs',
    admin_tab_patient_users: 'Patients',
    admin_tab_doctor_users: 'Médecins',
    admin_no_patient_users: 'Aucun patient inscrit',
    admin_no_doctor_users: 'Aucun médecin inscrit',
    admin_tab_analytics: 'Analytique',
    admin_no_pending: 'Aucune demande en attente',
    admin_doctor: 'Médecin',
    admin_specialty: 'Spécialité',
    admin_wilaya: 'Wilaya',
    admin_license: 'Licence',
    admin_actions: 'Actions',
    admin_type: 'Type',
    admin_status: 'Statut',
    admin_user: 'Utilisateur',
    admin_email: 'Email',
    admin_phone: 'Téléphone',
    admin_role: 'Rôle',
    admin_online: 'En ligne',
    admin_phone_type: 'Téléphone',
    admin_approved: 'Approuvé',
    admin_pending_status: 'En attente',
    admin_listed_status: 'Listé',
    admin_rejected: 'Rejeté',
    admin_confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce médecin ?',
    // Masquage d'une fiche (ajout 20/09/2026) : alternative non destructive a
    // la suppression, quand un praticien conteste une fiche importee.
    admin_hide_doctor: 'Masquer cette fiche du site',
    admin_unhide_doctor: 'Réafficher cette fiche sur le site',
    admin_confirm_hide: "Masquer cette fiche ? Elle disparaîtra du site (recherche, listes, lien direct, prise de rendez-vous) mais sera conservée en base avec son origine. Vous pourrez la réafficher à tout moment.",
    admin_confirm_unhide: 'Réafficher cette fiche sur le site ?',
    admin_add_title: "Ajouter un médecin à l'annuaire",
    admin_add_desc: 'Ce médecin sera visible avec son numéro de téléphone uniquement',
    admin_name: 'Nom complet',
    admin_address: 'Adresse',
    admin_fees: 'Honoraires (DZD, optionnel)',
    admin_cancel: 'Annuler',
    admin_submit: 'Ajouter',
    admin_submitting: 'Ajout...',
    admin_chart_specialty: 'Médecins par spécialité',
    admin_chart_appointments: 'Rendez-vous',
    admin_chart_overview: 'Vue d\'ensemble',
    admin_total_appointments: 'Total RDV',

    // Patient Dashboard
    patient_hello: 'Bonjour,',
    patient_subtitle: 'Gérez vos rendez-vous médicaux',
    patient_need_apt: 'Besoin d\'un rendez-vous ?',
    patient_find_doc: 'Trouvez un médecin et réservez en ligne',
    patient_find_btn: 'Trouver un médecin',
    patient_upcoming: 'À venir',
    patient_history: 'Historique',
    patient_cancelled: 'Annulés',
    // Idee CGM/ClickDoc : espace "Ordonnances" (routes/prescriptions.py).
    patient_prescriptions: 'Ordonnances',
    patient_no_prescriptions: 'Aucune ordonnance pour le moment',
    patient_no_prescriptions_desc: 'Les ordonnances transmises par vos médecins apparaîtront ici.',
    patient_prescription_view_btn: 'Voir / Télécharger',
    pdash_prescription_err_open: "Erreur lors de l'ouverture de l'ordonnance",
    patient_confirmed: 'Confirmé',
    patient_pending: 'En attente',
    patient_cancelled_status: 'Annulé',
    patient_completed: 'Terminé',
    patient_past_unresolved: 'Rendez-vous passé',
    patient_no_show: 'Non honoré',
    patient_reason: 'Motif',
    patient_reschedule: 'Reprogrammer',
    patient_cancel: 'Annuler',
    patient_no_upcoming: 'Aucun rendez-vous à venir',
    patient_no_upcoming_desc: 'Recherchez un médecin pour prendre rendez-vous',
    patient_no_history: 'Aucun historique',
    patient_no_cancelled: 'Aucun rendez-vous annulé',
    patient_cancel_title: 'Annuler le rendez-vous',
    patient_cancel_desc: 'Êtes-vous sûr de vouloir annuler ce rendez-vous ? Cette action est irréversible.',
    patient_keep: 'Non, garder',
    patient_yes_cancel: 'Oui, annuler',
    patient_cancelling: 'Annulation...',
    patient_reschedule_title: 'Reprogrammer le rendez-vous',
    patient_reschedule_desc: 'Choisissez une nouvelle date et heure',
    patient_available_slots: 'Créneaux disponibles',
    patient_select_date: 'Sélectionnez une date',
    patient_no_slots: 'Aucun créneau disponible',
    patient_confirm: 'Confirmer',
    patient_rescheduling: 'Reprogrammation...',

    // Patient Dashboard - notifications, salle d'attente, avis
    pdash_your_turn: "C'est votre tour, veuillez vous présenter au cabinet.",
    pdash_doctor_calling_toast: '📢 Le médecin vous appelle !',
    pdash_doctor_calling_alert: 'Le médecin vous appelle !',
    pdash_new_apt_toast: '📅 Nouveau rendez-vous !',
    pdash_apt_moved_toast: '🔄 Rendez-vous déplacé',
    pdash_apt_cancelled_toast: '❌ Rendez-vous annulé',
    pdash_apt_confirmed_toast: '✅ Rendez-vous confirmé',
    pdash_presence_signaled_toast: '✅ Votre présence a été signalée au médecin !',
    pdash_signal_error: 'Erreur lors du signalement',
    pdash_review_comment_required: 'Veuillez écrire un commentaire',
    pdash_review_published_toast: '✅ Votre avis a été publié !',
    pdash_review_publish_error: 'Erreur lors de la publication',
    pdash_apt_scheduled_by_doctor: 'Rendez-vous programmé par votre médecin',
    pdash_apt_rescheduled_by_doctor: 'Rendez-vous déplacé par votre médecin',
    pdash_waiting_room_prompt: "🏥 Vous êtes en salle d'attente ? Signalez votre présence au médecin.",
    pdash_presence_signaled_confirm: '✅ Votre présence a été signalée — Le médecin a été notifié',
    pdash_im_in_waiting_room: "Je suis en salle d'attente",
    pdash_checkin_too_late: 'Le délai pour signaler votre présence est dépassé (plus de 30 minutes de retard). Contactez directement le cabinet.',
    pdash_checkin_available_prefix: 'Vous pourrez signaler votre présence à partir de 30 minutes avant votre rendez-vous',
    // Salle d'attente VIRTUELLE (teleconsultation, demande Nadjib 20/09/2026) :
    // le patient n'est pas au cabinet, "signalez votre presence en salle
    // d'attente" n'a aucun sens pour lui — mais le medecin a quand meme besoin
    // de savoir que son patient est la et pret (sa salle d'attente n'affiche
    // que les patients qui se sont signales, voir routes/waiting_room.py).
    pdash_video_waiting_room_prompt: '📹 Prêt pour votre téléconsultation ? Signalez-vous au médecin.',
    pdash_video_presence_signaled_confirm: "✅ Vous êtes dans la salle d'attente virtuelle — Le médecin a été notifié",
    pdash_im_ready_video: 'Je suis prêt pour ma téléconsultation',
    pdash_video_checkin_too_late: 'Le délai pour vous signaler est dépassé (plus de 30 minutes de retard). Contactez directement le cabinet.',
    pdash_video_checkin_available_prefix: 'Vous pourrez vous signaler à partir de 30 minutes avant votre téléconsultation',
    pdash_cancel_reschedule_closed: 'Annulation et reprogrammation ne sont plus possibles à moins de 24h du rendez-vous. Contactez directement le cabinet.',
    pdash_this_doctor: 'ce médecin',
    pdash_leave_review: 'Laisser un avis',
    // Correctif (idee CGM/ClickDoc) : informations pre-consultation renseignees par le patient
    pdash_pre_visit_button: 'Compléter mes informations avant la consultation',
    pdash_pre_visit_button_done: 'Modifier mes informations avant la consultation',
    pdash_pre_visit_filled_badge: '✅ Informations transmises au médecin',
    pdash_pre_visit_title: 'Informations avant la consultation',
    pdash_pre_visit_desc: 'Ces informations seront visibles par le médecin avant votre rendez-vous, pour gagner du temps.',
    pdash_pre_visit_allergies_label: 'Allergies connues',
    pdash_pre_visit_allergies_placeholder: 'Ex : pénicilline, arachides... (laissez vide si aucune)',
    pdash_pre_visit_medications_label: 'Traitements en cours',
    pdash_pre_visit_medications_placeholder: 'Médicaments que vous prenez actuellement',
    pdash_pre_visit_notes_label: 'Informations complémentaires',
    pdash_pre_visit_notes_placeholder: 'Toute autre information utile pour le médecin',
    pdash_pre_visit_save: 'Enregistrer',
    pdash_pre_visit_saving: 'Enregistrement...',
    pdash_pre_visit_saved_toast: 'Informations enregistrées',
    pdash_pre_visit_save_error: "Erreur lors de l'enregistrement",
    // Idee CGM/ClickDoc : teleconsultation (Daily.co) - bouton "Rejoindre" et
    // salle video integree, cote patient.
    pdash_join_video_btn: 'Rejoindre la consultation vidéo',
    pdash_join_video_too_early: 'Disponible à partir de {time}',
    pdash_video_dialog_title: 'Consultation vidéo',
    pdash_video_join_error: "Impossible de rejoindre la consultation vidéo, veuillez réessayer.",
    // Correctif (v2, cases a cocher) : sections et libelles "autre" du formulaire
    pdash_pre_visit_context_label: 'Motif de la visite',
    pdash_pre_visit_other_label: 'Autre / précisions',
    pdash_pre_visit_allergies_other_placeholder: 'Autre allergie non listée...',
    pdash_pre_visit_medications_other_placeholder: 'Autre traitement non listé...',
    pdash_pre_visit_context_other_placeholder: 'Autre précision utile pour le médecin...',
    // Correctif (v2) : options a cocher — allergies
    pv_allergy_penicillin: 'Pénicilline / antibiotiques',
    pv_allergy_aspirin_nsaid: 'Aspirine / anti-inflammatoires',
    pv_allergy_latex: 'Latex',
    pv_allergy_iodine: 'Iode / produits de contraste',
    pv_allergy_nuts: 'Arachides / fruits à coque',
    pv_allergy_sulfa: 'Sulfamides',
    pv_allergy_anesthesia: 'Anesthésiques locaux',
    pv_allergy_insects: "Piqûres d'insectes",
    pv_allergy_none: 'Aucune allergie connue',
    // Correctif (v2) : options a cocher — traitements en cours
    pv_med_anticoagulants: 'Anticoagulants / antiagrégants',
    pv_med_antidiabetics: 'Antidiabétiques (dont insuline)',
    pv_med_antihypertensives: 'Anti-hypertenseurs (tension)',
    pv_med_corticosteroids: 'Corticoïdes',
    pv_med_anticonvulsants: 'Anticonvulsivants',
    pv_med_heart: 'Traitement cardiaque',
    pv_med_psychiatric: 'Traitement psychiatrique / anxiolytiques',
    pv_med_contraception: 'Contraception hormonale',
    pv_med_none: 'Aucun traitement en cours',
    // Correctif (v2) : options a cocher — motif de la visite
    pv_ctx_first_visit: 'Première consultation avec ce médecin',
    pv_ctx_followup: 'Suivi habituel',
    pv_ctx_pregnant: 'Grossesse en cours',
    pv_ctx_exam_results: "Vient avec des résultats d'examens (radios, analyses...)",
    pv_ctx_certificate: "Besoin d'un certificat médical",
    pv_ctx_urgent: 'Douleur importante / urgence',
    pv_ctx_renewal: "Renouvellement d'ordonnance uniquement",
    pdash_notifications: 'Notifications',
    pdash_no_notifications: 'Aucune notification',
    pdash_notification_singular: 'Notification',
    pdash_review_about: 'Votre avis sur Dr.',
    pdash_rating_label: 'Note',
    pdash_comment_label: 'Commentaire',
    pdash_describe_experience: 'Décrivez votre expérience...',
    pdash_publishing: 'Publication...',
    pdash_publish: 'Publier',

    // Doctor Dashboard
    doc_title: 'Tableau de bord',
    doc_subtitle: 'Gérez vos rendez-vous et disponibilités',
    doc_pending_approval: "En attente d'approbation",
    doc_active: 'Profil actif',
    doc_today: "RDV aujourd'hui",
    doc_total: 'Total RDV',
    doc_pending_count: 'En attente',
    doc_tab_appointments: 'Rendez-vous',
    doc_tab_schedule: 'Horaires',
    doc_tab_profile: 'Mon profil',
    doc_upcoming: 'Rendez-vous à venir',
    doc_no_upcoming: 'Aucun rendez-vous à venir',
    doc_edit: 'Modifier',
    doc_save: 'Enregistrer',
    doc_saving: 'Enregistrement...',
    doc_cancel: 'Annuler',
    doc_availability: 'Mes disponibilités',
    doc_my_profile: 'Mon profil',
    doc_photo_url: 'URL de la photo',
    doc_phone: 'Téléphone',
    doc_fees: 'Honoraires (DZD)',
    doc_address: 'Adresse',
    doc_education: 'Formation',
    doc_bio: 'Présentation / Bio',
    doc_languages: 'Langues parlées',
    doc_insurance: 'Assurances acceptées',
    doc_add_language: 'Ajouter une langue',
    doc_add_insurance: 'Ajouter une assurance',
    doc_complete_profile: 'Complétez votre profil pour attirer plus de patients',
    doc_add_info: 'Ajouter bio, formation, langues...',
    doc_license: 'N° Licence',
    doc_rating: 'avis',
    doc_status_title: 'Modifier le statut',
    doc_status_desc: 'Changez le statut du rendez-vous avec',
    doc_confirmed: 'Confirmé',
    doc_completed: 'Terminé',
    // Teleconsultation (paiement manuel BaridiMob/CCP) : badge distinct d'un
    // "en attente" ordinaire, pour rappeler au medecin qu'il doit verifier
    // le virement avant de confirmer - voir payment_expiry.py.
    doc_payment_pending_badge: '💳 En attente de paiement',
    doc_payment_reference_label: 'Référence virement',
    doc_cancelled: 'Annulé',

    // Doctor Dashboard — full i18n catch-up pass
    doc_notifications_title: 'Notifications',
    doc_mark_all_read: 'Tout marquer lu',
    doc_no_notification: 'Aucune notification',
    doc_day_word: 'jour',
    doc_days_word: 'jours',
    doc_remaining_word: 'restant',
    doc_remaining_days_word: 'restants',
    doc_trial_urgent_prefix: '⚠️ Essai gratuit — Plus que',
    doc_trial_active_prefix: "✅ Période d'essai gratuite —",
    doc_trial_price_notice: "Après l'essai, abonnez-vous à 2 500 DA/mois pour continuer à recevoir des rendez-vous en ligne.",
    doc_subscribe_btn: "S'abonner",
    doc_sub_active_prefix: '✅ Abonnement actif —',
    doc_sub_expired_title: '🔴 Abonnement expiré — Rendez-vous en ligne désactivés',
    doc_sub_expired_subtitle: 'Votre profil reste visible mais les patients ne peuvent plus réserver en ligne.',
    doc_renew_btn: 'Renouveler',
    doc_revenue_7d_title: 'Revenus - 7 derniers jours',
    doc_revenue_total_7d: 'Total 7 jours',
    doc_revenue_avg_day: 'Moyenne/jour',
    doc_revenue_best_day: 'Meilleur jour',
    doc_this_month: 'Ce mois',
    doc_stats_completed: '✓ Complétées',
    doc_stats_confirmed: '⏳ Confirmées',
    doc_stats_cancelled: '✕ Annulées',
    doc_revenue_label: 'Revenus',
    doc_stats_monthly_revenue_title: 'Revenus — 6 derniers mois',
    doc_stats_patient_mix_title: 'Répartition des patients',
    doc_stats_new_patients: 'Nouveaux patients',
    doc_stats_returning_patients: 'Patients récurrents',
    doc_stats_attendance_title: 'Taux de présence — 6 derniers mois',
    doc_stats_attendance_rate: 'Taux de présence',
    doc_stats_no_data: 'Pas encore assez de données pour ce graphique',
    doc_calendar_today_btn: "Aujourd'hui",
    doc_total_this_month: 'Total ce mois',
    doc_per_consultation: 'Par consultation',
    doc_completion_rate: 'Taux complétude',
    doc_sub_info_unavailable: "Informations d'abonnement non disponibles",
    doc_sub_status_trial: "Période d'essai",
    doc_sub_status_active: 'Actif',
    doc_sub_status_expired: 'Expiré',
    doc_my_subscription: 'Mon abonnement',
    doc_trial_end_label: "Fin de l'essai",
    doc_subscribed_until_label: "Abonné jusqu'au",
    doc_monthly_price_label: 'Tarif mensuel',
    doc_da_per_month: 'DA / mois',
    doc_choose_payment_method: 'Choisir un mode de paiement',
    doc_price_no_commitment: '2 500 DA / mois — Sans engagement',
    doc_card_cib: 'Carte CIB',
    doc_secure_online_payment: 'Paiement sécurisé en ligne',
    doc_via_chargily: 'Via Chargily Pay',
    doc_pay_by_cib: 'Payer par CIB',
    doc_payment_via_app: 'Paiement via application',
    doc_pay_by_baridimob: 'Payer par BaridiMob',
    doc_bank_transfer: 'Virement bancaire',
    doc_activation_24h: 'Activation sous 24h',
    doc_bank_label: 'Banque :',
    doc_holder_label: 'Titulaire :',
    doc_rib_label: 'RIB :',
    doc_amount_label: 'Montant :',
    doc_reason_label: 'Motif :',
    doc_motif_value: 'Abonnement + votre email',
    doc_send_receipt_to: 'Envoyez le reçu à',
    doc_whats_included: '✅ Ce qui est inclus',
    doc_incl_online_booking: '✅ Réservation en ligne par les patients',
    doc_incl_full_dashboard: '✅ Tableau de bord médecin complet',
    doc_incl_appointment_mgmt: '✅ Gestion des rendez-vous et agenda',
    doc_incl_stats_revenue: '✅ Statistiques et revenus',
    doc_incl_visible_profile: '✅ Profil visible sur Tabbibak.dz',
    doc_incl_priority_support: '✅ Support technique prioritaire',
    doc_rescheduled_by_doctor: '🔄 Déplacé par le médecin',
    doc_no_show_badge: '⚠ Non honoré',
    // Correctif (idee CGM/ClickDoc) : infos pre-consultation renseignees par le patient, visibles au medecin
    doc_pre_visit_allergies: 'Allergies',
    doc_pre_visit_medications: 'Traitements en cours',
    doc_reschedule_btn: 'Déplacer',
    doc_name_required: 'Le nom est obligatoire',
    doc_patient_added: 'Patient ajouté',
    doc_err_add_patient: "Erreur lors de l'ajout du patient",
    doc_err_load_record: 'Erreur lors du chargement du dossier patient',
    doc_patient_called: 'Patient appelé',
    doc_error_generic: 'Erreur',
    doc_consultation_done: 'Consultation terminée',
    doc_record_updated: 'Dossier mis à jour',
    doc_err_save: 'Erreur lors de la sauvegarde',
    doc_note_added: 'Note ajoutée',
    doc_note_deleted: 'Note supprimée',
    doc_type_value_required: 'Type et valeur requis',
    doc_measurement_added: 'Mesure ajoutée',
    doc_err_add_measurement: "Erreur lors de l'ajout de la mesure",
    doc_measurement_deleted: 'Mesure supprimée',
    doc_choose_date_time: 'Veuillez choisir une date et un horaire',
    doc_appointment_booked: '✅ Rendez-vous programmé — Le patient a été notifié par email',
    doc_err_booking: 'Erreur lors de la programmation',
    doc_patient_removed: 'Patient retiré de votre liste',
    doc_err_delete: 'Erreur lors de la suppression',
    doc_add_at_least_one_med: 'Ajoutez au moins un medicament',
    doc_dosage_freq_required: 'Dosage et frequence sont obligatoires pour chaque medicament',
    doc_err_generate_cert: "Impossible de generer le certificat d'ordonnance",
    doc_prescription_ready: 'Ordonnance prete a imprimer !',
    doc_subject_message_required: 'Sujet et message requis',
    doc_recipient_required: 'Destinataire requis',
    doc_message_sent: '✅ Message envoyé avec succès !',
    doc_err_send_message: 'Erreur envoi message',
    doc_file_too_large: 'Fichier trop volumineux (max 10MB)',
    doc_file_added_prefix: '✅ Fichier',
    doc_file_added_suffix: 'ajouté',
    doc_confirm_delete_message: 'Supprimer ce message ?',
    doc_message_deleted: 'Message supprimé',
    doc_err_deletion: 'Erreur suppression',
    doc_use_bank_transfer_notice: 'Utilisez le virement bancaire ou contactez-nous pour vous abonner',
    doc_appointment_rescheduled: 'Rendez-vous déplacé — Le patient a été notifié par email',
    doc_err_reschedule: 'Erreur lors du déplacement',
    doc_patient_fallback: 'Patient',
    doc_at_time: 'à',
    doc_schedule_warning_prefix: 'Attention :',
    doc_schedule_warning_mid: 'rendez-vous déjà confirmé(s) tombent sur un créneau que vous venez de fermer :',
    doc_schedule_warning_suffix: 'Ces rendez-vous ne seront PAS annulés automatiquement — pensez à contacter ces patients si besoin. Continuer ?',
    doc_metric_confirmed: 'Confirmés',
    doc_metric_revenue_month: 'Revenus mois',
    doc_metric_total_patients: 'Total patients',
    doc_metric_avg_rating: 'Note moyenne',
    doc_account_pending_notice: "Votre compte est en attente de validation par notre équipe. Complétez votre profil ci-dessous pour accélérer la validation — les rendez-vous, la salle d'attente, les patients, les statistiques et la messagerie seront disponibles une fois votre compte approuvé.",
    doc_tab_waiting_room: "🏥 Salle d'attente",
    doc_tab_patients: '👥 Patients',
    doc_tab_analytics: '📊 Statistiques',
    doc_tab_messages: 'Messages',
    doc_tab_subscription: 'Abonnement',
    doc_waiting_room_title: "🏥 Salle d'attente — Aujourd'hui",
    doc_refresh_btn: 'Actualiser',
    doc_no_patient_waiting: "Aucun patient en salle d'attente",
    doc_patients_signal_arrival: 'Les patients signalent leur arrivée depuis leur espace',
    // Salle d'attente : un patient en teleconsultation s'y signale aussi
    // (il est chez lui, pas au cabinet) - le badge evite au medecin de le
    // chercher dans son couloir.
    doc_waiting_video_badge: 'Téléconsultation',
    doc_appointment_abbr: 'RDV',
    doc_in_consultation: '🟢 En consultation',
    doc_arrived_prefix: 'Arrivé à',
    doc_call_patient_btn: '📢 Appeler',
    doc_finish_btn: '✅ Terminer',
    doc_my_patients_prefix: '👥 Mes patients',
    doc_add_btn: 'Ajouter',
    doc_no_patient_seen: 'Aucun patient consulté',
    doc_last_visit_label: 'Dernière :',
    doc_visit_word: 'visite',
    doc_visits_word: 'visites',
    doc_offplatform_paren: '(hors plateforme)',
    doc_offplatform_badge: 'Hors plateforme',
    doc_select_patient_notice: 'Sélectionnez un patient pour voir son dossier',
    doc_loading: 'Chargement...',
    doc_book_appointment_btn: 'Programmer RDV',
    doc_delete_btn: 'Supprimer',
    doc_prescription_btn: 'Ordonnance',
    doc_medical_record_title: '📋 Dossier médical',
    doc_blood_type_label: 'Groupe sanguin',
    doc_choose_placeholder: 'Choisir',
    doc_not_specified: 'Non renseigné',
    doc_allergies_label: '⚠️ Allergies',
    doc_add_placeholder: 'Ajouter...',
    doc_antecedents_label: '📌 Antécédents',
    doc_chronic_conditions_label: '🏥 Maladies chroniques',
    doc_measurements_title: '📈 Mesures',
    doc_type_label: 'Type',
    doc_choose_type_placeholder: 'Choisir un type',
    doc_suggested_specialty: 'Suggéré pour votre spécialité',
    doc_other_custom_measurement: 'Autre (mesure personnalisée)...',
    doc_measurement_name_label: 'Nom de la mesure',
    doc_ex_saturation_placeholder: 'Ex : Saturation',
    doc_systolic_label: 'Systolique',
    doc_diastolic_label: 'Diastolique',
    doc_pain_label: 'Douleur :',
    doc_value_label: 'Valeur',
    doc_ex_prefix: 'Ex :',
    doc_unit_label: 'Unité',
    doc_ex_kg_placeholder: 'Ex : kg',
    doc_date_label: 'Date',
    doc_bmi_label: 'IMC :',
    doc_calculated_auto: '(calculé automatiquement)',
    doc_bmi_source_prefix: 'À partir du poids',
    doc_bmi_source_mid: 'et de la taille',
    doc_no_measurement: 'Aucune mesure enregistrée',
    doc_consultation_notes_title: '📝 Notes de consultation',
    doc_add_note_placeholder: 'Ajouter une note...',
    doc_no_note: 'Aucune note',
    doc_visit_history_title: '📅 Historique des visites',
    doc_badge_completed: '✓ Complété',
    doc_badge_cancelled: '✕ Annulé',
    doc_badge_confirmed: '✓ Confirmé',
    doc_badge_pending: '⏳ En attente',
    doc_no_show_appointment_singular: 'rendez-vous non honoré',
    doc_no_show_appointments_plural: 'rendez-vous non honorés',
    doc_patient_already_prefix: '⚠ Ce patient a déjà',
    doc_absence_no_cancel_suffix: '(absence sans annulation).',
    doc_consultation_duration_label: 'Durée consultation estimée',
    doc_consultation_duration_hint: "Sert au calcul de l'heure de fin estimée et à la durée de la salle de vidéoconsultation — ne modifie pas l'espacement des créneaux ci-dessous (fixé à 30 min).",
    doc_15min: '15 minutes',
    doc_30min: '30 minutes',
    doc_45min: '45 minutes',
    doc_1hour: '1 heure',
    doc_slots_word: 'créneaux',
    doc_slot_type_in_person: 'Cabinet uniquement',
    doc_slot_type_in_person_short: 'Cabinet',
    doc_slot_type_video: 'Vidéo uniquement',
    doc_slot_type_video_short: 'Vidéo',
    doc_slot_type_both: 'Cabinet et vidéo',
    doc_slot_type_both_short: 'Les deux',
    doc_inbox_tab: 'Reçus',
    doc_sent_tab: 'Envoyés',
    doc_new_message_btn: 'Nouveau message',
    doc_new_medical_message_title: '✉️ Nouveau message médical',
    doc_use_template_label: 'Utiliser un modèle',
    doc_choose_template_option: '-- Choisir un modèle --',
    doc_cat_references: 'Références',
    doc_cat_analysis_results: "Résultats d'analyse",
    doc_cat_imaging_results: 'Résultats imagerie',
    doc_cat_medical_opinion: 'Avis médical',
    doc_cat_patient_followup: 'Suivi patient',
    doc_cat_urgent: 'Urgences',
    doc_cat_general: 'Général',
    doc_doctor_on_platform_label: 'Médecin sur Tabbibak',
    doc_search_dr_placeholder: 'Rechercher Dr...',
    doc_external_email_label: 'Ou email externe',
    doc_patient_name_label: 'Nom du patient',
    doc_optional_placeholder: 'Optionnel',
    doc_age_label: 'Âge',
    doc_priority_label: 'Priorité',
    doc_priority_normal: '🟢 Normal',
    doc_priority_urgent: '🔴 Urgent',
    doc_subject_label: 'Sujet *',
    doc_subject_placeholder: 'Objet du message',
    doc_message_label: 'Message *',
    doc_write_message_placeholder: 'Rédigez votre message...',
    doc_add_attachment: 'Ajouter une pièce jointe',
    doc_attachment_hint: 'PDF, Image — max 10MB',
    doc_sending: 'Envoi...',
    doc_send_btn: 'Envoyer',
    doc_no_message_received: 'Aucun message reçu',
    doc_no_message_sent: 'Aucun message envoyé',
    doc_from_label: 'De:',
    doc_to_label: 'À:',
    doc_patient_label: 'Patient:',
    doc_years_word: 'ans',
    doc_urgent_badge: '🚨 URGENT',
    doc_patient_emoji_label: '👤 Patient:',
    doc_close_btn: 'Fermer',
    doc_reply_btn: '↩ Répondre',
    doc_original_message_prefix: 'Message original de Dr.',
    doc_dialog_patient_label: 'Patient :',
    doc_reschedule_dialog_title: 'Déplacer le rendez-vous',
    doc_currently_on: 'Actuellement le',
    doc_new_date_label: 'Nouvelle date',
    doc_new_time_label: 'Nouvel horaire',
    doc_choose_time_placeholder: 'Choisir un horaire',
    doc_no_slot_available: 'Aucun créneau disponible ce jour-là (planning fermé ou déjà complet).',
    doc_reschedule_reason_label: 'Motif du déplacement (optionnel)',
    doc_reschedule_reason_placeholder: 'Ex: Urgence médicale, indisponibilité...',
    doc_email_notification_notice: '📧 Le patient recevra un email de notification avec les nouvelles informations.',
    doc_moving: 'Déplacement...',
    doc_confirm_reschedule_btn: 'Confirmer le déplacement',
    doc_manual_patient_title: 'Ajouter un patient',
    doc_manual_patient_desc: 'Ce patient ne sera pas inscrit sur Tabbibak, mais vous pourrez suivre son dossier medical et lui creer des ordonnances.',
    doc_full_name_label: 'Nom complet *',
    doc_ex_name_placeholder: 'Ex: Ahmed Benali',
    doc_ex_phone_placeholder: 'Ex: 0555 12 34 56',
    doc_email_label_full: 'Email (optionnel, pour les notifications de rendez-vous)',
    doc_ex_email_placeholder: 'Ex: ahmed.benali@email.com',
    doc_dob_label: 'Date de naissance (optionnel)',
    doc_adding: 'Ajout...',
    doc_add_patient_btn: 'Ajouter le patient',
    doc_book_appointment_title: 'Programmer un rendez-vous',
    doc_time_label: 'Horaire',
    doc_book_consultation_type_label: 'Type de consultation',
    doc_book_type_in_person: 'Au cabinet',
    doc_book_type_video: 'Vidéo (téléconsultation)',
    doc_book_video_notice: '📹 Une salle de visioconsultation sera créée automatiquement. Le lien pour rejoindre sera envoyé au patient et disponible depuis son tableau de bord.',
    doc_reason_optional_label: 'Motif (optionnel)',
    doc_book_reason_placeholder: 'Ex: Consultation de suivi, renouvellement ordonnance...',
    doc_confirmation_email_notice: '📧 Le patient recevra un email de confirmation.',
    doc_booking_in_progress: 'Programmation...',
    doc_confirm_appointment_btn: 'Confirmer le RDV',
    doc_delete_patient_title: 'Supprimer ce patient',
    doc_delete_patient_confirm_prefix: 'Êtes-vous sûr de vouloir retirer',
    doc_delete_patient_confirm_suffix: 'de votre liste de patients ?',
    doc_delete_patient_confirm_detail: "Son dossier médical et ses notes seront supprimés. Ses rendez-vous passés resteront dans l'historique.",
    doc_deleting: 'Suppression...',
    doc_yes_delete: 'Oui, supprimer',
    doc_create_prescription_title: 'Créer une ordonnance',
    doc_diagnostic_label: 'Diagnostic (optionnel)',
    doc_diagnostic_placeholder: 'Ex: Rhinopharyngite, Hypertension...',
    doc_medications_label: 'Medicaments',
    doc_medication_word: 'Medicament',
    doc_med_name_placeholder: 'Nom du medicament *',
    doc_med_dosage_placeholder: 'Dosage (ex: 500mg) *',
    doc_med_frequency_placeholder: 'Fréquence (ex: 3x/jour) *',
    doc_med_duration_placeholder: 'Duree (ex: 7 jours)',
    // Verification de doublons dans l'ordonnance (voir DoctorDashboard.js,
    // utils/medicationDuplicates.js) — meme logique a deux niveaux que le
    // vérificateur public (drugdup_and est reutilisee depuis ces clés-là).
    doc_rx_dup_mid: ' sont en réalité le même médicament (même substance, dosage et forme) — vérifiez avant de valider cette ordonnance.',
    doc_rx_samesubstance_mid: ' contiennent tous ',
    doc_rx_samesubstance_post: ', à des dosages ou formes différents dans cette ordonnance. Vérifiez la dose totale prescrite avant de valider.',
    doc_recommendations_label: 'Recommandations (optionnel)',
    doc_recommendations_placeholder: "Ex: Repos, boire beaucoup d'eau...",
    doc_prescription_open_notice: "L'ordonnance s'ouvrira dans un nouvel onglet prete a imprimer ou telecharger en PDF.",
    // Idee CGM/ClickDoc : copie privee versee dans l'espace du patient au
    // moment de l'impression (routes/prescriptions.py).
    doc_prescription_saved_notice: 'Cette ordonnance sera aussi ajoutee automatiquement a l\'espace de ce patient sur Tabbibak.',
    doc_prescription_not_saved_notice: 'Patient hors plateforme : cette ordonnance sera imprimee mais ne peut pas etre ajoutee a un espace patient.',
    doc_prescription_saved_toast: 'Ordonnance imprimee et ajoutee a l\'espace du patient.',
    doc_print_download_btn: 'Imprimer / Telecharger PDF',
    doc_sse_new_appointment: '📅 Nouveau rendez-vous !',
    doc_sse_patient_arrived: '🟢 Patient arrivé !',

    // Idee CGM/ClickDoc : teleconsultation (Daily.co) — reglage du medecin
    // (proposer la video) et bouton "Rejoindre" sur un RDV video.
    doc_video_consultation_label: 'Proposer la téléconsultation vidéo',
    doc_video_consultation_desc: "Vos patients pourront choisir un rendez-vous vidéo en plus du cabinet.",
    doc_video_consultation_active: 'Téléconsultation vidéo activée',
    doc_video_payment_ccp_label: 'Numéro CCP / BaridiMob',
    doc_video_payment_ccp_placeholder: 'Ex : 1234567 clé 89',
    doc_video_payment_ccp_desc: "Affiché au patient pour régler sa téléconsultation par virement, en attendant le paiement en ligne.",
    doc_video_payment_ccp_none: "Aucun numéro CCP/BaridiMob renseigné — ajoutez-en un pour que vos patients puissent payer leurs téléconsultations.",
    doc_video_payment_ccp_invalid: "Numéro CCP/BaridiMob invalide : 6 à 12 chiffres attendus (espaces et tirets tolérés).",
    doc_video_consultation_inactive: 'Téléconsultation vidéo désactivée',
    doc_join_video_btn: 'Rejoindre la consultation vidéo',
    doc_join_video_too_early: 'Disponible à partir de {time}',
    doc_video_consultation_tag: 'Consultation vidéo',
    doc_patient_connected_tag: 'Patient connecté à la salle vidéo',
    doc_no_show_video_connected_warning: 'Ce patient s\'est connecté à la salle de consultation vidéo. Confirmez uniquement si la consultation n\'a pas réellement eu lieu.',
    doc_video_dialog_title: 'Consultation vidéo',
    doc_video_join_error: "Impossible de rejoindre la consultation vidéo, veuillez réessayer.",

    // Doctor Profile page
    dp_back: 'Retour',
    dp_available: 'Disponible en ligne',
    dp_phone_only: 'RDV par téléphone',
    dp_video_available: 'Téléconsultation disponible',
    dp_presentation: 'Présentation',
    dp_education: 'Formation',
    dp_languages: 'Langues parlées',
    dp_insurance: 'Assurances acceptées',
    dp_book: 'Prendre rendez-vous',
    dp_slots_on: 'Créneaux le',
    dp_no_slots: 'Aucun créneau disponible',
    dp_contact: 'Contactez le cabinet',
    dp_no_online: "Ce médecin n'accepte pas encore les rendez-vous en ligne",
    dp_call: 'Appeler',
    dp_reviews: 'Avis des patients',
    dp_write_review: 'Donner un avis',
    dp_no_reviews: 'Aucun avis pour le moment',
    dp_avg_rating: 'Note moyenne des patients',
    dp_confirm_title: 'Confirmer le rendez-vous',
    dp_confirm_with: 'Rendez-vous avec',
    dp_date_time: 'Date et heure',
    // Idee CGM/ClickDoc : teleconsultation (Daily.co) — choix cabinet/video
    // au moment de la reservation, visible uniquement si le medecin l'a
    // active (doctor.video_consultation_enabled).
    dp_consultation_type_label: 'Type de consultation',
    dp_consultation_type_in_person: 'Au cabinet',
    dp_consultation_type_video: 'Vidéo (téléconsultation)',
    dp_slot_video_only_notice: 'Ce créneau est proposé uniquement en téléconsultation vidéo.',
    dp_video_payment_notice_prefix: "Rendez-vous provisoire tant que le paiement n'est pas confirmé. Réglez cette consultation par virement CCP/BaridiMob au numéro :",
    dp_video_payment_no_ccp: "Le médecin n'a pas encore renseigné de numéro de paiement — contactez-le directement pour régler votre consultation.",
    dp_payment_reference_label: 'Référence de virement',
    dp_payment_reference_placeholder: 'Ex : référence ou heure du virement',
    dp_payment_reference_required: "Merci d'indiquer la référence de votre virement CCP/BaridiMob pour confirmer la réservation.",
    dp_patient_account_required: 'Seul un compte patient peut réserver un rendez-vous. Connectez-vous avec un compte patient.',
    dp_reason: 'Motif (optionnel)',
    dp_reason_placeholder: 'Décrivez brièvement le motif...',
    dp_cancel: 'Annuler',
    dp_confirm: 'Confirmer',
    dp_booking: 'Réservation...',
    dp_login_required: 'Veuillez vous connecter ou créer un compte pour réserver un rendez-vous',
    dp_booking_success: 'Rendez-vous confirmé !',
    dp_booking_error: 'Erreur, veuillez réessayer',
    dp_review_title: 'Donner votre avis',
    dp_review_desc: 'Partagez votre expérience avec',
    dp_review_note: 'Note',
    dp_review_comment: 'Commentaire',
    dp_review_placeholder: 'Décrivez votre expérience...',
    dp_review_submit: 'Publier',
    dp_review_submitting: 'Publication...',
    dp_consultation: 'Consultation',
    dp_share: 'Partager',
    dp_share_whatsapp: 'WhatsApp',
    dp_share_facebook: 'Facebook',
    dp_share_copy: 'Copier le lien',
    dp_link_copied: 'Lien copié !',

    // Days
    day_monday: 'Lundi', day_tuesday: 'Mardi', day_wednesday: 'Mercredi', day_thursday: 'Jeudi',
    day_friday: 'Vendredi', day_saturday: 'Samedi', day_sunday: 'Dimanche',

    // Language
    lang_fr: 'Français',
    lang_ar: 'العربية',

    // Tool page layout (shared)
    tool_back_to_all: 'Tous les outils santé',
    tool_print: 'Imprimer / PDF',
    tool_need_consult_prefix: 'Besoin de consulter ',
    tool_need_consult_suffix: ' ? Prenez rendez-vous près de chez vous.',
    tool_default_specialty_label: 'un médecin',
    tool_search_cta: 'Rechercher sur Tabbibak',
    tool_disclaimer_footer: 'Estimation à titre informatif uniquement — ne remplace pas un avis médical. En cas de doute, consultez un professionnel de santé.',

    // Outil : Calculateur d'IMC
    bmi_title: "Calculateur d'IMC",
    bmi_subtitle: "Indice de masse corporelle, selon les seuils de l'Organisation mondiale de la santé.",
    bmi_weight_label: 'Poids (kg)',
    bmi_weight_placeholder: 'Ex: 70',
    bmi_height_label: 'Taille (cm)',
    bmi_height_placeholder: 'Ex: 175',
    bmi_result_label: 'Votre IMC',
    bmi_cat_under: 'Insuffisance pondérale',
    bmi_cat_normal: 'Poids normal',
    bmi_cat_over: 'Surpoids',
    bmi_cat_obese: 'Obésité',
    bmi_legend_under: 'Insuffisance pondérale : IMC < 18.5',
    bmi_legend_normal: 'Poids normal : 18.5 – 24.9',
    bmi_legend_over: 'Surpoids : 25 – 29.9',
    bmi_legend_obese: 'Obésité : IMC ≥ 30',

    // Outil : Calculateur d'ovulation
    ovulation_title: "Calculateur d'ovulation",
    ovulation_subtitle: 'Estimation basée sur la date de vos dernières règles et la durée de votre cycle.',
    ovulation_lmp_label: 'Date des dernières règles',
    ovulation_cycle_label: 'Durée moyenne du cycle (jours)',
    ovulation_result_label: "Date d'ovulation estimée",
    ovulation_fertile_label: 'Période de fertilité estimée',
    ovulation_from: 'Du',
    ovulation_to: 'au',
    ovulation_next_period_label: 'Prochaines règles estimées',
    ovulation_disclaimer: 'Cette estimation suppose un cycle régulier. En cas de cycles irréguliers, ces dates sont moins fiables — parlez-en à votre gynécologue.',

    // Outil : Suivi de grossesse
    pregnancy_title: 'Suivi de grossesse',
    pregnancy_subtitle: "Estimation de la date d'accouchement (règle de Naegele) à partir de vos dernières règles.",
    pregnancy_invalid_date: 'Cette date semble incorrecte, vérifiez-la.',
    pregnancy_trimester_1: '1er trimestre',
    pregnancy_trimester_2: '2e trimestre',
    pregnancy_trimester_3: '3e trimestre',
    pregnancy_you_are_at: 'Vous en êtes à',
    pregnancy_week_unit: 'semaine(s)',
    pregnancy_day_unit: 'jour(s)',
    pregnancy_and: 'et',
    pregnancy_due_date_label: 'Terme prévu (estimation)',
    pregnancy_days_remaining_label: 'Jours restants (estimation)',
    pregnancy_days_word: 'jours',
    pregnancy_card_title: 'Carte bébé — à partager',
    pregnancy_card_size_prefix: 'Taille approximative :',
    pregnancy_card_due_prefix: 'Terme prévu :',
    pregnancy_copied: 'Copié !',
    pregnancy_copy_button: 'Copier pour partager',
    pregnancy_share_pregnancy_label: 'Ma grossesse :',
    pregnancy_share_baby_size_label: 'Bébé a environ la taille de :',
    pregnancy_share_computed_with: '— Calculé avec Tabbibak.com',
    pregnancy_disclaimer: 'Cette date est une estimation statistique (règle de Naegele, cycle de 28 jours). Seule une échographie de datation réalisée par votre médecin ou sage-femme donne une date fiable.',

    // Outil : Posologie pédiatrique
    pediatric_title: 'Posologie pédiatrique',
    pediatric_subtitle: "Repère de dose pour le paracétamol et l'ibuprofène chez l'enfant, à titre indicatif.",
    pediatric_warning: "Ces doses sont indicatives et ne remplacent pas la notice du médicament ni l'avis d'un médecin ou pharmacien. Vérifiez toujours la graduation de la pipette ou seringue fournie avec votre boîte : elle varie selon la marque et la concentration du produit. En dessous de 3 mois, ou en cas de doute, consultez un médecin avant de donner un médicament.",
    pediatric_weight_label: "Poids de l'enfant (kg) *",
    pediatric_weight_placeholder: 'Ex: 12',
    pediatric_age_label: 'Âge (mois, facultatif)',
    pediatric_age_placeholder: 'Ex: 18',
    pediatric_out_of_range: 'Cet outil est calibré pour un poids de 3 à 50 kg. En dehors de cette plage, demandez la posologie exacte à un médecin ou pharmacien.',
    pediatric_para_heading: 'Paracétamol',
    pediatric_para_desc: '15 mg/kg par prise, toutes les 6 heures.',
    pediatric_dose_label: 'Dose par prise :',
    pediatric_para_max: 'Maximum 4 prises par 24h. Ne jamais dépasser 1 g par prise ni 60 mg/kg/jour.',
    pediatric_ibu_heading: 'Ibuprofène',
    pediatric_ibu_desc: '10 mg/kg par prise (sirop à 2%), toutes les 8 heures — uniquement à partir de 3 mois.',
    pediatric_dose_approx_ml: 'soit environ',
    pediatric_ibu_max: 'Maximum 3 prises par 24h. Vérifiez la concentration exacte de votre flacon.',
    pediatric_ibu_not_recommended: 'Non recommandé avant 3 mois. Consultez un médecin.',
    pediatric_contraindication_title: 'Contre-indication importante :',
    pediatric_contraindication_text: "l'ibuprofène (et les autres anti-inflammatoires) est contre-indiqué en cas de varicelle, d'infection bactérienne suspectée ou de déshydratation — il peut favoriser des complications graves. En cas de doute sur le diagnostic, donnez du paracétamol et consultez un médecin.",
    pediatric_disclaimer: 'Ces deux médicaments ne se prennent jamais en même temps sans avis médical. Consultez sans attendre en cas de fièvre chez un nourrisson de moins de 3 mois, de fièvre supérieure à 39,5°C ne baissant pas, de convulsions, de somnolence inhabituelle ou de refus de boire.',

    // Outil : Calendrier vaccinal
    vaccination_title: "Calendrier vaccinal de l'enfant",
    vaccination_subtitle: 'Repères indicatifs du programme national de vaccination en Algérie.',
    vaccination_dob_label: "Date de naissance de l'enfant",
    vaccination_disclaimer: "Ce calendrier reprend les grandes lignes du programme national élargi de vaccination en Algérie ; il évolue régulièrement (nouveaux vaccins, âges ajustés). Vérifiez toujours les dates exactes avec le carnet de santé de l'enfant et votre pédiatre ou centre de santé.",

    // Outil : Repère de risque cardiovasculaire
    cvrisk_title: 'Repère de risque cardiovasculaire',
    cvrisk_subtitle: 'Une auto-évaluation simple de vos facteurs de risque — pas un diagnostic.',
    cvrisk_warning: 'Cet outil ne remplace pas une évaluation médicale et ne détecte pas une urgence. En cas de douleur thoracique, essoufflement brutal ou malaise, appelez les secours immédiatement.',
    cvrisk_age_label: 'Âge',
    cvrisk_sex_label: 'Sexe',
    cvrisk_sex_placeholder: 'Sélectionner...',
    cvrisk_sex_male: 'Homme',
    cvrisk_sex_female: 'Femme',
    cvrisk_factor_smoking: "Vous fumez (ou avez arrêté il y a moins d'un an)",
    cvrisk_factor_hypertension: 'Hypertension artérielle connue',
    cvrisk_factor_diabetes: 'Diabète connu',
    cvrisk_factor_cholesterol: 'Cholestérol élevé connu',
    cvrisk_factor_obesity: 'IMC ≥ 30 (obésité)',
    cvrisk_factor_sedentary: "Moins de 30 minutes d'activité physique, 3 fois par semaine",
    cvrisk_factor_family: 'Infarctus ou AVC chez un parent proche avant 55 ans (homme) ou 65 ans (femme)',
    cvrisk_band_low: 'Faible',
    cvrisk_band_moderate: 'Modéré',
    cvrisk_band_high: 'Élevé',
    cvrisk_band_heading: 'Niveau de vigilance indicatif',
    cvrisk_msg_low: 'Continuez à surveiller votre santé régulièrement.',
    cvrisk_msg_other: 'Nous vous conseillons de discuter de ces facteurs avec un médecin, qui pourra faire une évaluation complète.',
    cvrisk_disclaimer: "Ce résultat est une estimation simplifiée basée sur des facteurs de risque connus. Il ne s'agit pas d'un score clinique validé (type SCORE2 ou Framingham) et ne remplace en aucun cas une consultation médicale.",

    // Outil : Tension artérielle
    bp_title: 'Évaluateur de tension artérielle',
    bp_subtitle: 'Repère indicatif à partir de vos chiffres de tension (mmHg).',
    bp_info: 'Une seule mesure ne permet pas de diagnostiquer une hypertension : le brassard doit être adapté, la mesure faite au repos, et répétée sur plusieurs jours. Seul un médecin peut confirmer un diagnostic.',
    bp_sys_label: 'Systolique (le grand chiffre)',
    bp_sys_placeholder: 'Ex: 130',
    bp_dia_label: 'Diastolique (le petit chiffre)',
    bp_dia_placeholder: 'Ex: 85',
    bp_cat_hypo: 'Hypotension',
    bp_cat_optimal: 'Optimale',
    bp_cat_normal: 'Normale',
    bp_cat_high_normal: 'Normale haute',
    bp_cat_grade1: 'Hypertension légère (grade 1)',
    bp_cat_grade2: 'Hypertension modérée (grade 2)',
    bp_cat_grade3: 'Hypertension sévère (grade 3)',
    bp_critical_warning: 'Ces chiffres sont élevés. Si vous avez aussi des maux de tête intenses, des troubles de la vue, une douleur thoracique ou un essoufflement, consultez en urgence.',
    bp_disclaimer: 'Ces seuils sont donnés à titre indicatif, inspirés des recommandations européennes. En cas de tension élevée de façon répétée, ou de symptômes associés, consultez un médecin ou un cardiologue.',

    // Outil : Masse grasse
    bf_title: "Indice de masse grasse (méthode US Navy)",
    bf_subtitle: 'Estimation de votre pourcentage de graisse corporelle à partir de mesures au ruban.',
    bf_neck_label: 'Tour de cou (cm)',
    bf_waist_label: 'Tour de taille (cm)',
    bf_hip_label: 'Tour de hanches (cm)',
    bf_cat_essential: 'Graisse essentielle',
    bf_cat_athletic: 'Athlétique',
    bf_cat_fit: 'Forme',
    bf_cat_acceptable: 'Acceptable',
    bf_cat_high: 'Élevé',
    bf_result_label: 'Masse grasse estimée',
    bf_disclaimer: "Cette méthode (US Navy) est une estimation par mesures de circonférence, moins précise qu'une impédancemétrie ou une DEXA. Mesurez avec un ruban souple, sans serrer.",

    // Outil : Calcium et vitamine D
    calcium_title: 'Besoins en calcium et vitamine D',
    calcium_subtitle: "Repères journaliers recommandés selon l'âge et la situation, et quelques sources alimentaires courantes.",
    calcium_profile_label: 'Votre profil',
    calcium_profile_child_1_3: 'Enfant (1–3 ans)',
    calcium_profile_child_4_8: 'Enfant (4–8 ans)',
    calcium_profile_teen: 'Adolescent·e (9–18 ans)',
    calcium_profile_adult: 'Adulte (19–50 ans)',
    calcium_profile_man_senior: 'Homme (51–70 ans)',
    calcium_profile_woman_senior: 'Femme (51–70 ans)',
    calcium_profile_elder: '71 ans et plus',
    calcium_profile_pregnancy_adult: 'Grossesse / allaitement (19–50 ans)',
    calcium_profile_pregnancy_teen: 'Grossesse / allaitement (14–18 ans)',
    calcium_daily_label: 'Calcium recommandé / jour',
    vitd_daily_label: 'Vitamine D recommandée / jour',
    calcium_sources_heading: 'Quelques sources alimentaires de calcium',
    calcium_source_milk: 'Lait (1 verre, 250 ml)',
    calcium_source_yogurt: 'Yaourt nature (1 pot, 125 g)',
    calcium_source_cheese: 'Fromage à pâte dure (30 g)',
    calcium_source_sardines: 'Sardines avec arêtes (100 g)',
    calcium_source_almonds: 'Amandes (30 g)',
    calcium_source_figs: 'Figues sèches (5 pièces)',
    calcium_vitd_info: "La vitamine D est surtout produite par la peau exposée au soleil ; elle est aussi présente dans les poissons gras, le jaune d'œuf et certains produits enrichis. En Algérie, une exposition modérée et régulière au soleil (visage, avant-bras, quelques minutes par jour, en dehors des heures les plus chaudes) contribue à couvrir une partie des besoins.",
    calcium_disclaimer: "Ces repères généraux ne remplacent pas un avis médical, en particulier en cas de carence connue, de pathologie osseuse, de grossesse à risque ou avant de démarrer un complément : parlez-en à votre médecin, qui pourra s'appuyer sur un bilan sanguin si nécessaire.",

    // Outil : Besoins caloriques
    calorie_title: 'Besoins caloriques (BMR / TDEE)',
    calorie_subtitle: 'Estimation de vos calories journalières selon votre objectif, formule de Mifflin-St Jeor.',
    calorie_activity_label: "Niveau d'activité",
    calorie_activity_sedentary: 'Sédentaire (peu ou pas de sport)',
    calorie_activity_light: 'Légèrement actif (sport 1-3 j/semaine)',
    calorie_activity_moderate: 'Modérément actif (sport 3-5 j/semaine)',
    calorie_activity_high: 'Très actif (sport 6-7 j/semaine)',
    calorie_activity_extreme: 'Extrêmement actif (sport intense, travail physique)',
    calorie_weight_loss: 'Perte de poids',
    calorie_maintenance: 'Maintien du poids',
    calorie_weight_gain: 'Prise de masse',
    calorie_per_day: 'kcal / jour',
    calorie_disclaimer: "Ces valeurs sont des estimations. Un déficit ou surplus trop important n'est pas recommandé sans avis médical, en particulier en cas de maladie chronique.",

    // Outil : Clairance de la créatinine
    crcl_title: 'Clairance de la créatinine (Cockcroft-Gault)',
    crcl_subtitle: 'Estimation de la fonction rénale, utile pour les patients diabétiques ou hypertendus.',
    crcl_info: "Renseignez le taux de créatinine indiqué sur votre bilan sanguin. Cette estimation ne remplace pas l'interprétation de votre médecin, en particulier pour ajuster la dose d'un médicament.",
    crcl_creatinine_label: 'Créatinine sanguine',
    crcl_stage_g1: 'G1 — Fonction normale ou élevée',
    crcl_stage_g2: 'G2 — Légèrement diminuée',
    crcl_stage_g3a: 'G3a — Légèrement à modérément diminuée',
    crcl_stage_g3b: 'G3b — Modérément à sévèrement diminuée',
    crcl_stage_g4: 'G4 — Sévèrement diminuée',
    crcl_stage_g5: 'G5 — Insuffisance rénale terminale',
    crcl_result_label: 'Clairance estimée',
    crcl_disclaimer: "La formule de Cockcroft-Gault est une estimation basée sur le poids, l'âge et le sexe ; elle est moins précise chez les personnes très maigres, très corpulentes, ou âgées. Un dosage sanguin avec calcul du DFG par le laboratoire reste la référence.",

    // Outil : Déshydratation & SRO
    dehydration_title: 'Déshydratation & SRO',
    dehydration_subtitle: 'Repère pour évaluer une déshydratation (diarrhée, vomissements) et la quantité de solution de réhydratation orale à donner.',
    dehydration_warning: 'Chez un nourrisson de moins de 3 mois, ou en cas de sang dans les selles, de fièvre élevée persistante, ou de vomissements incoercibles, consultez un médecin sans attendre ce questionnaire.',
    dehydration_weight_placeholder: 'Ex: 10',
    dehydration_age_years_label: 'Âge (années)',
    dehydration_age_years_placeholder: 'Ex: 1.5',
    dehydration_severe_heading: 'Signes sévères',
    dehydration_moderate_heading: 'Signes modérés',
    dehydration_sign_lethargy: "Léthargie, enfant très difficile à réveiller, ou inconscient",
    dehydration_sign_no_drink: "Ne peut pas boire, ou boit très mal",
    dehydration_sign_eyes_severe: "Yeux très enfoncés",
    dehydration_sign_skin_severe: "Le pli cutané reprend sa forme très lentement (plusieurs secondes)",
    dehydration_sign_agitated: "Agité(e), irritable",
    dehydration_sign_thirsty: "Boit avec avidité, semble avoir très soif",
    dehydration_sign_eyes_some: "Yeux légèrement enfoncés",
    dehydration_sign_skin_some: "Le pli cutané reprend sa forme lentement",
    dehydration_severe_result_title: 'Déshydratation sévère probable',
    dehydration_severe_result_text: 'Rendez-vous aux urgences immédiatement. Une réhydratation par voie intraveineuse est probablement nécessaire — le SRO seul ne suffit pas ici.',
    dehydration_moderate_result_title: 'Déshydratation modérée probable',
    dehydration_moderate_result_text: 'Solution de réhydratation orale (SRO) : environ 75 ml par kg de poids, à donner sur 4 heures, en petites quantités fréquentes (une cuillère toutes les 1 à 2 minutes pour un nourrisson).',
    dehydration_over_4h: 'sur 4 heures',
    dehydration_reassess: "Réévaluez après 4 heures. Si les signes ci-dessus persistent ou s'aggravent, consultez un médecin ou allez aux urgences.",
    dehydration_none_title: 'Pas de signe de déshydratation coché',
    dehydration_none_text: "Continuez l'allaitement ou l'alimentation habituelle, et donnez du SRO après chaque selle liquide pour prévenir la déshydratation :",
    dehydration_under2: 'Moins de 2 ans',
    dehydration_over2: '2 ans et plus',
    dehydration_planA_under2: '50 à 100 ml (10 à 20 cuillères à café)',
    dehydration_planA_over2: '100 à 200 ml (un demi à un verre)',
    dehydration_after_stool: 'après chaque selle liquide.',
    dehydration_disclaimer: "Le SRO se prépare avec de l'eau propre selon les instructions du sachet — ne jamais ajouter plus ou moins d'eau que recommandé. Votre médecin peut aussi prescrire du zinc en complément, comme recommandé par l'OMS en cas de diarrhée chez l'enfant.",

    // Outil : Convertisseur de fièvre
    fever_title: 'Convertisseur de fièvre',
    fever_subtitle: 'Comparez une température selon le mode de prise, et repérez les seuils qui doivent alerter.',
    fever_temp_label: 'Température mesurée (°C)',
    fever_site_label: 'Mode de prise',
    fever_site_rectal: 'Rectale',
    fever_site_oral: 'Orale (buccale)',
    fever_site_axillary: 'Axillaire (aisselle)',
    fever_site_tympanic: 'Tympanique (oreille)',
    fever_age_label: "Âge de l'enfant (mois, facultatif)",
    fever_age_placeholder: 'Laisser vide si adulte',
    fever_equiv_label: 'Équivalent rectal',
    fever_band_normal: 'Température normale',
    fever_band_low: 'Fébricule',
    fever_band_fever: 'Fièvre',
    fever_band_high: 'Fièvre élevée',
    fever_advice_under3: "Fièvre chez un nourrisson de moins de 3 mois : contactez un médecin immédiatement, même sans autre symptôme.",
    fever_advice_under6: "Contactez votre médecin dans la journée.",
    fever_advice_over6: "Température élevée : contactez votre médecin.",
    fever_advice_general: "Surveillez, hydratez bien l'enfant, et consultez si la fièvre persiste plus de 3 jours ou si d'autres symptômes inquiétants apparaissent.",
    fever_disclaimer: "La conversion entre modes de prise est approximative — les écarts varient selon l'appareil et la personne. La prise rectale est généralement considérée comme la plus fiable chez le nourrisson. En cas de doute, consultez un médecin plutôt que de vous fier uniquement à un chiffre.",

    // Outil : Convertisseur de glycémie
    glycemia_title: 'Convertisseur de glycémie',
    glycemia_subtitle: "Conversion mg/dL ↔ mmol/L et équivalence avec l'HbA1c.",
    glycemia_info: "Ces seuils sont donnés à titre indicatif. Le diagnostic du diabète repose sur des analyses de laboratoire répétées, pas sur une seule mesure au glucomètre.",
    glycemia_mgdl_label: 'Glycémie (mg/dL)',
    glycemia_mmol_label: 'Glycémie (mmol/L)',
    glycemia_timing_label: 'Moment de la mesure',
    glycemia_timing_fasting: 'À jeun',
    glycemia_timing_postprandial: 'Après un repas (2h)',
    glycemia_cat_low: 'Basse (hypoglycémie)',
    glycemia_cat_normal: 'Normale',
    glycemia_cat_prediabetes_fasting: 'Pré-diabète (à jeun)',
    glycemia_cat_high: 'Élevée — évocatrice de diabète',
    glycemia_cat_prediabetes_postprandial: 'Pré-diabète (post-prandiale)',
    glycemia_result_label: 'Interprétation indicative',
    glycemia_hba1c_heading: "Estimation depuis l'HbA1c",
    glycemia_hba1c_label: 'HbA1c (%)',
    glycemia_eag_label: 'Glycémie moyenne estimée',
    glycemia_disclaimer: "Ces conversions et seuils sont informatifs et ne remplacent pas le suivi de votre médecin ou endocrinologue, en particulier pour l'ajustement d'un traitement du diabète.",

    // Outil : Calculateur de croissance (OMS)
    growth_title: 'Calculateur de croissance (courbes OMS)',
    growth_subtitle: "Poids et taille de votre enfant comparés aux repères de croissance de l'OMS, de la naissance à 5 ans.",
    growth_info: "Ce repère compare une seule mesure aux courbes de l'OMS. C'est l'évolution dans le temps (le suivi régulier dans le carnet de santé) qui compte le plus, pas une mesure isolée.",
    growth_sex_label: 'Sexe',
    growth_sex_placeholder: 'Sélectionner...',
    growth_sex_boy: 'Garçon',
    growth_sex_girl: 'Fille',
    growth_age_label: 'Âge (mois, 0 à 60)',
    growth_age_placeholder: 'Ex: 14',
    growth_weight_label: 'Poids (kg)',
    growth_height_label: 'Taille (cm)',
    growth_weight_result_label: 'Poids',
    growth_height_result_label: 'Taille',
    growth_below_who: 'En dessous des repères OMS',
    growth_above_who: 'Au-dessus des repères OMS',
    growth_below_median: 'Dans la norme (en dessous de la médiane)',
    growth_above_median: 'Dans la norme (au-dessus de la médiane)',
    growth_who_refs_at_age: 'Repères OMS à cet âge :',
    growth_median_label: 'médiane',
    growth_disclaimer: "Une valeur en dehors de la plage 3ᵉ-97ᵉ percentile n'est pas forcément un problème, mais mérite d'en parler avec le pédiatre, surtout si elle est associée à un ralentissement ou une accélération inhabituelle par rapport aux mesures précédentes de l'enfant.",

    // Outil : Calculateur d'hydratation
    hydration_title: "Calculateur d'hydratation",
    hydration_subtitle: 'Estimation de vos besoins en eau selon votre poids, le climat et votre activité.',
    hydration_info: "Cette estimation est une moyenne générale pour un adulte en bonne santé. Si vous suivez un régime pauvre en sel, une restriction hydrique, ou souffrez d'une maladie rénale ou cardiaque, suivez les consignes de votre médecin plutôt que ce calcul.",
    hydration_weight_label: 'Poids (kg)',
    hydration_climate_label: 'Climat',
    hydration_climate_normal: 'Normal',
    hydration_climate_hot: 'Chaleur (été)',
    hydration_climate_very_hot: 'Forte chaleur / canicule',
    hydration_activity_label: 'Activité physique',
    hydration_activity_none: 'Aucune',
    hydration_activity_1: '30-60 min / jour',
    hydration_activity_2: '1-2h / jour',
    hydration_activity_3: 'Plus de 2h / jour',
    hydration_result_label: 'Besoin estimé',
    hydration_result_note: 'par jour, eau et boissons comprises',
    hydration_disclaimer: "Une partie de ces apports peut provenir de l'alimentation (fruits, légumes, soupes). En cas de forte chaleur, fractionnez votre consommation d'eau tout au long de la journée.",

    // Outil : Évaluateur de cycles de sommeil
    sleep_title: 'Évaluateur de cycles de sommeil',
    sleep_subtitle: 'Trouvez une heure de coucher ou de réveil qui tombe entre deux cycles de sommeil complets.',
    sleep_mode_wake: 'Je dois me réveiller à...',
    sleep_mode_sleep: 'Je vais me coucher à...',
    sleep_wake_time_label: 'Heure de réveil souhaitée',
    sleep_bed_time_label: 'Heure de coucher',
    sleep_recommended_bedtimes: 'Heures de coucher recommandées',
    sleep_recommended_wake: 'Heures de réveil recommandées',
    sleep_cycles_word: 'cycles',
    sleep_about: 'environ',
    sleep_hours_sleep: 'h de sommeil',
    sleep_recommended_badge: 'Repère conseillé',
    sleep_disclaimer: "La durée moyenne d'un cycle de sommeil (≈90 minutes) et le temps d'endormissement varient d'une personne à l'autre. Ces repères sont indicatifs ; en cas de troubles du sommeil persistants (insomnie, réveils fréquents, fatigue chronique), consultez un médecin.",

    // Outil : Calculateur d'arrêt du tabac
    smoking_title: "Calculateur d'arrêt du tabac",
    smoking_subtitle: 'Vos économies en DZD et les bénéfices santé au fil du temps depuis votre arrêt.',
    smoking_per_day_label: "Cigarettes par jour (avant l'arrêt)",
    smoking_price_label: "Prix d'un paquet (DZD)",
    smoking_cigs_per_pack_label: 'Cigarettes par paquet',
    smoking_quit_date_label: "Date d'arrêt",
    smoking_saved_money_label: 'Argent économisé',
    smoking_avoided_cigs_label: 'Cigarettes non fumées',
    smoking_benefits_heading: 'Bénéfices santé',
    smoking_disclaimer: "Ces délais sont des repères généraux communiqués par les autorités de santé publique ; ils varient d'une personne à l'autre. Un médecin ou un programme d'aide au sevrage tabagique peut vous accompagner pour augmenter vos chances de réussite.",
    smoking_m1_label: '20 minutes',
    smoking_m1_text: 'La fréquence cardiaque et la tension artérielle commencent à redescendre.',
    smoking_m2_label: '12 heures',
    smoking_m2_text: 'Le taux de monoxyde de carbone dans le sang revient à la normale.',
    smoking_m3_label: '2 jours',
    smoking_m3_text: "L'odorat et le goût commencent à s'améliorer.",
    smoking_m4_label: '3 semaines',
    smoking_m4_text: "La circulation sanguine et la fonction pulmonaire s'améliorent.",
    smoking_m5_label: '9 mois',
    smoking_m5_text: "La toux et l'essoufflement diminuent nettement.",
    smoking_m6_label: '1 an',
    smoking_m6_text: 'Le risque de maladie coronarienne est réduit de moitié par rapport à un fumeur.',
    smoking_m7_label: '5 ans',
    smoking_m7_text: "Le risque d'AVC rejoint celui d'un non-fumeur.",
    smoking_m8_label: '10 ans',
    smoking_m8_text: 'Le risque de cancer du poumon diminue significativement.',

    // Outil : Planning de prise d'antibiotiques
    atb_title: "Planning de prise d'antibiotiques",
    atb_subtitle: "Générez un calendrier de prises pour ne pas oublier une dose et terminer votre traitement.",
    atb_warning: "Ce planning est un simple outil d'organisation basé sur ce que votre médecin vous a prescrit (nom, fréquence, durée). Il ne remplace pas l'ordonnance : respectez toujours les horaires, la dose et la durée indiqués par votre médecin ou votre pharmacien, et n'arrêtez jamais un antibiotique de vous-même même si vous vous sentez mieux.",
    atb_name_label: "Nom de l'antibiotique (facultatif)",
    atb_name_placeholder: 'Ex: Amoxicilline',
    atb_start_date_label: 'Date de début',
    atb_frequency_label: 'Fréquence prescrite',
    atb_freq_1: '1 fois par jour',
    atb_freq_2: '2 fois par jour',
    atb_freq_3: '3 fois par jour',
    atb_freq_4: '4 fois par jour',
    atb_duration_label: 'Durée du traitement (jours)',
    atb_duration_placeholder: 'Ex: 7',
    atb_schedule_heading: 'Calendrier des prises',
    atb_doses_checked: 'prises cochées',
    atb_disclaimer: "Les horaires proposés (8h, 13h/14h, 18h/20h, 23h) sont des repères pratiques répartis sur la journée ; adaptez-les si votre médecin a précisé des horaires différents (par exemple par rapport aux repas). En cas d'effet indésirable (éruption cutanée, diarrhée importante, difficulté à respirer), contactez votre médecin ou un pharmacien rapidement.",

    // Outil : Prise de poids pendant la grossesse
    gwg_title: 'Prise de poids pendant la grossesse',
    gwg_subtitle: "Repères de l'Institute of Medicine (IOM) selon votre IMC d'avant grossesse, pour une grossesse simple.",
    gwg_info: "Ces repères concernent une grossesse simple (un seul bébé). Pour une grossesse gémellaire ou multiple, les cibles sont différentes — parlez-en à votre médecin ou sage-femme.",
    gwg_height_label: 'Taille (cm)',
    gwg_preweight_label: 'Poids avant la grossesse (kg)',
    gwg_currentweight_label: 'Poids actuel (kg, facultatif)',
    gwg_week_label: 'Semaine de grossesse (facultatif)',
    gwg_cat_under: 'Insuffisance pondérale',
    gwg_cat_normal: 'Poids normal',
    gwg_cat_over: 'Surpoids',
    gwg_cat_obese: 'Obésité',
    gwg_your_bmi_prefix: "Votre IMC d'avant grossesse :",
    gwg_total_recommended: 'Prise de poids totale recommandée sur toute la grossesse :',
    gwg_indicative_at_week: 'Repère indicatif à',
    gwg_weeks_word: 'semaines',
    gwg_about_prefix: 'Environ',
    gwg_kg_gained_since_start: 'kg pris depuis le début',
    gwg_current_gain_prefix: 'Votre prise de poids actuelle :',
    gwg_disclaimer: "Ces repères (Institute of Medicine, 2009) sont des moyennes indicatives ; le suivi réel de votre grossesse — poids, tension, croissance du bébé — doit être fait par votre médecin ou votre sage-femme lors des consultations prénatales.",

    // Outil : Congé maternité et arrêt maladie
    maternity_title: 'Congé maternité et arrêt maladie en Algérie',
    maternity_subtitle: "Repères sur la durée et l'indemnisation, selon la loi 25-08 (2025) et le régime général de la CNAS.",
    maternity_tab_leave: 'Congé maternité',
    maternity_tab_sick: 'Arrêt maladie',
    maternity_info_pre: 'Depuis la loi 25-08 (juillet 2025), le congé de maternité est de ',
    maternity_info_strong1: '150 jours consécutifs',
    maternity_info_mid: ', indemnisés à ',
    maternity_info_strong2: '100 % du salaire',
    maternity_info_post: " par la CNAS. Il peut débuter jusqu'à 42 jours avant la date présumée de l'accouchement, sans réduction de la durée totale si l'accouchement a lieu plus tôt.",
    maternity_due_date_label: "Date présumée de l'accouchement",
    maternity_leave_start_label: 'Début du congé (jours avant le terme)',
    maternity_start_42: '42 jours avant (maximum)',
    maternity_start_21: '21 jours avant',
    maternity_start_14: '14 jours avant',
    maternity_start_0: "Le jour de l'accouchement",
    maternity_leave_start_result: 'Début du congé',
    maternity_leave_end_result: 'Fin du congé (150 jours)',
    maternity_extension_note: "Des prolongations existent en cas de naissance prématurée ou de complications : +50 jours si le nouveau-né présente un handicap, une malformation congénitale ou une maladie grave (certificat médical requis), et jusqu'à +165 jours supplémentaires si des soins continus sont médicalement nécessaires (certificat d'un spécialiste en pédiatrie).",
    sick_info_pre: "En arrêt maladie ordinaire, l'indemnité journalière est de ",
    sick_info_strong1: '50 % du salaire journalier',
    sick_info_mid: ' pour les 15 premiers jours, puis ',
    sick_info_strong2: '100 %',
    sick_info_post: " à partir du 16ᵉ jour. En cas d'hospitalisation ou de maladie chronique reconnue (longue durée), l'indemnisation est de 100 % dès le premier jour.",
    sick_daily_salary_label: 'Salaire journalier net (DZD)',
    sick_days_label: "Nombre de jours d'arrêt",
    sick_days_placeholder: 'Ex: 20',
    sick_total_label: 'Indemnité totale estimée (arrêt ordinaire)',
    sick_note: "L'indemnité journalière ne peut pas être inférieure à 1/30ᵉ du salaire mensuel précédemment perçu. La durée maximale de prise en charge est de 3 ans. L'ouverture des droits suppose une durée d'affiliation minimale (généralement 15 jours de travail dans le trimestre précédent, ou 60 jours dans les 12 derniers mois).",
    maternity_legal_disclaimer: "Ces informations sont indicatives et ne constituent pas un conseil juridique ou financier personnalisé. La réglementation peut évoluer et des situations particulières (conditions d'affiliation, cas non salarié via la CASNOS...) peuvent changer les règles applicables. Confirmez toujours votre situation auprès de la CNAS (numéro vert 30-10), de la CASNOS ou des ressources humaines de votre employeur.",

    // Outil : Simulateur de remboursement CNAS/CASNOS
    cnas_title: 'Simulateur de remboursement CNAS/CASNOS',
    cnas_subtitle: 'Une estimation indicative de votre remboursement selon le type de soins — à titre informatif uniquement.',
    cnas_info_pre: "Le remboursement de base de la Sécurité sociale algérienne (CNAS pour les salariés, CASNOS pour les non-salariés) est de ",
    cnas_info_strong1: '80 %',
    cnas_info_mid: ' du tarif de référence conventionné, porté à ',
    cnas_info_strong2: '100 %',
    cnas_info_post: ' pour certaines situations (maladies chroniques reconnues, maternité, personnes à faible revenu, retraités/invalides sous conditions).',
    cnas_type_label: 'Type de soins',
    cnas_cat_consultation: 'Consultation médicale (généraliste ou spécialiste)',
    cnas_cat_pharmacie: 'Médicaments prescrits (hors carte Chifa en tiers payant)',
    cnas_cat_hospitalisation: 'Hospitalisation (hors maternité)',
    cnas_cat_chronique: 'Soins liés à une maladie chronique reconnue',
    cnas_cat_maternite: 'Suivi de grossesse, accouchement, soins postnatals',
    cnas_amount_label: 'Montant payé ou tarif de référence (DZD)',
    cnas_amount_placeholder: 'Ex: 1500',
    cnas_reimbursed_label: 'Remboursement estimé',
    cnas_remaining_label: 'Reste à votre charge (estimation)',
    cnas_chifa_heading: 'À savoir sur la carte Chifa',
    cnas_chifa_text: "Avec la carte Chifa, les médicaments prescrits jusqu'à 3 000 DZD sont généralement pris en charge directement en pharmacie (tiers payant), sans avance de frais, pour les deux premières ordonnances par bénéficiaire sur une période de 3 mois. Au-delà, une avance de frais suivie d'une demande de remboursement peut être nécessaire.",
    cnas_disclaimer: "Ceci est une estimation générale et indicative, pas un document officiel ni un conseil financier ou juridique. Les taux réels dépendent du tarif de référence conventionné (qui peut différer du prix facturé), de votre régime et de votre situation personnelle. Confirmez toujours le montant exact auprès de la CNAS ou de la CASNOS.",

    // Outil : Vérificateur de doublons de principe actif
    drugdup_title: 'Vérificateur de doublons de médicament',
    drugdup_subtitle: 'Repérez si, parmi vos médicaments, certains sont en réalité le même produit (même substance, dosage et forme) vendu sous des marques différentes.',
    drugdup_info: "Cet outil compare les médicaments à partir du registre pharmaceutique officiel (plus de 9500 références) et signale deux types de cas : deux marques différentes qui correspondent exactement au même médicament (même substance, même dosage, même forme), et la même substance active retrouvée à des dosages ou formes différents (par exemple Doliprane 500 mg et Doliprane 1000 mg) — ce qui peut être volontaire selon la prescription, mais à vérifier. Il ne détecte pas les interactions médicamenteuses, ni les cas où la même substance porte un libellé différent selon le sel chimique ou la voie d'administration (par exemple une forme injectable et un comprimé). En cas de doute sur une association ou un dosage, demandez toujours à votre pharmacien.",
    drugdup_search_placeholder: 'Rechercher un médicament (nom commercial)...',
    drugdup_type_more: 'Tapez au moins 2 caractères pour rechercher un médicament.',
    drugdup_searching: 'Recherche en cours…',
    drugdup_search_error: 'La recherche est momentanément indisponible. Réessayez plus tard.',
    drugdup_none_found: 'Aucun médicament trouvé pour cette recherche.',
    drugdup_selected_heading: 'Médicaments sélectionnés',
    drugdup_and: ' et ',
    drugdup_substance_label: 'Substance active : ',
    drugdup_dup_mid: ' sont en réalité le même médicament (même substance, dosage et forme), vendu sous des marques différentes.',
    drugdup_dup_post: ' Le prendre en double expose à un risque de surdosage. Vérifiez avec votre pharmacien avant de les associer.',
    drugdup_samesubstance_mid: ' contiennent tous ',
    drugdup_samesubstance_post: ', à des dosages ou formes différents. Cela peut être volontaire selon la prescription, mais vérifiez la dose totale avec votre médecin ou pharmacien avant de les associer.',
    drugdup_no_duplicate: "Aucun doublon exact, ni association de dosages différents de la même substance, détecté parmi les médicaments sélectionnés (selon le registre officiel). Cela ne garantit pas l'absence d'un principe actif commun sous un libellé différent (par exemple un sel chimique ou une voie d'administration différente) : en cas de doute, vérifiez avec votre pharmacien.",
    drugdup_disclaimer: "Cet outil ne remplace pas une analyse d'interactions médicamenteuses complète, qui doit être faite par un pharmacien ou un médecin — en particulier si vous prenez des traitements chroniques ou plusieurs médicaments en même temps.",

    // Outil : Triage d'urgence
    triage_title: "Triage d'urgence",
    triage_subtitle: "Un premier repère pour savoir s'il faut appeler les secours, consulter rapidement, ou attendre.",
    triage_call_warning: "En cas de doute ou d'urgence évidente, appelez directement les secours sans attendre ce questionnaire.",
    triage_civil_protection: 'Protection Civile — 1021',
    triage_samu: 'SAMU — 14',
    triage_red_question: 'Un de ces signes est-il présent ?',
    triage_red_1: 'Perte de connaissance ou confusion soudaine',
    triage_red_2: 'Difficulté sévère à respirer, étouffement',
    triage_red_3: 'Douleur violente ou oppression dans la poitrine',
    triage_red_4: "Saignement abondant qui ne s'arrête pas",
    triage_red_5: 'Convulsions',
    triage_red_6: "Faiblesse ou paralysie soudaine d'un côté du corps, difficulté à parler",
    triage_red_7: 'Gonflement du visage/gorge après une piqûre, un aliment ou un médicament',
    triage_red_8: 'Traumatisme grave (chute importante, accident, plaie profonde)',
    triage_orange_question: 'Ou plutôt un de ceux-ci ?',
    triage_orange_1: 'Fièvre élevée (>39,5°C) qui ne baisse pas malgré un traitement',
    triage_orange_2: 'Vomissements ou diarrhée répétés avec signes de déshydratation',
    triage_orange_3: 'Douleur intense mais stable, sans les signes ci-dessus',
    triage_orange_4: 'Plaie qui pourrait nécessiter des points de suture',
    triage_result_red_title: 'Urgence probable : appelez le 1021 ou le 14 maintenant',
    triage_result_orange_title: 'Consultation prioritaire recommandée, dans les 24 heures',
    triage_result_red_text: "Dirigez-vous vers les urgences de l'hôpital le plus proche ou appelez les secours sans attendre.",
    triage_result_orange_text: 'Consultez un médecin ou un service de garde dans la journée.',
    triage_call_1021: 'Appeler le 1021',
    triage_call_14: 'Appeler le 14',
    triage_none_title: "Aucun signe d'alerte coché",
    triage_none_text: 'Une consultation classique chez un médecin généraliste est suffisante.',
    triage_disclaimer: "Ce questionnaire est un premier repère, pas un diagnostic. En cas de doute, il vaut mieux toujours consulter ou appeler les secours plutôt que d'attendre.",

    // Outil : Certificat médical prénuptial
    prenup_title: 'Certificat médical prénuptial en Algérie',
    prenup_subtitle: 'Ce que prévoit la réglementation, les examens concernés, et vos droits — à titre informatif.',
    prenup_intro: "Depuis le décret exécutif de novembre 2024, un certificat médical prénuptial est exigé pour tout mariage contracté en Algérie. Chaque futur·e époux·se doit présenter le sien.",
    prenup_mandatory_heading: 'Examens obligatoires',
    prenup_mand_1: 'Interrogatoire médical détaillé (antécédents personnels et familiaux, maladies héréditaires)',
    prenup_mand_2: 'Mesure de la tension artérielle',
    prenup_mand_3: 'Taille et poids, examen clinique général',
    prenup_mand_4: 'Détermination du groupe sanguin (ABO) et du Rhésus',
    prenup_mand_5: 'Sérologies de la toxoplasmose, de la rubéole et de la syphilis',
    prenup_recommended_heading: 'Examens recommandés (selon le contexte)',
    prenup_rec_1: "Sérologie de l'hépatite B (VHB)",
    prenup_rec_2: "Sérologie de l'hépatite C (VHC)",
    prenup_rec_3: 'Sérologie du VIH',
    prenup_rec_note: "Le médecin peut prescrire des examens complémentaires si des symptômes évoquant une infection sexuellement transmissible sont constatés.",
    prenup_right_heading: 'Un droit important',
    prenup_right_text: "Le notaire ou l'officier de l'état civil ne peut pas refuser de célébrer le mariage sur la base des résultats médicaux. Les deux futurs époux restent entièrement libres de se marier quels que soient les résultats — le certificat a un rôle d'information, pas de condition bloquante.",
    prenup_validity_heading: 'Validité et remise',
    prenup_validity_text: "Le certificat est valable moins de trois mois à compter de sa délivrance. Il est remis individuellement à chaque futur·e époux·se par le médecin examinateur, puis présenté au notaire ou à l'officier d'état civil avant l'établissement de l'acte de mariage.",
    prenup_disclaimer: "Cette page résume la réglementation en vigueur à titre informatif ; elle ne remplace pas une consultation médicale. Pour effectuer ces examens, adressez-vous à un médecin généraliste ou à un laboratoire d'analyses agréé.",

    // Outil : Jeûne du Ramadan et diabète
    ramadan_title: 'Jeûne du Ramadan et diabète',
    ramadan_subtitle: 'Un repère indicatif inspiré du cadre de stratification IDF-DAR, pour préparer la discussion avec votre médecin.',
    ramadan_info: "Cet outil s'inspire du cadre international IDF-DAR mais n'en est pas une reproduction certifiée — certains seuils de l'algorithme officiel complet ne sont pas publiés dans le détail. Il donne un repère de discussion, pas une décision médicale. La décision de jeûner doit toujours être prise avec votre médecin.",
    ramadan_very_high_heading: 'Situations à très haut risque',
    ramadan_auto_1: 'Grossesse en cours',
    ramadan_auto_2: 'Dialyse ou insuffisance rénale sévère',
    ramadan_auto_3: "Acidocétose ou coma hyperosmolaire dans les 3 derniers mois",
    ramadan_auto_4: "Non-perception des hypoglycémies (pas de signes d'alerte)",
    ramadan_auto_5: 'Maladie aiguë actuelle (fièvre, infection, chirurgie récente...)',
    ramadan_auto_6: 'Infarctus, AVC ou événement cardiovasculaire dans les 3 derniers mois',
    ramadan_auto_7: 'Troubles cognitifs, dépendance fonctionnelle ou grand âge avec fragilité',
    ramadan_type1_label: 'Diabète de type 1',
    ramadan_longstanding_label: 'Diabète connu depuis 10 ans ou plus',
    ramadan_hypo_label: 'Hypoglycémies au cours des 3 derniers mois',
    ramadan_hypo_none: 'Aucune',
    ramadan_hypo_rare: "Moins d'une fois par semaine",
    ramadan_hypo_frequent: 'Plusieurs fois par semaine',
    ramadan_hypo_severe: "Épisode sévère (aide d'un tiers nécessaire)",
    ramadan_hba1c_label: 'Dernière HbA1c',
    ramadan_hba1c_lt75: 'Moins de 7,5 %',
    ramadan_hba1c_mid: 'Entre 7,5 % et 9 %',
    ramadan_hba1c_high: 'Plus de 9 %',
    ramadan_treatment_label: 'Traitement actuel',
    ramadan_treat_1: 'Autre (metformine, DPP-4, GLP-1, SGLT2, sans insuline ni sulfamide)',
    ramadan_treat_2: 'Gliclazide, glimépiride ou répaglinide',
    ramadan_treat_3: 'Glibenclamide',
    ramadan_treat_4: 'Insuline basale seule',
    ramadan_treat_5: 'Insuline mixte, une injection par jour',
    ramadan_treat_6: 'Schéma basal-bolus ou pompe à insuline',
    ramadan_treat_7: 'Insuline mixte, plusieurs injections par jour',
    ramadan_see_result_btn: 'Voir mon repère de risque',
    ramadan_band_very_high_label: 'Très haut risque',
    ramadan_band_very_high_text: "Le jeûne est déconseillé. Parlez-en impérativement à votre médecin avant de décider — un suivi rapproché ou une adaptation du traitement peut être nécessaire.",
    ramadan_band_low_label: 'Risque faible',
    ramadan_band_low_text: "Le jeûne est habituellement possible pour ce profil, avec une auto-surveillance régulière et un plan préparé avec votre médecin.",
    ramadan_band_moderate_label: 'Risque modéré',
    ramadan_band_moderate_text: "Le jeûne peut être envisagé mais avec prudence : discutez avec votre médecin d'un éventuel ajustement du traitement et d'une surveillance renforcée.",
    ramadan_band_high_label: 'Risque élevé',
    ramadan_band_high_text: "Le jeûne est probablement à risque pour ce profil. Une évaluation médicale avant le Ramadan est fortement recommandée.",
    ramadan_disclaimer: "Quel que soit le résultat, si vous ressentez des signes d'hypoglycémie, de déshydratation sévère ou de malaise pendant le jeûne, rompez-le immédiatement et prenez les mesures nécessaires : votre santé prime sur le jeûne, ce que rappellent d'ailleurs les recommandations religieuses elles-mêmes pour les personnes malades.",

    // Outil : Auto-test de perception des couleurs
    colorperception_title: 'Auto-test de perception des couleurs',
    colorperception_subtitle: 'Un repère préliminaire et ludique — pas un diagnostic de daltonisme.',
    colorperception_info: "Ce test simplifié ne remplace pas le test d'Ishihara ni un examen ophtalmologique. Il vous donne juste un premier repère. Le rendu des couleurs peut aussi varier selon votre écran.",
    colorperception_round_word: 'Manche',
    colorperception_instruction: 'Cliquez sur la case dont la teinte est différente des autres.',
    colorperception_correct: 'Correct !',
    colorperception_wrong: 'Pas tout à fait — au suivant.',
    colorperception_score_label: 'Score :',
    colorperception_restart: 'Recommencer',
    colorperception_result_good_label: 'Aucune difficulté notable détectée',
    colorperception_result_good_text: 'Vous avez distingué correctement la plupart des teintes proposées dans cet auto-test simplifié.',
    colorperception_result_mid_label: 'Quelques hésitations',
    colorperception_result_mid_text: "Certaines teintes ont été plus difficiles à distinguer. Un test réalisé par un ophtalmologue (test d'Ishihara ou équivalent) donnerait un avis fiable.",
    colorperception_result_bad_label: 'Difficultés répétées',
    colorperception_result_bad_text: 'Vous avez eu du mal à distinguer plusieurs teintes proches. Nous vous recommandons de consulter un ophtalmologue pour un test de vision des couleurs complet.',
    colorperception_disclaimer: "Le daltonisme (le plus souvent une difficulté à distinguer le rouge et le vert) se confirme par un test médical standardisé. Un dépistage précoce, en particulier chez l'enfant, permet d'adapter certains apprentissages scolaires.",

    // Outil : Auto-questionnaire de stress
    stress_title: 'Auto-questionnaire de stress',
    stress_subtitle: 'Un repère indicatif sur votre niveau de stress au quotidien — pas un diagnostic clinique.',
    stress_info: "Ce questionnaire simplifié n'est pas une échelle clinique validée (comme la HAD ou le PSS). Il vous donne un premier repère personnel ; seul un professionnel de santé peut poser un diagnostic de stress chronique, d'anxiété ou d'épuisement (burnout).",
    stress_intro: 'Au cours des deux dernières semaines...',
    stress_q1: "Je me sens tendu·e ou à cran, même sans raison précise",
    stress_q2: "J'ai du mal à me détendre une fois la journée terminée",
    stress_q3: "Je dors moins bien ou je me réveille fatigué·e",
    stress_q4: "Je suis plus irritable que d'habitude avec mes proches",
    stress_q5: "J'ai du mal à me concentrer sur mes tâches",
    stress_q6: "Je me sens dépassé·e par ce que j'ai à faire",
    stress_q7: "J'ai moins d'énergie ou d'envie pour les choses que j'aime habituellement",
    stress_q8: "Je ressens des tensions physiques (maux de tête, douleurs, mâchoire serrée...)",
    stress_opt_never: 'Jamais',
    stress_opt_sometimes: 'Parfois',
    stress_opt_often: 'Souvent',
    stress_opt_almost_always: 'Presque toujours',
    stress_see_result_btn: 'Voir mon résultat',
    stress_band_low_label: 'Stress limité',
    stress_band_low_text: "Votre quotidien ne semble pas marqué par un stress important en ce moment. Continuez à prendre soin de votre équilibre (sommeil, activité, temps pour vous).",
    stress_band_mid_label: 'Stress modéré',
    stress_band_mid_text: "Vous ressentez des signes de stress à surveiller. Des pauses régulières, de l'activité physique, un bon sommeil, et en parler à vos proches ou à un professionnel peuvent aider.",
    stress_band_high_label: 'Stress marqué',
    stress_band_high_text: "Vos réponses suggèrent un niveau de stress élevé et persistant. Il serait utile d'en parler avec un médecin ou un professionnel de santé mentale, qui pourra faire un vrai bilan et vous accompagner.",
    stress_help_note: "Si vous traversez une période difficile ou si vous avez des idées noires, n'hésitez pas à en parler à un proche de confiance ou à un professionnel de santé — vous n'êtes pas seul·e, et un accompagnement peut vraiment aider.",

    // Hub des outils santé
    hub_page_title: 'Outils santé',
    hub_page_subtitle: 'Des outils gratuits pour mieux comprendre votre santé au quotidien.',
    hub_footer_tagline: 'La plateforme algérienne de prise de rendez-vous médicaux',
    hub_disclaimer: 'Ces outils fournissent des estimations à titre informatif uniquement et ne remplacent pas un avis médical. En cas de doute, consultez un professionnel de santé.',
    hub_cta_discover: 'Découvrir',
    hub_badge_new: 'Nouveau',
    hub_badge_popular: 'Populaire',
    hub_cat_emergency: 'Urgences & prévention',
    hub_cat_child: "Santé de l'enfant & pédiatrie",
    hub_cat_chronic: 'Maladies chroniques & suivi quotidien',
    hub_cat_nutrition: 'Nutrition & métabolisme',
    hub_cat_women: 'Femme, fertilité & grossesse',
    hub_cat_wellbeing: 'Bien-être & lifestyle',
    hub_cat_admin: 'Démarches & droits en Algérie',
    hub_triage_urgence_title: "Triage d'urgence",
    hub_triage_urgence_desc: "Un premier repère pour savoir s'il faut appeler les secours ou consulter rapidement.",
    hub_triage_urgence_cta: 'Faire le point',
    hub_fievre_title: 'Convertisseur de fièvre',
    hub_fievre_desc: 'Comparez une température selon le mode de prise, et les seuils qui doivent alerter.',
    hub_fievre_cta: 'Convertir',
    hub_arret_tabac_title: 'Arrêt du tabac',
    hub_arret_tabac_desc: 'Vos économies en DZD et les bénéfices santé au fil du temps.',
    hub_arret_tabac_cta: 'Calculer',
    hub_posologie_enfant_title: 'Posologie pédiatrique',
    hub_posologie_enfant_desc: "Repère de dose pour le paracétamol et l'ibuprofène chez l'enfant.",
    hub_posologie_enfant_cta: 'Calculer la dose',
    hub_vaccination_title: 'Calendrier vaccinal',
    hub_vaccination_desc: "Le calendrier de vaccination de l'enfant en Algérie, avec vos dates personnalisées.",
    hub_vaccination_cta: 'Voir le calendrier',
    hub_croissance_title: 'Croissance (courbes OMS)',
    hub_croissance_desc: "Poids et taille de votre enfant comparés aux repères de l'OMS, 0 à 5 ans.",
    hub_croissance_cta: 'Comparer',
    hub_deshydratation_title: 'Déshydratation & SRO',
    hub_deshydratation_desc: 'Quantité de solution de réhydratation orale en cas de diarrhée ou vomissements.',
    hub_deshydratation_cta: 'Calculer',
    hub_tension_arterielle_title: 'Tension artérielle',
    hub_tension_arterielle_desc: 'Un repère indicatif à partir de vos chiffres de tension.',
    hub_tension_arterielle_cta: 'Vérifier ma tension',
    hub_glycemie_title: 'Convertisseur de glycémie',
    hub_glycemie_desc: "Conversion mg/dL ↔ mmol/L et équivalence avec l'HbA1c.",
    hub_glycemie_cta: 'Convertir',
    hub_clairance_creatinine_title: 'Clairance de la créatinine',
    hub_clairance_creatinine_desc: 'Estimation de votre fonction rénale (formule de Cockcroft-Gault).',
    hub_clairance_creatinine_cta: 'Estimer',
    hub_risque_cardiovasculaire_title: 'Risque cardiovasculaire',
    hub_risque_cardiovasculaire_desc: 'Un premier repère sur vos facteurs de risque cardiovasculaire.',
    hub_risque_cardiovasculaire_cta: 'Évaluer mon risque',
    hub_bilan_sanguin_title: 'Convertisseur de bilan sanguin',
    hub_bilan_sanguin_desc: 'NFS et bilan lipidique : convertissez et repérez vos valeurs usuelles.',
    hub_bilan_sanguin_cta: 'Convertir',
    hub_ramadan_diabete_title: 'Jeûne du Ramadan et diabète',
    hub_ramadan_diabete_desc: 'Un repère de risque pour préparer la discussion avec votre médecin avant le jeûne.',
    hub_ramadan_diabete_cta: 'Évaluer mon risque',
    hub_planning_antibiotiques_title: "Planning d'antibiotiques",
    hub_planning_antibiotiques_desc: 'Un calendrier de prises pour ne rien oublier et terminer votre traitement.',
    hub_planning_antibiotiques_cta: 'Créer mon planning',
    hub_imc_title: "Calculateur d'IMC",
    hub_imc_desc: 'Calculez votre indice de masse corporelle et connaissez votre catégorie de poids.',
    hub_imc_cta: 'Calculer mon IMC',
    hub_hydratation_title: "Calculateur d'hydratation",
    hub_hydratation_desc: 'Vos besoins en eau selon votre poids, le climat et votre activité.',
    hub_hydratation_cta: 'Calculer',
    hub_calories_title: 'Besoins caloriques (BMR/TDEE)',
    hub_calories_desc: 'Vos calories journalières selon votre objectif de poids.',
    hub_calories_cta: 'Calculer',
    hub_masse_grasse_title: 'Masse grasse (méthode US Navy)',
    hub_masse_grasse_desc: 'Estimation de votre pourcentage de graisse corporelle.',
    hub_masse_grasse_cta: 'Estimer',
    hub_calcium_vitamine_d_title: 'Calcium & vitamine D',
    hub_calcium_vitamine_d_desc: 'Vos besoins journaliers recommandés selon votre âge et votre situation.',
    hub_calcium_vitamine_d_cta: 'Voir mes besoins',
    hub_ovulation_title: "Calculateur d'ovulation",
    hub_ovulation_desc: 'Estimez votre période de fertilité et la date de vos prochaines règles.',
    hub_ovulation_cta: 'Calculer',
    hub_grossesse_title: 'Suivi de grossesse',
    hub_grossesse_desc: "Estimez votre date d'accouchement et suivez l'avancement de votre grossesse.",
    hub_grossesse_cta: 'Suivre ma grossesse',
    hub_prise_poids_grossesse_title: 'Prise de poids gestationnelle',
    hub_prise_poids_grossesse_desc: 'Repères de prise de poids pendant la grossesse selon votre IMC de départ.',
    hub_prise_poids_grossesse_cta: 'Vérifier',
    hub_bilan_prenuptial_title: 'Certificat médical prénuptial',
    hub_bilan_prenuptial_desc: "Ce que prévoit la réglementation algérienne : examens, validité, vos droits.",
    hub_bilan_prenuptial_cta: 'En savoir plus',
    hub_stress_title: 'Auto-questionnaire de stress',
    hub_stress_desc: 'Un repère indicatif sur votre niveau de stress au quotidien.',
    hub_stress_cta: 'Faire le test',
    hub_cycles_sommeil_title: 'Cycles de sommeil',
    hub_cycles_sommeil_desc: "Trouvez l'heure idéale pour vous coucher ou vous réveiller.",
    hub_cycles_sommeil_cta: 'Calculer',
    hub_perception_couleurs_title: 'Auto-test de perception des couleurs',
    hub_perception_couleurs_desc: 'Un repère préliminaire et ludique — pas un diagnostic de daltonisme.',
    hub_perception_couleurs_cta: 'Faire le test',
    hub_doublons_medicaments_title: 'Doublons de médicaments',
    hub_doublons_medicaments_desc: 'Vérifiez si plusieurs médicaments que vous prenez partagent le même principe actif.',
    hub_doublons_medicaments_cta: 'Vérifier',
    hub_simulateur_cnas_title: 'Simulateur de remboursement CNAS/CASNOS',
    hub_simulateur_cnas_desc: 'Une estimation indicative de votre remboursement selon le type de soins.',
    hub_simulateur_cnas_cta: 'Simuler',
    hub_conge_maternite_title: 'Congé maternité et arrêt maladie',
    hub_conge_maternite_desc: "Durée et indemnisation selon la loi 25-08 et le régime général de la CNAS.",
    hub_conge_maternite_cta: 'Voir mes dates',
    // Page Incendies 2026
    incendies_page_title: 'Solidarité incendies 2026',
    incendies_hero_title: "Tabbibak est de tout cœur avec l'Algérie",
    incendies_hero_text: "Nos pensées vont aux familles touchées par les incendies à Jijel, Béjaïa, Tizi-Ouzou et dans les autres wilayas frappées ces derniers jours, ainsi qu'à toutes les équipes de la Protection Civile mobilisées sur le terrain.",
    incendies_donate_btn: 'Faire un don au Croissant-Rouge Algérien',
    incendies_emergency_title: "Numéros d'urgence utiles",
    incendies_emergency_pc: 'Protection Civile',
    incendies_emergency_samu: 'SAMU',
    incendies_emergency_police: 'Police',
    incendies_emergency_gendarmerie: 'Gendarmerie Nationale',
    incendies_safety_title: 'Conseils de prévention et de sécurité',
    incendies_safety_alert_title: '⚠️ Si un feu menace directement votre habitation',
    incendies_safety_alert_text: "La Protection Civile recommande une évacuation volontaire et préventive immédiate dès qu'un feu approche de votre zone, sans attendre un ordre officiel. Coopérez pleinement avec les équipes de secours sur place.",
    incendies_before_title: 'Avant / Prévention',
    incendies_before_1: 'Signalez immédiatement tout départ de feu ou comportement suspect au 14',
    incendies_before_2: 'Ne faites aucun brûlage en période de vent fort ou de forte chaleur',
    incendies_before_3: "N'entreposez pas de bois, fuel ou bonbonnes de gaz contre l'habitation",
    incendies_before_4: "Équipez votre conduit de cheminée d'un grillage anti-braises",
    incendies_before_5: 'Débroussaillez les abords immédiats de votre logement si possible',
    incendies_during_title: 'En cas de fumée / feu proche',
    incendies_during_1: 'Protégez-vous des fumées avec un linge humide sur le nez et la bouche',
    incendies_during_2: 'Évitez tout effort physique intense, surtout pour les personnes âgées ou asthmatiques',
    incendies_during_3: "Fermez portes, fenêtres et ventilations si vous restez à l'intérieur",
    incendies_during_4: "Dégagez les routes pour laisser passer les secours, n'y stationnez pas par curiosité",
    incendies_during_5: 'Gardez votre téléphone disponible pour les secours, limitez les appels non essentiels',
    incendies_doctors_title: 'Médecins disponibles dans les wilayas touchées',
    incendies_doctors_subtitle: "Besoin d'un médecin à Jijel, Béjaïa ou Tizi-Ouzou ? Voici une sélection de professionnels de santé disponibles sur Tabbibak.",
    incendies_see_all: 'Voir tous les médecins →',
    incendies_no_doctors: 'Aucun médecin trouvé pour le moment à',
  },

  ar: {
    // Navbar
    nav_search: 'ابحث عن طبيب',
    nav_about: 'حول',
    nav_favorites: 'المفضلة',
    nav_my_favorites: 'أطبائي المفضلون',
    nav_settings: 'الإعدادات',
    nav_login: 'تسجيل الدخول',
    nav_register: 'إنشاء حساب',
    nav_logout: 'تسجيل الخروج',
    nav_admin: 'الإدارة',
    nav_doctor_cabinet: 'عيادتي',
    nav_appointments: 'مواعيدي',
    nav_dashboard: 'لوحة التحكم',
    role_admin: 'مسؤول',
    role_doctor: 'طبيب',
    role_patient: 'مريض',

    // Home Hero
    hero_badge: 'أطباء متاحون',
    hero_title_1: 'ابحث عن طبيبك في ',
    hero_title_highlight: 'الجزائر',
    hero_subtitle: 'احجز موعدك عبر الإنترنت مع أطباء مؤهلين في 69 ولاية. بسيط، سريع ومجاني.',
    hero_search_btn: 'ابحث عن طبيب',
    hero_free: 'مجاني',
    hero_24h: '24/24',
    hero_verified: 'موثق',
    hero_next_rdv: 'حجز المواعيد',
    hero_today: 'متاح 24/7',
    hero_reviews: 'آراء المرضى',
    hero_excellent: 'ممتاز',

    // Téléconsultation - mise en avant page d'accueil
    home_video_badge: 'جديد',
    home_video_title: 'استشر طبيبًا بالفيديو، دون مغادرة منزلك',
    home_video_desc: 'تتيح لك الاستشارة عن بعد التواصل المباشر مع الطبيب عبر مكالمة فيديو آمنة، عندما لا يكون التنقل ضروريًا. احجز موعد فيديو في خطوات قليلة.',
    home_video_cta: 'ابحث عن طبيب يقدم الاستشارة عن بعد',
    home_video_benefit1_title: 'وفّر وقتك',
    home_video_benefit1_desc: 'دون تنقل أو انتظار: استشر طبيبك من منزلك في موعدك المحدد.',
    home_video_benefit2_title: 'مكالمة فيديو آمنة',
    home_video_benefit2_desc: 'تتم الاستشارة عبر مكالمة فيديو خاصة، لا يمكن الوصول إليها إلا لك وللطبيب.',
    home_video_benefit3_title: 'حسب الطبيب',
    home_video_benefit3_desc: 'تُقدَّم الاستشارة عن بعد من طرف الأطباء الذين يفعّلونها في ملفهم الشخصي.',

    // Home Search Form
    search_specialty: 'التخصص',
    search_all_specialties: 'الكل',
    search_wilaya: 'الولاية',
    search_all_wilayas: 'الكل',
    search_doctor_name: 'اسم الطبيب',
    search_daira: 'الدائرة',
    search_all_dairas: 'الكل',
    search_btn: 'ابحث عن طبيب',

    // Home Stats
    stats_wilayas: 'ولاية مغطاة',
    stats_doctors: 'أطباء مسجلون',
    stats_specialties: 'تخصص',
    stats_available: 'متاح',

    // Home How it works
    how_title: 'كيف يعمل؟',
    how_subtitle: 'ثلاث خطوات بسيطة لحجز موعد',
    how_step1_title: 'ابحث',
    how_step1_desc: 'ابحث عن طبيب حسب التخصص، الولاية أو الاسم',
    how_step2_title: 'احجز',
    how_step2_desc: 'اختر موعدًا متاحًا وأكد',
    how_step3_title: 'استشر',
    how_step3_desc: 'توجه إلى طبيبك في الموعد المحدد',

    // Home Featured
    featured_title: 'أطباؤنا',
    featured_subtitle: 'أفضل الممارسين في خدمتكم',
    featured_see_all: 'عرض جميع الأطباء',

    // Home Doctor CTA
    cta_doctor_title: 'هل أنت طبيب؟',
    cta_doctor_subtitle: 'انضم إلى أكبر منصة طبية في الجزائر وطوّر عيادتك.',
    cta_free: 'تسجيل مجاني',
    cta_online: 'إدارة المواعيد عبر الإنترنت',
    cta_visibility: 'الظهور في 69 ولاية',
    cta_teleconsultation: 'جديد: قدّم لمرضاك الاستشارة عن بعد بالفيديو',
    cta_btn: 'أنشئ ملفي الطبي',

    // Footer
    footer_desc: 'منصة حجز المواعيد الطبية في الجزائر. بسيط، سريع وموثوق.',
    footer_patients: 'للمرضى',
    footer_find: 'ابحث عن طبيب',
    footer_create_account: 'أنشئ حساب',
    footer_login: 'تسجيل الدخول',
    footer_doctors: 'للأطباء',
    footer_register: 'التسجيل',
    footer_access: 'الدخول للعيادة',
    footer_contact: 'اتصل بنا',
    footer_rights: 'جميع الحقوق محفوظة',

    // Search Page
    search_page_placeholder: 'ابحث عن طبيب...',
    search_page_btn: 'بحث',
    search_page_filters: 'التصفية',
    search_page_all_specialties: 'جميع التخصصات',
    search_page_all_wilayas: 'جميع الولايات',
    search_page_daira: 'الدائرة',
    search_page_all_dairas: 'جميع الدوائر',
    search_page_online_only: 'متصل فقط',
    search_page_video_only: 'الاستشارة عن بعد متاحة',
    search_page_sort: 'ترتيب حسب',
    search_page_relevance: 'الصلة',
    search_page_best_rating: 'أفضل تقييم',
    search_page_name_az: 'الاسم (أ-ي)',
    search_page_clear: 'مسح التصفية',
    search_page_searching: 'جاري البحث...',
    search_page_found: 'تم العثور',
    search_page_found_plural: 'تم العثور',
    search_page_doctor: 'طبيب',
    search_page_doctors: 'أطباء',
    search_page_no_results: 'لم يتم العثور على أطباء',
    search_page_try_different: 'حاول تعديل معايير البحث',
    search_page_prev: 'السابق',
    search_page_next: 'التالي',
    search_page_online: 'متصل',

    // Doctor Card
    card_online: 'متصل',
    card_video_consultation: 'استشارة عن بعد',
    card_phone: 'هاتف',
    card_book: 'حجز موعد',
    card_profile: 'الملف',

    // Login
    login_title: 'مرحبًا',
    login_subtitle: 'سجل دخولك إلى حسابك',
    login_email: 'البريد الإلكتروني',
    login_password: 'كلمة المرور',
    login_btn: 'تسجيل الدخول',
    login_loading: 'جاري التسجيل...',
    login_or: 'أو',
    login_google: 'المتابعة مع Google',
    login_no_account: 'ليس لديك حساب؟',
    login_register: 'إنشاء حساب',
    login_forgot: 'نسيت كلمة المرور؟',
    login_doctor: 'هل أنت طبيب؟ سجل هنا',
    login_success: 'تم تسجيل الدخول بنجاح!',
    login_error: 'حدث خطأ. يرجى المحاولة مرة أخرى.',

    // Register
    register_title: 'إنشاء حساب',
    register_subtitle: 'سجل لحجز مواعيدك عبر الإنترنت',
    register_name: 'الاسم الكامل',
    register_name_placeholder: 'اسمك',
    register_first_name: 'الاسم الأول',
    register_first_name_placeholder: 'اسمك الأول',
    register_last_name: 'اللقب',
    register_last_name_placeholder: 'لقبك',
    register_names_identical: 'لا يمكن أن يكون الاسم الأول مطابقًا للقب',
    register_phone_invalid: 'رقم الهاتف غير صحيح',
    register_email: 'البريد الإلكتروني',
    register_phone: 'الهاتف',
    register_password: 'كلمة المرور',
    register_confirm: 'تأكيد كلمة المرور',
    register_btn: 'إنشاء حساب',
    register_loading: 'جاري التسجيل...',
    register_or: 'أو',
    register_google: 'المتابعة مع Google',
    register_has_account: 'لديك حساب بالفعل؟',
    register_login: 'تسجيل الدخول',
    register_success: 'تم التسجيل بنجاح!',
    register_password_mismatch: 'كلمتا المرور غير متطابقتين',
    register_password_short: 'يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل',
    register_password_no_uppercase: 'يجب أن تحتوي كلمة المرور على حرف كبير على الأقل',
    register_password_no_lowercase: 'يجب أن تحتوي كلمة المرور على حرف صغير على الأقل',
    register_password_no_digit: 'يجب أن تحتوي كلمة المرور على رقم واحد على الأقل',
    register_password_rules: '8 أحرف على الأقل، تحتوي على حرف كبير وحرف صغير ورقم',

    // Favorites
    fav_title: 'أطبائي المفضلون',
    fav_subtitle: 'اعثر بسهولة على أطبائك المفضلين',
    fav_login: 'سجّل دخولك',
    fav_login_desc: 'أنشئ حسابًا لحفظ أطبائك المفضلين',
    fav_empty: 'لا توجد مفضلات',
    fav_empty_desc: 'أضف أطباء بالنقر على القلب في ملفاتهم',
    fav_toggle_error: 'حدث خطأ، يرجى إعادة المحاولة.',

    // About
    about_badge: 'قصتنا',
    about_title_1: 'جعل الصحة في متناول ',
    about_title_highlight: 'جميع الجزائريين',
    about_subtitle: 'وُلد Tabbibak.dz من ملاحظة بسيطة: إيجاد طبيب جيد في الجزائر لا ينبغي أن يكون معركة. مهمتنا هي ربط كل مريض بالطبيب المناسب، في ولايته، بنقرات قليلة.',
    about_search_btn: 'ابحث عن طبيب',
    about_doctor_btn: 'انضم كطبيب',
    about_mission_title: 'مهمتنا',
    about_mission_desc: 'إتاحة الوصول إلى الرعاية الصحية في الجزائر من خلال منصة حديثة ومجانية تتيح لكل مواطن العثور على طبيب مؤهل وتقييمه وحجز موعد معه، بغض النظر عن ولايته.',
    about_vision_title: 'رؤيتنا',
    about_vision_desc: 'أن نصبح مرجع الصحة الرقمية في الجزائر بحلول 2030. بلد يمكن فيه لكل مريض الوصول إلى رعاية صحية عالية الجودة في دقائق، ولكل طبيب أدوات حديثة لإدارة عيادته.',
    about_values_title: 'قيمنا',
    about_values_subtitle: 'ما يوجهنا يوميًا',
    about_val1_title: 'الرعاية',
    about_val1_desc: 'كل مريض يستحق الاهتمام والاحترام في مسار علاجه.',
    about_val2_title: 'الثقة',
    about_val2_desc: 'أطباء موثقون، آراء حقيقية، بيانات محمية.',
    about_val3_title: 'القرب',
    about_val3_desc: 'شبكة أطباء في 69 ولاية جزائرية.',
    about_val4_title: 'البساطة',
    about_val4_desc: 'ابحث واحجز في أقل من دقيقتين، بدون مكالمة هاتفية.',
    about_stats_wilayas: 'ولاية مغطاة',
    about_stats_specialties: 'تخصص طبي',
    about_stats_free: 'مجاني للمرضى',
    about_stats_online: 'متاح عبر الإنترنت',
    about_faq_title: 'الأسئلة الشائعة',
    about_faq1_q: 'هل Tabbibak.dz مجاني؟',
    about_faq1_a: 'نعم، المنصة مجانية تمامًا للمرضى. الأطباء يستفيدون أيضًا من تسجيل مجاني.',
    about_faq2_q: 'كيف يتم التحقق من الأطباء؟',
    about_faq2_a: 'كل طبيب مسجل يمر بعملية تحقق من فريقنا. نتحقق من رقم الترخيص والمؤهلات.',
    about_faq3_q: 'هل يمكنني إلغاء موعد؟',
    about_faq3_a: 'نعم، يمكنك إلغاء أو إعادة جدولة موعد في أي وقت من لوحة التحكم الخاصة بك.',
    about_faq4_q: 'ما هي الولايات المغطاة؟',
    about_faq4_a: 'يغطي Tabbibak.dz 69 ولاية في الجزائر. نضيف أطباء جدد كل أسبوع.',
    about_cta_title: 'مستعد لإيجاد طبيبك؟',
    about_cta_subtitle: 'انضم إلى آلاف الجزائريين الذين يستخدمون Tabbibak.dz للعناية بصحتهم.',
    about_cta_search: 'ابحث عن طبيب',
    about_cta_register: 'أنشئ حسابًا مجانيًا',
    about_footer_desc: 'منصة حجز المواعيد الطبية في الجزائر.',

    // Admin Dashboard
    admin_title: 'لوحة الإدارة',
    admin_subtitle: 'إدارة الأطباء والمستخدمين',
    admin_add_doctor: 'إضافة طبيب',
    admin_patients: 'المرضى',
    admin_registered: 'أطباء مسجلون',
    admin_listed: 'أطباء مُدرجون',
    admin_pending: 'قيد الانتظار',
    admin_tab_pending: 'قيد الانتظار',
    admin_tab_doctors: 'جميع الأطباء',
    admin_tab_users: 'المستخدمون',
    admin_tab_patient_users: 'المرضى',
    admin_tab_doctor_users: 'الأطباء',
    admin_no_patient_users: 'لا يوجد مرضى مسجلون',
    admin_no_doctor_users: 'لا يوجد أطباء مسجلون',
    admin_tab_analytics: 'التحليلات',
    admin_no_pending: 'لا توجد طلبات قيد الانتظار',
    admin_doctor: 'الطبيب',
    admin_specialty: 'التخصص',
    admin_wilaya: 'الولاية',
    admin_license: 'الترخيص',
    admin_actions: 'الإجراءات',
    admin_type: 'النوع',
    admin_status: 'الحالة',
    admin_user: 'المستخدم',
    admin_email: 'البريد الإلكتروني',
    admin_phone: 'الهاتف',
    admin_role: 'الدور',
    admin_online: 'متصل',
    admin_phone_type: 'هاتف',
    admin_approved: 'معتمد',
    admin_pending_status: 'قيد الانتظار',
    admin_listed_status: 'مُدرج',
    admin_rejected: 'مرفوض',
    admin_confirm_delete: 'هل أنت متأكد من حذف هذا الطبيب؟',
    admin_hide_doctor: 'إخفاء هذه البطاقة من الموقع',
    admin_unhide_doctor: 'إظهار هذه البطاقة على الموقع',
    admin_confirm_hide: 'إخفاء هذه البطاقة؟ ستختفي من الموقع (البحث والقوائم والرابط المباشر وحجز المواعيد) مع الاحتفاظ بها في قاعدة البيانات ومصدرها. يمكنك إظهارها مجددًا في أي وقت.',
    admin_confirm_unhide: 'إظهار هذه البطاقة على الموقع؟',
    admin_add_title: 'إضافة طبيب إلى الدليل',
    admin_add_desc: 'سيكون هذا الطبيب مرئيًا برقم هاتفه فقط',
    admin_name: 'الاسم الكامل',
    admin_address: 'العنوان',
    admin_fees: 'الأتعاب (دج، اختياري)',
    admin_cancel: 'إلغاء',
    admin_submit: 'إضافة',
    admin_submitting: 'جاري الإضافة...',
    admin_chart_specialty: 'الأطباء حسب التخصص',
    admin_chart_appointments: 'المواعيد',
    admin_chart_overview: 'نظرة عامة',
    admin_total_appointments: 'إجمالي المواعيد',

    // Patient Dashboard
    patient_hello: 'مرحبًا،',
    patient_subtitle: 'إدارة مواعيدك الطبية',
    patient_need_apt: 'تحتاج موعد؟',
    patient_find_doc: 'ابحث عن طبيب واحجز عبر الإنترنت',
    patient_find_btn: 'ابحث عن طبيب',
    patient_upcoming: 'القادمة',
    patient_history: 'السجل',
    patient_cancelled: 'الملغاة',
    patient_prescriptions: 'الوصفات الطبية',
    patient_no_prescriptions: 'لا توجد وصفات طبية حاليا',
    patient_no_prescriptions_desc: 'ستظهر هنا الوصفات الطبية التي يرسلها أطباؤك.',
    patient_prescription_view_btn: 'عرض / تنزيل',
    pdash_prescription_err_open: 'خطأ أثناء فتح الوصفة الطبية',
    patient_confirmed: 'مؤكد',
    patient_pending: 'قيد الانتظار',
    patient_cancelled_status: 'ملغى',
    patient_completed: 'مكتمل',
    patient_past_unresolved: 'موعد سابق',
    patient_no_show: 'لم يتم الحضور',
    patient_reason: 'السبب',
    patient_reschedule: 'إعادة جدولة',
    patient_cancel: 'إلغاء',
    patient_no_upcoming: 'لا توجد مواعيد قادمة',
    patient_no_upcoming_desc: 'ابحث عن طبيب لحجز موعد',
    patient_no_history: 'لا يوجد سجل',
    patient_no_cancelled: 'لا توجد مواعيد ملغاة',
    patient_cancel_title: 'إلغاء الموعد',
    patient_cancel_desc: 'هل أنت متأكد من إلغاء هذا الموعد؟ لا يمكن التراجع.',
    patient_keep: 'لا، احتفظ',
    patient_yes_cancel: 'نعم، إلغاء',
    patient_cancelling: 'جاري الإلغاء...',
    patient_reschedule_title: 'إعادة جدولة الموعد',
    patient_reschedule_desc: 'اختر تاريخًا ووقتًا جديدين',
    patient_available_slots: 'المواعيد المتاحة',
    patient_select_date: 'اختر تاريخًا',
    patient_no_slots: 'لا توجد مواعيد متاحة',
    patient_confirm: 'تأكيد',
    patient_rescheduling: 'جاري الإعادة...',

    // Patient Dashboard - notifications, salle d'attente, avis
    pdash_your_turn: 'حان دورك، يرجى التوجه إلى العيادة.',
    pdash_doctor_calling_toast: '📢 الطبيب ينادي عليك!',
    pdash_doctor_calling_alert: 'الطبيب ينادي عليك!',
    pdash_new_apt_toast: '📅 موعد جديد!',
    pdash_apt_moved_toast: '🔄 تم تغيير الموعد',
    pdash_apt_cancelled_toast: '❌ تم إلغاء الموعد',
    pdash_apt_confirmed_toast: '✅ تم تأكيد الموعد',
    pdash_presence_signaled_toast: '✅ تم إعلام الطبيب بحضورك!',
    pdash_signal_error: 'خطأ أثناء الإعلام عن الحضور',
    pdash_review_comment_required: 'يرجى كتابة تعليق',
    pdash_review_published_toast: '✅ تم نشر رأيك!',
    pdash_review_publish_error: 'خطأ أثناء النشر',
    pdash_apt_scheduled_by_doctor: 'تم تحديد الموعد من قبل طبيبك',
    pdash_apt_rescheduled_by_doctor: 'تم تغيير موعدك من قبل طبيبك',
    pdash_waiting_room_prompt: '🏥 هل أنت في غرفة الانتظار؟ أعلم الطبيب بحضورك.',
    pdash_presence_signaled_confirm: '✅ تم الإعلان عن حضورك — تم إخطار الطبيب',
    pdash_im_in_waiting_room: 'أنا في غرفة الانتظار',
    pdash_checkin_too_late: 'انتهت مهلة الإعلان عن حضورك (تأخير يفوق 30 دقيقة). يرجى الاتصال مباشرة بالعيادة.',
    pdash_checkin_available_prefix: 'يمكنك الإعلان عن حضورك ابتداءً من 30 دقيقة قبل موعدك',
    pdash_video_waiting_room_prompt: '📹 هل أنت جاهز لاستشارتك المرئية؟ أعلم الطبيب بجاهزيتك.',
    pdash_video_presence_signaled_confirm: '✅ أنت في غرفة الانتظار الافتراضية — تم إخطار الطبيب',
    pdash_im_ready_video: 'أنا جاهز لاستشارتي المرئية',
    pdash_video_checkin_too_late: 'انتهت مهلة الإعلان عن جاهزيتك (تأخير يفوق 30 دقيقة). يرجى الاتصال مباشرة بالعيادة.',
    pdash_video_checkin_available_prefix: 'يمكنك الإعلان عن جاهزيتك ابتداءً من 30 دقيقة قبل استشارتك المرئية',
    pdash_cancel_reschedule_closed: 'لم يعد بالإمكان إلغاء أو إعادة جدولة الموعد قبل أقل من 24 ساعة منه. يرجى الاتصال مباشرة بالعيادة.',
    pdash_this_doctor: 'هذا الطبيب',
    pdash_leave_review: 'ترك رأي',
    // Correctif (idee CGM/ClickDoc) : informations pre-consultation renseignees par le patient
    pdash_pre_visit_button: 'أكمل معلوماتي قبل الاستشارة',
    pdash_pre_visit_button_done: 'عدّل معلوماتي قبل الاستشارة',
    pdash_pre_visit_filled_badge: '✅ تم إرسال المعلومات إلى الطبيب',
    pdash_pre_visit_title: 'معلومات قبل الاستشارة',
    pdash_pre_visit_desc: 'ستكون هذه المعلومات مرئية للطبيب قبل موعدك، لكسب الوقت.',
    pdash_pre_visit_allergies_label: 'الحساسية المعروفة',
    pdash_pre_visit_allergies_placeholder: 'مثال: البنسلين، الفول السوداني... (اتركه فارغًا إذا لم توجد)',
    pdash_pre_visit_medications_label: 'العلاجات الحالية',
    pdash_pre_visit_medications_placeholder: 'الأدوية التي تتناولها حاليًا',
    pdash_pre_visit_notes_label: 'معلومات إضافية',
    pdash_pre_visit_notes_placeholder: 'أي معلومة أخرى مفيدة للطبيب',
    pdash_pre_visit_save: 'حفظ',
    pdash_pre_visit_saving: 'جارٍ الحفظ...',
    pdash_pre_visit_saved_toast: 'تم حفظ المعلومات',
    pdash_pre_visit_save_error: 'خطأ أثناء الحفظ',
    pdash_join_video_btn: 'الانضمام إلى الاستشارة المرئية',
    pdash_join_video_too_early: 'متاح ابتداءً من {time}',
    pdash_video_dialog_title: 'استشارة مرئية',
    pdash_video_join_error: 'تعذّر الانضمام إلى الاستشارة المرئية، يرجى إعادة المحاولة.',
    // Correctif (v2, cases a cocher) : sections et libelles "autre" du formulaire
    pdash_pre_visit_context_label: 'سبب الزيارة',
    pdash_pre_visit_other_label: 'أخرى / توضيحات',
    pdash_pre_visit_allergies_other_placeholder: 'حساسية أخرى غير مذكورة...',
    pdash_pre_visit_medications_other_placeholder: 'علاج آخر غير مذكور...',
    pdash_pre_visit_context_other_placeholder: 'أي توضيح آخر مفيد للطبيب...',
    // Correctif (v2) : options a cocher — allergies
    pv_allergy_penicillin: 'البنسلين / المضادات الحيوية',
    pv_allergy_aspirin_nsaid: 'الأسبرين / مضادات الالتهاب',
    pv_allergy_latex: 'اللاتكس',
    pv_allergy_iodine: 'اليود / مواد التباين',
    pv_allergy_nuts: 'الفول السوداني / المكسرات',
    pv_allergy_sulfa: 'السلفوناميدات',
    pv_allergy_anesthesia: 'التخدير الموضعي',
    pv_allergy_insects: 'لدغات الحشرات',
    pv_allergy_none: 'لا توجد حساسية معروفة',
    // Correctif (v2) : options a cocher — traitements en cours
    pv_med_anticoagulants: 'مضادات التخثر / مضادات الصفيحات',
    pv_med_antidiabetics: 'أدوية السكري (بما فيها الأنسولين)',
    pv_med_antihypertensives: 'أدوية ضغط الدم',
    pv_med_corticosteroids: 'الكورتيزون',
    pv_med_anticonvulsants: 'مضادات الاختلاج',
    pv_med_heart: 'علاج القلب',
    pv_med_psychiatric: 'علاج نفسي / مهدئات',
    pv_med_contraception: 'وسائل منع الحمل الهرمونية',
    pv_med_none: 'لا يوجد علاج حالي',
    // Correctif (v2) : options a cocher — motif de la visite
    pv_ctx_first_visit: 'أول استشارة مع هذا الطبيب',
    pv_ctx_followup: 'متابعة معتادة',
    pv_ctx_pregnant: 'حامل حاليًا',
    pv_ctx_exam_results: 'أحضر نتائج فحوصات (أشعة، تحاليل...)',
    pv_ctx_certificate: 'بحاجة لشهادة طبية',
    pv_ctx_urgent: 'ألم شديد / حالة طارئة',
    pv_ctx_renewal: 'تجديد الوصفة الطبية فقط',
    pdash_notifications: 'الإشعارات',
    pdash_no_notifications: 'لا توجد إشعارات',
    pdash_notification_singular: 'إشعار',
    pdash_review_about: 'رأيك حول الدكتور',
    pdash_rating_label: 'التقييم',
    pdash_comment_label: 'التعليق',
    pdash_describe_experience: 'صف تجربتك...',
    pdash_publishing: 'جاري النشر...',
    pdash_publish: 'نشر',

    // Doctor Dashboard
    doc_title: 'لوحة التحكم',
    doc_subtitle: 'إدارة مواعيدك وتوافرك',
    doc_pending_approval: 'قيد الموافقة',
    doc_active: 'الملف نشط',
    doc_today: 'مواعيد اليوم',
    doc_total: 'إجمالي المواعيد',
    doc_pending_count: 'قيد الانتظار',
    doc_tab_appointments: 'المواعيد',
    doc_tab_schedule: 'الجدول',
    doc_tab_profile: 'ملفي',
    doc_upcoming: 'المواعيد القادمة',
    doc_no_upcoming: 'لا توجد مواعيد قادمة',
    doc_edit: 'تعديل',
    doc_save: 'حفظ',
    doc_saving: 'جاري الحفظ...',
    doc_cancel: 'إلغاء',
    doc_availability: 'توافري',
    doc_my_profile: 'ملفي',
    doc_photo_url: 'رابط الصورة',
    doc_phone: 'الهاتف',
    doc_fees: 'الأتعاب (دج)',
    doc_address: 'العنوان',
    doc_education: 'التعليم',
    doc_bio: 'نبذة / السيرة',
    doc_languages: 'اللغات',
    doc_insurance: 'التأمينات المقبولة',
    doc_add_language: 'إضافة لغة',
    doc_add_insurance: 'إضافة تأمين',
    doc_complete_profile: 'أكمل ملفك لجذب المزيد من المرضى',
    doc_add_info: 'أضف سيرة، تعليم، لغات...',
    doc_license: 'رقم الترخيص',
    doc_rating: 'تقييم',
    doc_status_title: 'تغيير الحالة',
    doc_status_desc: 'تغيير حالة الموعد مع',
    doc_confirmed: 'مؤكد',
    doc_completed: 'مكتمل',
    doc_payment_pending_badge: '💳 بانتظار الدفع',
    doc_payment_reference_label: 'مرجع التحويل',
    doc_cancelled: 'ملغى',

    // Doctor Dashboard — full i18n catch-up pass
    doc_notifications_title: 'الإشعارات',
    doc_mark_all_read: 'تحديد الكل كمقروء',
    doc_no_notification: 'لا توجد إشعارات',
    doc_day_word: 'يوم',
    doc_days_word: 'أيام',
    doc_remaining_word: 'متبقٍ',
    doc_remaining_days_word: 'متبقية',
    doc_trial_urgent_prefix: '⚠️ تجربة مجانية — تبقى',
    doc_trial_active_prefix: '✅ فترة تجريبية مجانية —',
    doc_trial_price_notice: 'بعد الفترة التجريبية، اشترك بمبلغ 2500 دج/شهر لمواصلة استقبال المواعيد عبر الإنترنت.',
    doc_subscribe_btn: 'اشترك',
    doc_sub_active_prefix: '✅ الاشتراك نشط —',
    doc_sub_expired_title: '🔴 انتهى الاشتراك — تم تعطيل الحجز عبر الإنترنت',
    doc_sub_expired_subtitle: 'يبقى ملفك مرئيًا لكن لم يعد بإمكان المرضى الحجز عبر الإنترنت.',
    doc_renew_btn: 'تجديد',
    doc_revenue_7d_title: 'الإيرادات - آخر 7 أيام',
    doc_revenue_total_7d: 'إجمالي 7 أيام',
    doc_revenue_avg_day: 'المعدل/يوم',
    doc_revenue_best_day: 'أفضل يوم',
    doc_this_month: 'هذا الشهر',
    doc_stats_completed: '✓ مكتملة',
    doc_stats_confirmed: '⏳ مؤكدة',
    doc_stats_cancelled: '✕ ملغاة',
    doc_revenue_label: 'الإيرادات',
    doc_stats_monthly_revenue_title: 'الإيرادات — آخر 6 أشهر',
    doc_stats_patient_mix_title: 'توزيع المرضى',
    doc_stats_new_patients: 'مرضى جدد',
    doc_stats_returning_patients: 'مرضى متكررون',
    doc_stats_attendance_title: 'معدل الحضور — آخر 6 أشهر',
    doc_stats_attendance_rate: 'معدل الحضور',
    doc_stats_no_data: 'لا توجد بيانات كافية بعد لهذا الرسم البياني',
    doc_calendar_today_btn: 'اليوم',
    doc_total_this_month: 'إجمالي هذا الشهر',
    doc_per_consultation: 'لكل استشارة',
    doc_completion_rate: 'معدل الإنجاز',
    doc_sub_info_unavailable: 'معلومات الاشتراك غير متوفرة',
    doc_sub_status_trial: 'فترة تجريبية',
    doc_sub_status_active: 'نشط',
    doc_sub_status_expired: 'منتهي',
    doc_my_subscription: 'اشتراكي',
    doc_trial_end_label: 'نهاية الفترة التجريبية',
    doc_subscribed_until_label: 'مشترك حتى',
    doc_monthly_price_label: 'السعر الشهري',
    doc_da_per_month: 'دج / شهر',
    doc_choose_payment_method: 'اختر طريقة الدفع',
    doc_price_no_commitment: '2500 دج / شهر — بدون التزام',
    doc_card_cib: 'بطاقة CIB',
    doc_secure_online_payment: 'دفع آمن عبر الإنترنت',
    doc_via_chargily: 'عبر Chargily Pay',
    doc_pay_by_cib: 'الدفع عبر CIB',
    doc_payment_via_app: 'الدفع عبر التطبيق',
    doc_pay_by_baridimob: 'الدفع عبر BaridiMob',
    doc_bank_transfer: 'تحويل بنكي',
    doc_activation_24h: 'التفعيل خلال 24 ساعة',
    doc_bank_label: 'البنك :',
    doc_holder_label: 'صاحب الحساب :',
    doc_rib_label: 'RIB :',
    doc_amount_label: 'المبلغ :',
    doc_reason_label: 'السبب :',
    doc_motif_value: 'اشتراك + بريدك الإلكتروني',
    doc_send_receipt_to: 'أرسل الإيصال إلى',
    doc_whats_included: '✅ ما هو مشمول',
    doc_incl_online_booking: '✅ حجز عبر الإنترنت من طرف المرضى',
    doc_incl_full_dashboard: '✅ لوحة تحكم كاملة للطبيب',
    doc_incl_appointment_mgmt: '✅ إدارة المواعيد والجدول الزمني',
    doc_incl_stats_revenue: '✅ الإحصائيات والإيرادات',
    doc_incl_visible_profile: '✅ ملف مرئي على Tabbibak.dz',
    doc_incl_priority_support: '✅ دعم تقني ذو أولوية',
    doc_rescheduled_by_doctor: '🔄 أعاد الطبيب جدولته',
    doc_no_show_badge: '⚠ لم يُحترم',
    // Correctif (idee CGM/ClickDoc) : infos pre-consultation renseignees par le patient, visibles au medecin
    doc_pre_visit_allergies: 'الحساسية',
    doc_pre_visit_medications: 'العلاجات الحالية',
    doc_reschedule_btn: 'تأجيل',
    doc_name_required: 'الاسم إلزامي',
    doc_patient_added: 'تمت إضافة المريض',
    doc_err_add_patient: 'خطأ أثناء إضافة المريض',
    doc_err_load_record: 'خطأ أثناء تحميل ملف المريض',
    doc_patient_called: 'تم استدعاء المريض',
    doc_error_generic: 'خطأ',
    doc_consultation_done: 'انتهت الاستشارة',
    doc_record_updated: 'تم تحديث الملف',
    doc_err_save: 'خطأ أثناء الحفظ',
    doc_note_added: 'تمت إضافة الملاحظة',
    doc_note_deleted: 'تم حذف الملاحظة',
    doc_type_value_required: 'النوع والقيمة مطلوبان',
    doc_measurement_added: 'تمت إضافة القياس',
    doc_err_add_measurement: 'خطأ أثناء إضافة القياس',
    doc_measurement_deleted: 'تم حذف القياس',
    doc_choose_date_time: 'يرجى اختيار تاريخ ووقت',
    doc_appointment_booked: '✅ تمت برمجة الموعد — تم إشعار المريض عبر البريد الإلكتروني',
    doc_err_booking: 'خطأ أثناء البرمجة',
    doc_patient_removed: 'تمت إزالة المريض من قائمتك',
    doc_err_delete: 'خطأ أثناء الحذف',
    doc_add_at_least_one_med: 'أضف دواءً واحدًا على الأقل',
    doc_dosage_freq_required: 'الجرعة والتردد إلزاميان لكل دواء',
    doc_err_generate_cert: 'تعذر إنشاء شهادة الوصفة',
    doc_prescription_ready: 'الوصفة جاهزة للطباعة !',
    doc_subject_message_required: 'الموضوع والرسالة مطلوبان',
    doc_recipient_required: 'المستلم مطلوب',
    doc_message_sent: '✅ تم إرسال الرسالة بنجاح !',
    doc_err_send_message: 'خطأ في إرسال الرسالة',
    doc_file_too_large: 'الملف كبير جدًا (الحد الأقصى 10 ميغابايت)',
    doc_file_added_prefix: '✅ الملف',
    doc_file_added_suffix: 'تمت إضافته',
    doc_confirm_delete_message: 'حذف هذه الرسالة؟',
    doc_message_deleted: 'تم حذف الرسالة',
    doc_err_deletion: 'خطأ في الحذف',
    doc_use_bank_transfer_notice: 'استخدم التحويل البنكي أو تواصل معنا للاشتراك',
    doc_appointment_rescheduled: 'تم تأجيل الموعد — تم إشعار المريض عبر البريد الإلكتروني',
    doc_err_reschedule: 'خطأ أثناء التأجيل',
    doc_patient_fallback: 'مريض',
    doc_at_time: 'في',
    doc_schedule_warning_prefix: 'تنبيه :',
    doc_schedule_warning_mid: 'موعد (مواعيد) مؤكد بالفعل يقع في فترة زمنية أغلقتها للتو :',
    doc_schedule_warning_suffix: 'لن يتم إلغاء هذه المواعيد تلقائيًا — يرجى التفكير في الاتصال بهؤلاء المرضى عند الحاجة. متابعة؟',
    doc_metric_confirmed: 'مؤكدة',
    doc_metric_revenue_month: 'إيرادات الشهر',
    doc_metric_total_patients: 'إجمالي المرضى',
    doc_metric_avg_rating: 'التقييم المتوسط',
    doc_account_pending_notice: 'حسابك في انتظار التحقق من قبل فريقنا. أكمل ملفك أدناه لتسريع عملية التحقق — ستكون المواعيد وغرفة الانتظار والمرضى والإحصائيات والمراسلة متاحة بمجرد الموافقة على حسابك.',
    doc_tab_waiting_room: '🏥 غرفة الانتظار',
    doc_tab_patients: '👥 المرضى',
    doc_tab_analytics: '📊 الإحصائيات',
    doc_tab_messages: 'الرسائل',
    doc_tab_subscription: 'الاشتراك',
    doc_waiting_room_title: '🏥 غرفة الانتظار — اليوم',
    doc_refresh_btn: 'تحديث',
    doc_no_patient_waiting: 'لا يوجد مرضى في غرفة الانتظار',
    doc_patients_signal_arrival: 'يقوم المرضى بالإبلاغ عن وصولهم من مساحتهم الخاصة',
    doc_waiting_video_badge: 'استشارة مرئية',
    doc_appointment_abbr: 'موعد',
    doc_in_consultation: '🟢 في الاستشارة',
    doc_arrived_prefix: 'وصل الساعة',
    doc_call_patient_btn: '📢 استدعاء',
    doc_finish_btn: '✅ إنهاء',
    doc_my_patients_prefix: '👥 مرضاي',
    doc_add_btn: 'إضافة',
    doc_no_patient_seen: 'لم يتم استقبال أي مريض',
    doc_last_visit_label: 'الأخيرة :',
    doc_visit_word: 'زيارة',
    doc_visits_word: 'زيارات',
    doc_offplatform_paren: '(خارج المنصة)',
    doc_offplatform_badge: 'خارج المنصة',
    doc_select_patient_notice: 'اختر مريضًا لعرض ملفه',
    doc_loading: 'جاري التحميل...',
    doc_book_appointment_btn: 'برمجة موعد',
    doc_delete_btn: 'حذف',
    doc_prescription_btn: 'وصفة طبية',
    doc_medical_record_title: '📋 الملف الطبي',
    doc_blood_type_label: 'فصيلة الدم',
    doc_choose_placeholder: 'اختر',
    doc_not_specified: 'غير محدد',
    doc_allergies_label: '⚠️ الحساسية',
    doc_add_placeholder: 'إضافة...',
    doc_antecedents_label: '📌 السوابق',
    doc_chronic_conditions_label: '🏥 الأمراض المزمنة',
    doc_measurements_title: '📈 القياسات',
    doc_type_label: 'النوع',
    doc_choose_type_placeholder: 'اختر نوعًا',
    doc_suggested_specialty: 'مقترح لتخصصك',
    doc_other_custom_measurement: 'أخرى (قياس مخصص)...',
    doc_measurement_name_label: 'اسم القياس',
    doc_ex_saturation_placeholder: 'مثال: التشبع',
    doc_systolic_label: 'الانقباضي',
    doc_diastolic_label: 'الانبساطي',
    doc_pain_label: 'الألم :',
    doc_value_label: 'القيمة',
    doc_ex_prefix: 'مثال:',
    doc_unit_label: 'الوحدة',
    doc_ex_kg_placeholder: 'مثال: kg',
    doc_date_label: 'التاريخ',
    doc_bmi_label: 'مؤشر كتلة الجسم :',
    doc_calculated_auto: '(محسوب تلقائيًا)',
    doc_bmi_source_prefix: 'استنادًا إلى الوزن',
    doc_bmi_source_mid: 'والطول',
    doc_no_measurement: 'لا يوجد قياس مسجل',
    doc_consultation_notes_title: '📝 ملاحظات الاستشارة',
    doc_add_note_placeholder: 'إضافة ملاحظة...',
    doc_no_note: 'لا توجد ملاحظات',
    doc_visit_history_title: '📅 سجل الزيارات',
    doc_badge_completed: '✓ مكتمل',
    doc_badge_cancelled: '✕ ملغى',
    doc_badge_confirmed: '✓ مؤكد',
    doc_badge_pending: '⏳ قيد الانتظار',
    doc_no_show_appointment_singular: 'موعد لم يُحترم',
    doc_no_show_appointments_plural: 'مواعيد لم تُحترم',
    doc_patient_already_prefix: '⚠ هذا المريض لديه بالفعل',
    doc_absence_no_cancel_suffix: '(غياب دون إلغاء).',
    doc_consultation_duration_label: 'المدة التقديرية للاستشارة',
    doc_consultation_duration_hint: 'تُستخدم لحساب وقت الانتهاء التقديري ومدة قاعة الاستشارة عبر الفيديو — لا تغيّر تباعد المواعيد أدناه (ثابت كل 30 دقيقة).',
    doc_15min: '15 دقيقة',
    doc_30min: '30 دقيقة',
    doc_45min: '45 دقيقة',
    doc_1hour: 'ساعة واحدة',
    doc_slots_word: 'فترات',
    doc_slot_type_in_person: 'العيادة فقط',
    doc_slot_type_in_person_short: 'العيادة',
    doc_slot_type_video: 'الفيديو فقط',
    doc_slot_type_video_short: 'فيديو',
    doc_slot_type_both: 'العيادة والفيديو',
    doc_slot_type_both_short: 'الاثنان',
    doc_inbox_tab: 'الواردة',
    doc_sent_tab: 'المرسلة',
    doc_new_message_btn: 'رسالة جديدة',
    doc_new_medical_message_title: '✉️ رسالة طبية جديدة',
    doc_use_template_label: 'استخدام نموذج',
    doc_choose_template_option: '-- اختر نموذجًا --',
    doc_cat_references: 'إحالات',
    doc_cat_analysis_results: 'نتائج التحاليل',
    doc_cat_imaging_results: 'نتائج التصوير',
    doc_cat_medical_opinion: 'رأي طبي',
    doc_cat_patient_followup: 'متابعة المريض',
    doc_cat_urgent: 'حالات طارئة',
    doc_cat_general: 'عام',
    doc_doctor_on_platform_label: 'طبيب على Tabbibak',
    doc_search_dr_placeholder: 'البحث عن طبيب...',
    doc_external_email_label: 'أو بريد إلكتروني خارجي',
    doc_patient_name_label: 'اسم المريض',
    doc_optional_placeholder: 'اختياري',
    doc_age_label: 'العمر',
    doc_priority_label: 'الأولوية',
    doc_priority_normal: '🟢 عادي',
    doc_priority_urgent: '🔴 عاجل',
    doc_subject_label: 'الموضوع *',
    doc_subject_placeholder: 'موضوع الرسالة',
    doc_message_label: 'الرسالة *',
    doc_write_message_placeholder: 'اكتب رسالتك...',
    doc_add_attachment: 'إضافة مرفق',
    doc_attachment_hint: 'PDF، صورة — الحد الأقصى 10 ميغابايت',
    doc_sending: 'جاري الإرسال...',
    doc_send_btn: 'إرسال',
    doc_no_message_received: 'لا توجد رسائل واردة',
    doc_no_message_sent: 'لا توجد رسائل مرسلة',
    doc_from_label: 'من:',
    doc_to_label: 'إلى:',
    doc_patient_label: 'المريض:',
    doc_years_word: 'سنة',
    doc_urgent_badge: '🚨 عاجل',
    doc_patient_emoji_label: '👤 المريض:',
    doc_close_btn: 'إغلاق',
    doc_reply_btn: '↩ الرد',
    doc_original_message_prefix: 'الرسالة الأصلية من د.',
    doc_dialog_patient_label: 'المريض :',
    doc_reschedule_dialog_title: 'تأجيل الموعد',
    doc_currently_on: 'حاليًا في',
    doc_new_date_label: 'تاريخ جديد',
    doc_new_time_label: 'وقت جديد',
    doc_choose_time_placeholder: 'اختر وقتًا',
    doc_no_slot_available: 'لا توجد فترة زمنية متاحة في هذا اليوم (الجدول مغلق أو ممتلئ بالفعل).',
    doc_reschedule_reason_label: 'سبب التأجيل (اختياري)',
    doc_reschedule_reason_placeholder: 'مثال: حالة طبية طارئة، عدم التوفر...',
    doc_email_notification_notice: '📧 سيتلقى المريض بريدًا إلكترونيًا بالمعلومات الجديدة.',
    doc_moving: 'جاري التأجيل...',
    doc_confirm_reschedule_btn: 'تأكيد التأجيل',
    doc_manual_patient_title: 'إضافة مريض',
    doc_manual_patient_desc: 'لن يتم تسجيل هذا المريض على Tabbibak، لكن يمكنك متابعة ملفه الطبي وإنشاء وصفات طبية له.',
    doc_full_name_label: 'الاسم الكامل *',
    doc_ex_name_placeholder: 'مثال: أحمد بن علي',
    doc_ex_phone_placeholder: 'مثال: 0555 12 34 56',
    doc_email_label_full: 'البريد الإلكتروني (اختياري، لإشعارات المواعيد)',
    doc_ex_email_placeholder: 'مثال: ahmed.benali@email.com',
    doc_dob_label: 'تاريخ الميلاد (اختياري)',
    doc_adding: 'جاري الإضافة...',
    doc_add_patient_btn: 'إضافة المريض',
    doc_book_appointment_title: 'برمجة موعد',
    doc_time_label: 'الوقت',
    doc_book_consultation_type_label: 'نوع الاستشارة',
    doc_book_type_in_person: 'في العيادة',
    doc_book_type_video: 'بالفيديو (استشارة عن بعد)',
    doc_book_video_notice: '📹 سيتم إنشاء قاعة استشارة عن بعد تلقائيًا. سيتم إرسال رابط الانضمام إلى المريض وسيكون متاحًا من لوحة تحكمه.',
    doc_reason_optional_label: 'السبب (اختياري)',
    doc_book_reason_placeholder: 'مثال: استشارة متابعة، تجديد وصفة طبية...',
    doc_confirmation_email_notice: '📧 سيتلقى المريض بريدًا إلكترونيًا للتأكيد.',
    doc_booking_in_progress: 'جاري البرمجة...',
    doc_confirm_appointment_btn: 'تأكيد الموعد',
    doc_delete_patient_title: 'حذف هذا المريض',
    doc_delete_patient_confirm_prefix: 'هل أنت متأكد أنك تريد إزالة',
    doc_delete_patient_confirm_suffix: 'من قائمة مرضاك؟',
    doc_delete_patient_confirm_detail: 'سيتم حذف ملفه الطبي وملاحظاته. ستبقى مواعيده السابقة في السجل.',
    doc_deleting: 'جاري الحذف...',
    doc_yes_delete: 'نعم، حذف',
    doc_create_prescription_title: 'إنشاء وصفة طبية',
    doc_diagnostic_label: 'التشخيص (اختياري)',
    doc_diagnostic_placeholder: 'مثال: التهاب البلعوم الأنفي، ارتفاع ضغط الدم...',
    doc_medications_label: 'الأدوية',
    doc_medication_word: 'الدواء',
    doc_med_name_placeholder: 'اسم الدواء *',
    doc_med_dosage_placeholder: 'الجرعة (مثال: 500 ملغ) *',
    doc_med_frequency_placeholder: 'التكرار (مثال: 3 مرات/يوم) *',
    doc_med_duration_placeholder: 'المدة (مثال: 7 أيام)',
    doc_rx_dup_mid: ' هما في الواقع نفس الدواء (نفس المادة الفعالة والجرعة والشكل) — تحقق قبل اعتماد هذه الوصفة.',
    doc_rx_samesubstance_mid: ' تحتوي جميعها على ',
    doc_rx_samesubstance_post: '، بجرعات أو أشكال مختلفة في هذه الوصفة. تحقق من الجرعة الإجمالية الموصوفة قبل الاعتماد.',
    doc_recommendations_label: 'التوصيات (اختياري)',
    doc_recommendations_placeholder: 'مثال: الراحة، شرب كمية كبيرة من الماء...',
    doc_prescription_open_notice: 'ستفتح الوصفة الطبية في علامة تبويب جديدة جاهزة للطباعة أو التنزيل بصيغة PDF.',
    doc_prescription_saved_notice: 'ستُضاف هذه الوصفة الطبية أيضًا تلقائيًا إلى مساحة هذا المريض على Tabbibak.',
    doc_prescription_not_saved_notice: 'مريض خارج المنصة: ستُطبع هذه الوصفة الطبية لكن لا يمكن إضافتها إلى مساحة مريض.',
    doc_prescription_saved_toast: 'تم طباعة الوصفة الطبية وإضافتها إلى مساحة المريض.',
    doc_print_download_btn: 'طباعة / تنزيل PDF',
    doc_sse_new_appointment: '📅 موعد جديد !',
    doc_sse_patient_arrived: '🟢 وصل المريض !',

    doc_video_consultation_label: 'اقتراح استشارة مرئية عن بعد',
    doc_video_consultation_desc: 'سيتمكن مرضاك من اختيار موعد بالفيديو بالإضافة إلى العيادة.',
    doc_video_consultation_active: 'الاستشارة المرئية عن بعد مفعّلة',
    doc_video_payment_ccp_label: 'رقم CCP / BaridiMob',
    doc_video_payment_ccp_placeholder: 'مثال: 1234567 المفتاح 89',
    doc_video_payment_ccp_desc: 'يُعرض للمريض لتسديد الاستشارة عن بعد بالتحويل، ريثما يتوفر الدفع الإلكتروني.',
    doc_video_payment_ccp_none: 'لم يتم إدخال رقم CCP/BaridiMob — أضف رقمًا ليتمكن مرضاك من دفع استشاراتهم عن بعد.',
    doc_video_payment_ccp_invalid: 'رقم CCP/BaridiMob غير صالح: يجب أن يتكون من 6 إلى 12 رقمًا.',
    doc_video_consultation_inactive: 'الاستشارة المرئية عن بعد غير مفعّلة',
    doc_join_video_btn: 'الانضمام إلى الاستشارة المرئية',
    doc_join_video_too_early: 'متاح ابتداءً من {time}',
    doc_video_consultation_tag: 'استشارة مرئية',
    doc_patient_connected_tag: 'المريض متصل بقاعة الفيديو',
    doc_no_show_video_connected_warning: 'اتصل هذا المريض بقاعة الاستشارة المرئية. أكّد فقط إذا لم تتم الاستشارة فعليًا.',
    doc_video_dialog_title: 'استشارة مرئية',
    doc_video_join_error: 'تعذّر الانضمام إلى الاستشارة المرئية، يرجى إعادة المحاولة.',

    // Doctor Profile page
    dp_back: 'رجوع',
    dp_available: 'متاح عبر الإنترنت',
    dp_phone_only: 'موعد بالهاتف',
    dp_video_available: 'الاستشارة عن بعد متاحة',
    dp_presentation: 'نبذة',
    dp_education: 'التعليم',
    dp_languages: 'اللغات',
    dp_insurance: 'التأمينات المقبولة',
    dp_book: 'حجز موعد',
    dp_slots_on: 'المواعيد في',
    dp_no_slots: 'لا توجد مواعيد متاحة',
    dp_contact: 'اتصل بالعيادة',
    dp_no_online: 'هذا الطبيب لا يقبل حجز مواعيد عبر الإنترنت بعد',
    dp_call: 'اتصل',
    dp_reviews: 'آراء المرضى',
    dp_write_review: 'أعطِ رأيك',
    dp_no_reviews: 'لا توجد آراء حاليًا',
    dp_avg_rating: 'متوسط تقييم المرضى',
    dp_confirm_title: 'تأكيد الموعد',
    dp_confirm_with: 'موعد مع',
    dp_date_time: 'التاريخ والوقت',
    dp_consultation_type_label: 'نوع الاستشارة',
    dp_consultation_type_in_person: 'في العيادة',
    dp_consultation_type_video: 'بالفيديو (استشارة عن بعد)',
    dp_slot_video_only_notice: 'هذا الموعد متاح فقط عبر استشارة الفيديو عن بعد.',
    dp_video_payment_notice_prefix: 'الموعد مؤقت إلى حين تأكيد الدفع. يرجى تسديد هذه الاستشارة بالتحويل عبر CCP/BaridiMob إلى الرقم:',
    dp_video_payment_no_ccp: 'لم يقم الطبيب بعد بإدخال رقم للدفع — يرجى التواصل معه مباشرة لتسديد الاستشارة.',
    dp_payment_reference_label: 'مرجع التحويل',
    dp_payment_reference_placeholder: 'مثال: مرجع أو وقت التحويل',
    dp_payment_reference_required: 'يرجى إدخال مرجع تحويل CCP/BaridiMob لتأكيد الحجز.',
    dp_patient_account_required: 'يمكن فقط لحساب مريض حجز موعد. يرجى تسجيل الدخول بحساب مريض.',
    dp_reason: 'السبب (اختياري)',
    dp_reason_placeholder: 'صف السبب باختصار...',
    dp_cancel: 'إلغاء',
    dp_confirm: 'تأكيد',
    dp_booking: 'جاري الحجز...',
    dp_login_required: 'يرجى تسجيل الدخول أو إنشاء حساب لحجز موعد',
    dp_booking_success: 'تم تأكيد الموعد!',
    dp_booking_error: 'حدث خطأ، يرجى المحاولة مرة أخرى',
    dp_review_title: 'أعطِ رأيك',
    dp_review_desc: 'شارك تجربتك مع',
    dp_review_note: 'التقييم',
    dp_review_comment: 'تعليق',
    dp_review_placeholder: 'صف تجربتك...',
    dp_review_submit: 'نشر',
    dp_review_submitting: 'جاري النشر...',
    dp_consultation: 'الاستشارة',
    dp_share: 'مشاركة',
    dp_share_whatsapp: 'واتساب',
    dp_share_facebook: 'فيسبوك',
    dp_share_copy: 'نسخ الرابط',
    dp_link_copied: 'تم نسخ الرابط!',

    // Days
    day_monday: 'الاثنين', day_tuesday: 'الثلاثاء', day_wednesday: 'الأربعاء', day_thursday: 'الخميس',
    day_friday: 'الجمعة', day_saturday: 'السبت', day_sunday: 'الأحد',

    // Language
    lang_fr: 'Français',
    lang_ar: 'العربية',

    // Tool page layout (shared)
    tool_back_to_all: 'جميع أدوات الصحة',
    tool_print: 'طباعة / PDF',
    tool_need_consult_prefix: 'بحاجة لاستشارة ',
    tool_need_consult_suffix: '؟ احجز موعدًا بالقرب منك.',
    tool_default_specialty_label: 'طبيب',
    tool_search_cta: 'ابحث في Tabbibak',
    tool_disclaimer_footer: 'هذا مجرد تقدير لأغراض إعلامية فقط، ولا يغني عن استشارة طبية. في حال الشك، استشر أخصائي رعاية صحية.',

    // Outil : Calculateur d'IMC
    bmi_title: 'حاسبة مؤشر كتلة الجسم',
    bmi_subtitle: 'مؤشر كتلة الجسم، وفق العتبات المعتمدة من منظمة الصحة العالمية.',
    bmi_weight_label: 'الوزن (كغ)',
    bmi_weight_placeholder: 'مثال: 70',
    bmi_height_label: 'الطول (سم)',
    bmi_height_placeholder: 'مثال: 175',
    bmi_result_label: 'مؤشر كتلة جسمك',
    bmi_cat_under: 'نقص في الوزن',
    bmi_cat_normal: 'وزن طبيعي',
    bmi_cat_over: 'وزن زائد',
    bmi_cat_obese: 'سمنة',
    bmi_legend_under: 'نقص في الوزن: مؤشر كتلة الجسم أقل من 18.5',
    bmi_legend_normal: 'وزن طبيعي: من 18.5 إلى 24.9',
    bmi_legend_over: 'وزن زائد: من 25 إلى 29.9',
    bmi_legend_obese: 'سمنة: مؤشر كتلة الجسم 30 فما فوق',

    // Outil : Calculateur d'ovulation
    ovulation_title: 'حاسبة الإباضة',
    ovulation_subtitle: 'تقدير يعتمد على تاريخ آخر دورة شهرية ومدة الدورة لديك.',
    ovulation_lmp_label: 'تاريخ آخر دورة شهرية',
    ovulation_cycle_label: 'متوسط مدة الدورة (بالأيام)',
    ovulation_result_label: 'تاريخ الإباضة المتوقع',
    ovulation_fertile_label: 'فترة الخصوبة المتوقعة',
    ovulation_from: 'من',
    ovulation_to: 'إلى',
    ovulation_next_period_label: 'موعد الدورة القادمة المتوقع',
    ovulation_disclaimer: 'يفترض هذا التقدير أن الدورة منتظمة. في حال عدم انتظام الدورة، تكون هذه التواريخ أقل دقة — تحدثي مع طبيب أمراض النساء الخاص بك.',

    // Outil : Suivi de grossesse
    pregnancy_title: 'متابعة الحمل',
    pregnancy_subtitle: 'تقدير تاريخ الولادة (قاعدة نيغيلي) انطلاقًا من تاريخ آخر دورة شهرية.',
    pregnancy_invalid_date: 'يبدو أن هذا التاريخ غير صحيح، يرجى التحقق منه.',
    pregnancy_trimester_1: 'الثلث الأول',
    pregnancy_trimester_2: 'الثلث الثاني',
    pregnancy_trimester_3: 'الثلث الثالث',
    pregnancy_you_are_at: 'أنتِ الآن في',
    pregnancy_week_unit: 'أسبوع',
    pregnancy_day_unit: 'يوم',
    pregnancy_and: 'و',
    pregnancy_due_date_label: 'التاريخ المتوقع للولادة (تقديري)',
    pregnancy_days_remaining_label: 'الأيام المتبقية (تقديري)',
    pregnancy_days_word: 'يوم',
    pregnancy_card_title: 'بطاقة الطفل — للمشاركة',
    pregnancy_card_size_prefix: 'الحجم التقريبي:',
    pregnancy_card_due_prefix: 'التاريخ المتوقع:',
    pregnancy_copied: 'تم النسخ!',
    pregnancy_copy_button: 'نسخ للمشاركة',
    pregnancy_share_pregnancy_label: 'حملي:',
    pregnancy_share_baby_size_label: 'حجم الطفل يقارب حجم:',
    pregnancy_share_computed_with: '— محسوب عبر Tabbibak.com',
    pregnancy_disclaimer: 'هذا التاريخ تقدير إحصائي (قاعدة نيغيلي، لدورة مدتها 28 يومًا). فقط الفحص بالموجات فوق الصوتية الذي يجريه طبيبك أو القابلة يعطي تاريخًا موثوقًا.',

    // Outil : Posologie pédiatrique
    pediatric_title: 'جرعات الأطفال الدوائية',
    pediatric_subtitle: 'دليل إرشادي لجرعات الباراسيتامول والإيبوبروفين عند الطفل.',
    pediatric_warning: 'هذه الجرعات إرشادية فقط ولا تغني عن نشرة الدواء أو استشارة الطبيب أو الصيدلي. تحققي دائمًا من تدريج القطارة أو المحقنة المرفقة بعلبة الدواء، فهي تختلف حسب العلامة التجارية وتركيز المنتج. قبل سن 3 أشهر، أو في حال الشك، استشيري الطبيب قبل إعطاء أي دواء.',
    pediatric_weight_label: 'وزن الطفل (كغ) *',
    pediatric_weight_placeholder: 'مثال: 12',
    pediatric_age_label: 'العمر (بالأشهر، اختياري)',
    pediatric_age_placeholder: 'مثال: 18',
    pediatric_out_of_range: 'هذه الأداة مخصصة لوزن يتراوح بين 3 و50 كغ. خارج هذا النطاق، اطلب الجرعة الدقيقة من الطبيب أو الصيدلي.',
    pediatric_para_heading: 'الباراسيتامول',
    pediatric_para_desc: '15 ملغ/كغ في الجرعة الواحدة، كل 6 ساعات.',
    pediatric_dose_label: 'الجرعة الواحدة:',
    pediatric_para_max: 'بحد أقصى 4 جرعات في 24 ساعة. لا تتجاوز أبدًا 1 غرام في الجرعة الواحدة أو 60 ملغ/كغ في اليوم.',
    pediatric_ibu_heading: 'الإيبوبروفين',
    pediatric_ibu_desc: '10 ملغ/كغ في الجرعة الواحدة (شراب بتركيز 2%)، كل 8 ساعات — ابتداءً من سن 3 أشهر فقط.',
    pediatric_dose_approx_ml: 'أي ما يعادل تقريبًا',
    pediatric_ibu_max: 'بحد أقصى 3 جرعات في 24 ساعة. تحققي من التركيز الدقيق لقارورتك.',
    pediatric_ibu_not_recommended: 'غير مستحسن قبل سن 3 أشهر. استشيري الطبيب.',
    pediatric_contraindication_title: 'مضاد استطباب مهم:',
    pediatric_contraindication_text: 'الإيبوبروفين (ومضادات الالتهاب الأخرى) ممنوع استعماله في حالات جدري الماء (العنقز)، أو الاشتباه بعدوى بكتيرية، أو الجفاف — إذ قد يؤدي إلى مضاعفات خطيرة. في حال الشك بالتشخيص، أعطِ الباراسيتامول واستشر الطبيب.',
    pediatric_disclaimer: 'لا يُعطى هذان الدواءان معًا أبدًا دون استشارة طبية. استشيري الطبيب فورًا في حال الحمى عند رضيع أقل من 3 أشهر، أو حمى تتجاوز 39.5 درجة مئوية ولا تنخفض، أو تشنجات، أو نعاس غير معتاد، أو رفض الشرب.',

    // Outil : Calendrier vaccinal
    vaccination_title: 'جدول تلقيح الطفل',
    vaccination_subtitle: 'مؤشرات إرشادية للبرنامج الوطني للتلقيح في الجزائر.',
    vaccination_dob_label: 'تاريخ ميلاد الطفل',
    vaccination_disclaimer: 'يعرض هذا الجدول الخطوط العريضة للبرنامج الوطني الموسع للتلقيح في الجزائر، وهو يتطور بانتظام (لقاحات جديدة، أعمار معدّلة). تحققي دائمًا من التواريخ الدقيقة عبر دفتر صحة الطفل ومع طبيب الأطفال أو المركز الصحي.',

    // Outil : Repère de risque cardiovasculaire
    cvrisk_title: 'مؤشر استرشادي لخطر أمراض القلب والأوعية الدموية',
    cvrisk_subtitle: 'تقييم ذاتي بسيط لعوامل الخطر لديك — وليس تشخيصًا طبيًا.',
    cvrisk_warning: 'هذه الأداة لا تغني عن التقييم الطبي ولا تكشف الحالات الطارئة. في حال ألم في الصدر، أو ضيق تنفس مفاجئ، أو شعور بالتوعك، اتصلي بالإسعاف فورًا.',
    cvrisk_age_label: 'العمر',
    cvrisk_sex_label: 'الجنس',
    cvrisk_sex_placeholder: 'اختر...',
    cvrisk_sex_male: 'ذكر',
    cvrisk_sex_female: 'أنثى',
    cvrisk_factor_smoking: 'أنت مدخن (أو توقفت منذ أقل من سنة)',
    cvrisk_factor_hypertension: 'ارتفاع ضغط الدم معروف',
    cvrisk_factor_diabetes: 'داء السكري معروف',
    cvrisk_factor_cholesterol: 'ارتفاع الكوليسترول معروف',
    cvrisk_factor_obesity: 'مؤشر كتلة الجسم 30 فما فوق (سمنة)',
    cvrisk_factor_sedentary: 'أقل من 30 دقيقة نشاط بدني، 3 مرات في الأسبوع',
    cvrisk_factor_family: 'إصابة أحد الأقارب المباشرين بجلطة قلبية أو سكتة دماغية قبل سن 55 (رجل) أو 65 (امرأة)',
    cvrisk_band_low: 'منخفض',
    cvrisk_band_moderate: 'متوسط',
    cvrisk_band_high: 'مرتفع',
    cvrisk_band_heading: 'مستوى التنبيه الإرشادي',
    cvrisk_msg_low: 'واصل متابعة صحتك بانتظام.',
    cvrisk_msg_other: 'ننصحك بمناقشة هذه العوامل مع طبيب يمكنه إجراء تقييم شامل.',
    cvrisk_disclaimer: 'هذه النتيجة تقدير مبسط يعتمد على عوامل خطر معروفة. وهي ليست مقياسًا سريريًا معتمدًا (من نوع SCORE2 أو Framingham) ولا تغني بأي شكل عن استشارة طبية.',

    // Outil : Tension artérielle
    bp_title: 'مقيّم ضغط الدم',
    bp_subtitle: 'مؤشر إرشادي انطلاقًا من قراءات ضغط الدم لديك (ملم زئبقي).',
    bp_info: 'قياس واحد لا يكفي لتشخيص ارتفاع ضغط الدم: يجب أن يكون الكفّ مناسبًا، والقياس في حالة راحة، ومكررًا على عدة أيام. الطبيب وحده يمكنه تأكيد التشخيص.',
    bp_sys_label: 'الانقباضي (الرقم الأكبر)',
    bp_sys_placeholder: 'مثال: 130',
    bp_dia_label: 'الانبساطي (الرقم الأصغر)',
    bp_dia_placeholder: 'مثال: 85',
    bp_cat_hypo: 'انخفاض ضغط الدم',
    bp_cat_optimal: 'مثالي',
    bp_cat_normal: 'طبيعي',
    bp_cat_high_normal: 'طبيعي مرتفع',
    bp_cat_grade1: 'ارتفاع ضغط خفيف (الدرجة 1)',
    bp_cat_grade2: 'ارتفاع ضغط متوسط (الدرجة 2)',
    bp_cat_grade3: 'ارتفاع ضغط شديد (الدرجة 3)',
    bp_critical_warning: 'هذه الأرقام مرتفعة. إذا كنت تعاني أيضًا من صداع شديد، أو اضطرابات في الرؤية، أو ألم في الصدر، أو ضيق تنفس، استشر الطوارئ فورًا.',
    bp_disclaimer: 'هذه العتبات إرشادية، مستوحاة من التوصيات الأوروبية. في حال ارتفاع الضغط بشكل متكرر، أو ظهور أعراض مصاحبة، استشر طبيبًا أو طبيب قلب.',

    // Outil : Masse grasse
    bf_title: 'مؤشر الكتلة الدهنية (طريقة البحرية الأمريكية)',
    bf_subtitle: 'تقدير نسبة الدهون في جسمك انطلاقًا من قياسات بشريط القياس.',
    bf_neck_label: 'محيط الرقبة (سم)',
    bf_waist_label: 'محيط الخصر (سم)',
    bf_hip_label: 'محيط الورك (سم)',
    bf_cat_essential: 'دهون أساسية',
    bf_cat_athletic: 'رياضي',
    bf_cat_fit: 'لياقة جيدة',
    bf_cat_acceptable: 'مقبول',
    bf_cat_high: 'مرتفع',
    bf_result_label: 'نسبة الدهون المقدّرة',
    bf_disclaimer: 'هذه الطريقة (البحرية الأمريكية) تقدير بواسطة قياسات المحيط، وهي أقل دقة من قياس المعاوقة الكهربائية أو تصوير DEXA. استخدم شريط قياس مرنًا دون شدّ.',

    // Outil : Calcium et vitamine D
    calcium_title: 'احتياجات الكالسيوم وفيتامين د',
    calcium_subtitle: 'المعدلات اليومية الموصى بها حسب العمر والحالة، مع بعض المصادر الغذائية الشائعة.',
    calcium_profile_label: 'فئتك العمرية',
    calcium_profile_child_1_3: 'طفل (1–3 سنوات)',
    calcium_profile_child_4_8: 'طفل (4–8 سنوات)',
    calcium_profile_teen: 'مراهق (9–18 سنة)',
    calcium_profile_adult: 'بالغ (19–50 سنة)',
    calcium_profile_man_senior: 'رجل (51–70 سنة)',
    calcium_profile_woman_senior: 'امرأة (51–70 سنة)',
    calcium_profile_elder: '71 سنة فما فوق',
    calcium_profile_pregnancy_adult: 'حمل / رضاعة (19–50 سنة)',
    calcium_profile_pregnancy_teen: 'حمل / رضاعة (14–18 سنة)',
    calcium_daily_label: 'الكالسيوم الموصى به / يوميًا',
    vitd_daily_label: 'فيتامين د الموصى به / يوميًا',
    calcium_sources_heading: 'بعض المصادر الغذائية للكالسيوم',
    calcium_source_milk: 'حليب (كوب واحد، 250 مل)',
    calcium_source_yogurt: 'زبادي طبيعي (علبة واحدة، 125 غ)',
    calcium_source_cheese: 'جبن صلب (30 غ)',
    calcium_source_sardines: 'سردين مع العظم (100 غ)',
    calcium_source_almonds: 'لوز (30 غ)',
    calcium_source_figs: 'تين مجفف (5 حبات)',
    calcium_vitd_info: 'يُنتَج فيتامين د أساسًا عبر تعرض الجلد لأشعة الشمس؛ ويوجد أيضًا في الأسماك الدهنية، وصفار البيض، وبعض المنتجات المدعّمة. في الجزائر، يساهم التعرض المعتدل والمنتظم للشمس (الوجه والساعدين، لبضع دقائق يوميًا، خارج ساعات الذروة) في تغطية جزء من الاحتياجات.',
    calcium_disclaimer: 'هذه المعدلات العامة لا تغني عن استشارة طبية، خصوصًا في حال وجود نقص معروف، أو مرض في العظام، أو حمل عالي الخطورة، أو قبل البدء في تناول مكمل غذائي: تحدث مع طبيبك الذي يمكنه الاعتماد على تحليل دم إذا لزم الأمر.',

    // Outil : Besoins caloriques
    calorie_title: 'الاحتياجات من السعرات الحرارية (الأيض الأساسي / الإجمالي)',
    calorie_subtitle: 'تقدير سعراتك الحرارية اليومية حسب هدفك، وفق معادلة ميفلين-سان جيور.',
    calorie_activity_label: 'مستوى النشاط البدني',
    calorie_activity_sedentary: 'خامل (نشاط رياضي قليل أو منعدم)',
    calorie_activity_light: 'نشاط خفيف (رياضة 1-3 أيام/أسبوع)',
    calorie_activity_moderate: 'نشاط متوسط (رياضة 3-5 أيام/أسبوع)',
    calorie_activity_high: 'نشاط عالٍ (رياضة 6-7 أيام/أسبوع)',
    calorie_activity_extreme: 'نشاط مكثف جدًا (رياضة شديدة، عمل بدني)',
    calorie_weight_loss: 'إنقاص الوزن',
    calorie_maintenance: 'الحفاظ على الوزن',
    calorie_weight_gain: 'زيادة الوزن',
    calorie_per_day: 'سعرة حرارية / يوم',
    calorie_disclaimer: 'هذه القيم تقديرية. لا يُنصح بعجز أو فائض كبير في السعرات دون استشارة طبية، خصوصًا في حال وجود مرض مزمن.',

    // Outil : Clairance de la créatinine
    crcl_title: 'تصفية الكرياتينين (معادلة كوكروفت-غولت)',
    crcl_subtitle: 'تقدير وظيفة الكلى، مفيد لمرضى السكري أو ارتفاع ضغط الدم.',
    crcl_info: 'أدخل نسبة الكرياتينين المذكورة في تحليل الدم الخاص بك. هذا التقدير لا يغني عن تفسير طبيبك، خصوصًا لضبط جرعة دواء.',
    crcl_creatinine_label: 'الكرياتينين في الدم',
    crcl_stage_g1: 'G1 — وظيفة طبيعية أو مرتفعة',
    crcl_stage_g2: 'G2 — منخفضة قليلًا',
    crcl_stage_g3a: 'G3a — منخفضة بين الخفيفة والمتوسطة',
    crcl_stage_g3b: 'G3b — منخفضة بين المتوسطة والشديدة',
    crcl_stage_g4: 'G4 — منخفضة بشدة',
    crcl_stage_g5: 'G5 — قصور كلوي نهائي',
    crcl_result_label: 'التصفية المقدّرة',
    crcl_disclaimer: 'معادلة كوكروفت-غولت تقدير يعتمد على الوزن والعمر والجنس؛ وهي أقل دقة لدى الأشخاص النحيفين جدًا، أو ذوي الوزن الزائد، أو كبار السن. يبقى تحليل الدم مع حساب معدل الترشيح الكبيبي في المخبر هو المرجع.',

    // Outil : Déshydratation & SRO
    dehydration_title: 'الجفاف ومحلول الإماهة الفموي',
    dehydration_subtitle: 'مؤشر لتقييم الجفاف (إسهال، قيء) وكمية محلول الإماهة الفموي الواجب إعطاؤها.',
    dehydration_warning: 'عند رضيع أقل من 3 أشهر، أو في حال وجود دم في البراز، أو حمى مرتفعة مستمرة، أو قيء لا يُسيطر عليه، استشر طبيبًا فورًا دون انتظار هذا الاستبيان.',
    dehydration_weight_placeholder: 'مثال: 10',
    dehydration_age_years_label: 'العمر (بالسنوات)',
    dehydration_age_years_placeholder: 'مثال: 1.5',
    dehydration_severe_heading: 'علامات شديدة',
    dehydration_moderate_heading: 'علامات متوسطة',
    dehydration_sign_lethargy: 'خمول شديد، صعوبة كبيرة في إيقاظ الطفل، أو فقدان الوعي',
    dehydration_sign_no_drink: 'غير قادر على الشرب، أو يشرب بصعوبة كبيرة',
    dehydration_sign_eyes_severe: 'عينان غائرتان بشدة',
    dehydration_sign_skin_severe: 'يعود طي الجلد إلى شكله ببطء شديد (عدة ثوانٍ)',
    dehydration_sign_agitated: 'مهتاج/ة، سريع/ة الانفعال',
    dehydration_sign_thirsty: 'يشرب بنهم، يبدو شديد العطش',
    dehydration_sign_eyes_some: 'عينان غائرتان قليلًا',
    dehydration_sign_skin_some: 'يعود طي الجلد إلى شكله ببطء',
    dehydration_severe_result_title: 'احتمال جفاف شديد',
    dehydration_severe_result_text: 'توجه إلى الطوارئ فورًا. من المرجح أن يكون الإماهة عبر الوريد ضرورية — محلول الإماهة الفموي وحده لا يكفي هنا.',
    dehydration_moderate_result_title: 'احتمال جفاف متوسط',
    dehydration_moderate_result_text: 'محلول الإماهة الفموي: حوالي 75 مل لكل كغ من الوزن، يُعطى خلال 4 ساعات، بكميات صغيرة ومتكررة (ملعقة كل 1 إلى 2 دقيقة للرضيع).',
    dehydration_over_4h: 'خلال 4 ساعات',
    dehydration_reassess: 'أعد التقييم بعد 4 ساعات. إذا استمرت العلامات أعلاه أو ازدادت سوءًا، استشر طبيبًا أو توجه إلى الطوارئ.',
    dehydration_none_title: 'لم يتم تحديد أي علامة جفاف',
    dehydration_none_text: 'واصل الرضاعة أو التغذية المعتادة، وأعطِ محلول الإماهة الفموي بعد كل براز سائل للوقاية من الجفاف:',
    dehydration_under2: 'أقل من سنتين',
    dehydration_over2: 'سنتان فما فوق',
    dehydration_planA_under2: '50 إلى 100 مل (10 إلى 20 ملعقة صغيرة)',
    dehydration_planA_over2: '100 إلى 200 مل (من نصف كوب إلى كوب)',
    dehydration_after_stool: 'بعد كل براز سائل.',
    dehydration_disclaimer: 'يُحضَّر محلول الإماهة الفموي بماء نظيف وفق تعليمات الكيس — لا تضف أبدًا كمية ماء أكثر أو أقل من الموصى بها. قد يصف لك طبيبك أيضًا الزنك كمكمّل، كما توصي به منظمة الصحة العالمية في حالات إسهال الطفل.',

    // Outil : Convertisseur de fièvre
    fever_title: 'محوّل درجة الحرارة',
    fever_subtitle: 'قارن درجة الحرارة حسب طريقة القياس، وتعرّف على العتبات التي يجب أن تنبهك.',
    fever_temp_label: 'درجة الحرارة المقاسة (°م)',
    fever_site_label: 'طريقة القياس',
    fever_site_rectal: 'شرجية',
    fever_site_oral: 'فموية',
    fever_site_axillary: 'إبطية',
    fever_site_tympanic: 'أذنية (طبلية)',
    fever_age_label: 'عمر الطفل (بالأشهر، اختياري)',
    fever_age_placeholder: 'اتركه فارغًا إذا كان بالغًا',
    fever_equiv_label: 'المعادل الشرجي',
    fever_band_normal: 'درجة حرارة طبيعية',
    fever_band_low: 'حرارة خفيفة',
    fever_band_fever: 'حمى',
    fever_band_high: 'حمى مرتفعة',
    fever_advice_under3: 'حمى عند رضيع أقل من 3 أشهر: اتصل بطبيب فورًا، حتى بدون أي عرض آخر.',
    fever_advice_under6: 'اتصل بطبيبك خلال اليوم.',
    fever_advice_over6: 'درجة حرارة مرتفعة: اتصل بطبيبك.',
    fever_advice_general: 'راقب الطفل، أكثر من ترطيبه، واستشر طبيبًا إذا استمرت الحمى أكثر من 3 أيام أو ظهرت أعراض أخرى مقلقة.',
    fever_disclaimer: 'التحويل بين طرق القياس تقريبي — تختلف الفوارق حسب الجهاز والشخص. تُعتبر القراءة الشرجية عمومًا الأكثر موثوقية عند الرضيع. في حال الشك، استشر طبيبًا بدل الاعتماد فقط على رقم.',

    // Outil : Convertisseur de glycémie
    glycemia_title: 'محوّل سكر الدم',
    glycemia_subtitle: 'تحويل ملغ/دل ↔ مليمول/ل ومعادلة مع الهيموغلوبين السكري HbA1c.',
    glycemia_info: 'هذه العتبات إرشادية. يعتمد تشخيص السكري على تحاليل مخبرية متكررة، وليس على قياس واحد بجهاز قياس السكر.',
    glycemia_mgdl_label: 'سكر الدم (ملغ/دل)',
    glycemia_mmol_label: 'سكر الدم (مليمول/ل)',
    glycemia_timing_label: 'وقت القياس',
    glycemia_timing_fasting: 'على الريق',
    glycemia_timing_postprandial: 'بعد الوجبة (ساعتان)',
    glycemia_cat_low: 'منخفضة (نقص السكر)',
    glycemia_cat_normal: 'طبيعية',
    glycemia_cat_prediabetes_fasting: 'ما قبل السكري (على الريق)',
    glycemia_cat_high: 'مرتفعة — موحية بالسكري',
    glycemia_cat_prediabetes_postprandial: 'ما قبل السكري (بعد الوجبة)',
    glycemia_result_label: 'تفسير إرشادي',
    glycemia_hba1c_heading: 'تقدير انطلاقًا من الهيموغلوبين السكري',
    glycemia_hba1c_label: 'الهيموغلوبين السكري HbA1c (%)',
    glycemia_eag_label: 'متوسط سكر الدم المقدّر',
    glycemia_disclaimer: 'هذه التحويلات والعتبات إعلامية ولا تغني عن متابعة طبيبك أو طبيب الغدد الصماء، خصوصًا لضبط علاج السكري.',

    // Outil : Calculateur de croissance (OMS)
    growth_title: 'حاسبة النمو (منحنيات منظمة الصحة العالمية)',
    growth_subtitle: 'وزن وطول طفلك مقارنة بمعايير النمو لمنظمة الصحة العالمية، من الولادة إلى 5 سنوات.',
    growth_info: 'يقارن هذا المؤشر قياسًا واحدًا فقط بمنحنيات منظمة الصحة العالمية. التطور عبر الزمن (المتابعة المنتظمة في دفتر الصحة) هو الأهم، وليس قياسًا معزولًا.',
    growth_sex_label: 'الجنس',
    growth_sex_placeholder: 'اختر...',
    growth_sex_boy: 'ذكر',
    growth_sex_girl: 'أنثى',
    growth_age_label: 'العمر (بالأشهر، من 0 إلى 60)',
    growth_age_placeholder: 'مثال: 14',
    growth_weight_label: 'الوزن (كغ)',
    growth_height_label: 'الطول (سم)',
    growth_weight_result_label: 'الوزن',
    growth_height_result_label: 'الطول',
    growth_below_who: 'دون معايير منظمة الصحة العالمية',
    growth_above_who: 'فوق معايير منظمة الصحة العالمية',
    growth_below_median: 'ضمن المعدل الطبيعي (دون الوسيط)',
    growth_above_median: 'ضمن المعدل الطبيعي (فوق الوسيط)',
    growth_who_refs_at_age: 'معايير منظمة الصحة العالمية في هذا العمر:',
    growth_median_label: 'الوسيط',
    growth_disclaimer: 'القيمة الواقعة خارج نطاق المئين 3-97 ليست بالضرورة مشكلة، لكنها تستحق نقاشًا مع طبيب الأطفال، خصوصًا إذا صاحبها تباطؤ أو تسارع غير معتاد مقارنة بالقياسات السابقة للطفل.',

    // Outil : Calculateur d'hydratation
    hydration_title: 'حاسبة الترطيب',
    hydration_subtitle: 'تقدير احتياجاتك من الماء حسب وزنك والمناخ ونشاطك البدني.',
    hydration_info: 'هذا التقدير متوسط عام لشخص بالغ يتمتع بصحة جيدة. إذا كنت تتبع نظامًا منخفض الملح، أو تخضع لتقييد في السوائل، أو تعاني من مرض في الكلى أو القلب، اتبع تعليمات طبيبك بدلًا من هذا الحساب.',
    hydration_weight_label: 'الوزن (كغ)',
    hydration_climate_label: 'المناخ',
    hydration_climate_normal: 'عادي',
    hydration_climate_hot: 'حر (صيف)',
    hydration_climate_very_hot: 'حر شديد / موجة حر',
    hydration_activity_label: 'النشاط البدني',
    hydration_activity_none: 'لا يوجد',
    hydration_activity_1: '30-60 دقيقة / يوم',
    hydration_activity_2: '1-2 ساعة / يوم',
    hydration_activity_3: 'أكثر من ساعتين / يوم',
    hydration_result_label: 'الاحتياج المقدّر',
    hydration_result_note: 'يوميًا، بما في ذلك الماء والمشروبات',
    hydration_disclaimer: 'قد يأتي جزء من هذه الاحتياجات من الغذاء (الفواكه، الخضروات، الحساء). في حالات الحر الشديد، وزّع استهلاكك للماء على مدار اليوم.',

    // Outil : Évaluateur de cycles de sommeil
    sleep_title: 'مقيّم دورات النوم',
    sleep_subtitle: 'اعثر على وقت نوم أو استيقاظ يقع بين دورتي نوم كاملتين.',
    sleep_mode_wake: 'يجب أن أستيقظ في...',
    sleep_mode_sleep: 'سأخلد للنوم في...',
    sleep_wake_time_label: 'وقت الاستيقاظ المطلوب',
    sleep_bed_time_label: 'وقت النوم',
    sleep_recommended_bedtimes: 'أوقات النوم الموصى بها',
    sleep_recommended_wake: 'أوقات الاستيقاظ الموصى بها',
    sleep_cycles_word: 'دورات',
    sleep_about: 'حوالي',
    sleep_hours_sleep: 'ساعة نوم',
    sleep_recommended_badge: 'الخيار الموصى به',
    sleep_disclaimer: 'مدة دورة النوم المتوسطة (≈90 دقيقة) ووقت الخلود للنوم يختلفان من شخص لآخر. هذه المعايير إرشادية؛ في حال اضطرابات النوم المستمرة (أرق، استيقاظ متكرر، إرهاق مزمن)، استشر طبيبًا.',

    // Outil : Calculateur d'arrêt du tabac
    smoking_title: 'حاسبة الإقلاع عن التدخين',
    smoking_subtitle: 'مدخراتك بالدينار الجزائري والفوائد الصحية بمرور الوقت منذ إقلاعك.',
    smoking_per_day_label: 'عدد السجائر يوميًا (قبل الإقلاع)',
    smoking_price_label: 'سعر العلبة (دج)',
    smoking_cigs_per_pack_label: 'عدد السجائر في العلبة',
    smoking_quit_date_label: 'تاريخ الإقلاع',
    smoking_saved_money_label: 'المال الموفَّر',
    smoking_avoided_cigs_label: 'سجائر لم تُدخَّن',
    smoking_benefits_heading: 'الفوائد الصحية',
    smoking_disclaimer: 'هذه المدد معايير عامة صادرة عن سلطات الصحة العامة؛ وهي تختلف من شخص لآخر. يمكن لطبيب أو برنامج مساعدة على الإقلاع عن التدخين مرافقتك لزيادة فرص نجاحك.',
    smoking_m1_label: '20 دقيقة',
    smoking_m1_text: 'يبدأ معدل ضربات القلب وضغط الدم بالانخفاض.',
    smoking_m2_label: '12 ساعة',
    smoking_m2_text: 'يعود مستوى أول أكسيد الكربون في الدم إلى الطبيعي.',
    smoking_m3_label: 'يومان',
    smoking_m3_text: 'تبدأ حاستا الشم والتذوق بالتحسن.',
    smoking_m4_label: '3 أسابيع',
    smoking_m4_text: 'تتحسن الدورة الدموية ووظيفة الرئتين.',
    smoking_m5_label: '9 أشهر',
    smoking_m5_text: 'يقل السعال وضيق التنفس بشكل ملحوظ.',
    smoking_m6_label: 'سنة واحدة',
    smoking_m6_text: 'ينخفض خطر مرض الشريان التاجي إلى النصف مقارنة بالمدخن.',
    smoking_m7_label: '5 سنوات',
    smoking_m7_text: 'يصل خطر السكتة الدماغية إلى مستوى غير المدخن.',
    smoking_m8_label: '10 سنوات',
    smoking_m8_text: 'ينخفض خطر سرطان الرئة بشكل ملحوظ.',

    // Outil : Planning de prise d'antibiotiques
    atb_title: 'جدول تناول المضادات الحيوية',
    atb_subtitle: 'أنشئ جدولًا للجرعات حتى لا تنسى جرعة وتُنهي علاجك.',
    atb_warning: 'هذا الجدول مجرد أداة تنظيمية تعتمد على ما وصفه لك طبيبك (الاسم، التكرار، المدة). وهو لا يغني عن الوصفة الطبية: احترم دائمًا المواعيد والجرعة والمدة التي حددها طبيبك أو صيدليك، ولا توقف أبدًا تناول مضاد حيوي من تلقاء نفسك حتى لو شعرت بتحسن.',
    atb_name_label: 'اسم المضاد الحيوي (اختياري)',
    atb_name_placeholder: 'مثال: أموكسيسيلين',
    atb_start_date_label: 'تاريخ البدء',
    atb_frequency_label: 'التكرار الموصوف',
    atb_freq_1: 'مرة واحدة يوميًا',
    atb_freq_2: 'مرتان يوميًا',
    atb_freq_3: '3 مرات يوميًا',
    atb_freq_4: '4 مرات يوميًا',
    atb_duration_label: 'مدة العلاج (أيام)',
    atb_duration_placeholder: 'مثال: 7',
    atb_schedule_heading: 'جدول الجرعات',
    atb_doses_checked: 'جرعة مؤكدة',
    atb_disclaimer: 'المواعيد المقترحة (8 صباحًا، 13/14، 18/20، 23) هي معايير عملية موزعة على اليوم؛ عدّلها إذا حدد طبيبك مواعيد مختلفة (مثلًا بالنسبة للوجبات). في حال ظهور أثر جانبي (طفح جلدي، إسهال شديد، صعوبة في التنفس)، اتصل بطبيبك أو صيدليك بسرعة.',

    // Outil : Prise de poids pendant la grossesse
    gwg_title: 'زيادة الوزن أثناء الحمل',
    gwg_subtitle: 'معايير معهد الطب الأمريكي (IOM) حسب مؤشر كتلة جسمك قبل الحمل، لحمل بجنين واحد.',
    gwg_info: 'تخص هذه المعايير حملًا بجنين واحد. بالنسبة للحمل بتوأم أو أكثر، تختلف الأهداف — تحدثي مع طبيبك أو القابلة.',
    gwg_height_label: 'الطول (سم)',
    gwg_preweight_label: 'الوزن قبل الحمل (كغ)',
    gwg_currentweight_label: 'الوزن الحالي (كغ، اختياري)',
    gwg_week_label: 'أسبوع الحمل (اختياري)',
    gwg_cat_under: 'نقص الوزن',
    gwg_cat_normal: 'وزن طبيعي',
    gwg_cat_over: 'زيادة الوزن',
    gwg_cat_obese: 'السمنة',
    gwg_your_bmi_prefix: 'مؤشر كتلة جسمك قبل الحمل:',
    gwg_total_recommended: 'إجمالي زيادة الوزن الموصى بها طوال فترة الحمل:',
    gwg_indicative_at_week: 'معيار إرشادي عند الأسبوع',
    gwg_weeks_word: 'أسبوع',
    gwg_about_prefix: 'حوالي',
    gwg_kg_gained_since_start: 'كغ منذ البداية',
    gwg_current_gain_prefix: 'زيادة وزنك الحالية:',
    gwg_disclaimer: 'هذه المعايير (معهد الطب، 2009) متوسطات إرشادية؛ يجب أن تتم المتابعة الفعلية لحملك — الوزن، ضغط الدم، نمو الجنين — من قبل طبيبك أو القابلة خلال استشارات ما قبل الولادة.',

    // Outil : Congé maternité et arrêt maladie
    maternity_title: 'إجازة الأمومة والعطلة المرضية في الجزائر',
    maternity_subtitle: 'معايير حول المدة والتعويض، وفق القانون 25-08 (2025) والنظام العام للصندوق الوطني للتأمينات الاجتماعية (CNAS).',
    maternity_tab_leave: 'إجازة الأمومة',
    maternity_tab_sick: 'العطلة المرضية',
    maternity_info_pre: 'منذ صدور القانون 25-08 (جويلية 2025)، أصبحت إجازة الأمومة ',
    maternity_info_strong1: '150 يومًا متتاليًا',
    maternity_info_mid: '، يُعوَّض عنها بنسبة ',
    maternity_info_strong2: '100% من الراتب',
    maternity_info_post: ' من طرف الصندوق الوطني للتأمينات الاجتماعية (CNAS). يمكن أن تبدأ حتى 42 يومًا قبل التاريخ المتوقع للولادة، دون تقليص المدة الإجمالية إذا حدثت الولادة قبل ذلك.',
    maternity_due_date_label: 'التاريخ المتوقع للولادة',
    maternity_leave_start_label: 'بداية الإجازة (أيام قبل الموعد)',
    maternity_start_42: '42 يومًا قبل (الحد الأقصى)',
    maternity_start_21: '21 يومًا قبل',
    maternity_start_14: '14 يومًا قبل',
    maternity_start_0: 'يوم الولادة',
    maternity_leave_start_result: 'بداية الإجازة',
    maternity_leave_end_result: 'نهاية الإجازة (150 يومًا)',
    maternity_extension_note: 'توجد تمديدات في حال الولادة المبكرة أو حدوث مضاعفات: +50 يومًا إذا كان المولود يعاني من إعاقة أو تشوه خلقي أو مرض خطير (يتطلب شهادة طبية)، وحتى +165 يومًا إضافيًا إذا كانت الرعاية المستمرة ضرورية طبيًا (شهادة من أخصائي في طب الأطفال).',
    sick_info_pre: 'في العطلة المرضية العادية، يبلغ التعويض اليومي ',
    sick_info_strong1: '50% من الراتب اليومي',
    sick_info_mid: ' خلال الـ15 يومًا الأولى، ثم ',
    sick_info_strong2: '100%',
    sick_info_post: ' ابتداءً من اليوم 16. في حالة الاستشفاء أو مرض مزمن معترف به (طويل الأمد)، يكون التعويض 100% منذ اليوم الأول.',
    sick_daily_salary_label: 'الراتب اليومي الصافي (دج)',
    sick_days_label: 'عدد أيام التوقف',
    sick_days_placeholder: 'مثال: 20',
    sick_total_label: 'التعويض الإجمالي المقدّر (توقف عادي)',
    sick_note: 'لا يمكن أن يقل التعويض اليومي عن 1/30 من الراتب الشهري المتحصل عليه سابقًا. المدة القصوى للتكفل هي 3 سنوات. يفترض فتح الحقوق مدة انتساب دنيا (عادة 15 يوم عمل خلال الثلاثي السابق، أو 60 يومًا خلال الـ12 شهرًا الأخيرة).',
    maternity_legal_disclaimer: 'هذه المعلومات إرشادية ولا تشكل استشارة قانونية أو مالية شخصية. قد يتطور التشريع وقد تُغيّر حالات خاصة (شروط الانتساب، حالة غير الأجير عبر الصندوق الوطني للضمان الاجتماعي لغير الأجراء CASNOS...) القواعد المطبقة. تأكد دائمًا من وضعيتك لدى CNAS (الرقم الأخضر 30-10)، أو CASNOS، أو مصلحة الموارد البشرية لدى صاحب عملك.',

    // Outil : Simulateur de remboursement CNAS/CASNOS
    cnas_title: 'محاكي استرجاع مصاريف CNAS/CASNOS',
    cnas_subtitle: 'تقدير إرشادي لاسترجاع مصاريفك حسب نوع الرعاية — لأغراض إعلامية فقط.',
    cnas_info_pre: 'التعويض الأساسي للضمان الاجتماعي الجزائري (CNAS للأجراء، CASNOS لغير الأجراء) هو ',
    cnas_info_strong1: '80%',
    cnas_info_mid: ' من التعريفة المرجعية المتفق عليها، ويرتفع إلى ',
    cnas_info_strong2: '100%',
    cnas_info_post: ' في حالات معينة (أمراض مزمنة معترف بها، الأمومة، ذوو الدخل المحدود، المتقاعدون/ذوو الإعاقة حسب الشروط).',
    cnas_type_label: 'نوع الرعاية',
    cnas_cat_consultation: 'استشارة طبية (طبيب عام أو أخصائي)',
    cnas_cat_pharmacie: 'أدوية موصوفة (خارج نظام الدفع المباشر ببطاقة شفاء)',
    cnas_cat_hospitalisation: 'استشفاء (باستثناء الأمومة)',
    cnas_cat_chronique: 'رعاية مرتبطة بمرض مزمن معترف به',
    cnas_cat_maternite: 'متابعة الحمل، الولادة، الرعاية بعد الولادة',
    cnas_amount_label: 'المبلغ المدفوع أو التعريفة المرجعية (دج)',
    cnas_amount_placeholder: 'مثال: 1500',
    cnas_reimbursed_label: 'التعويض المقدّر',
    cnas_remaining_label: 'المتبقي على عاتقك (تقدير)',
    cnas_chifa_heading: 'معلومة عن بطاقة شفاء',
    cnas_chifa_text: 'ببطاقة شفاء، تُغطى عادةً الأدوية الموصوفة حتى 3000 دج مباشرة في الصيدلية (دفع مباشر) دون تسبيق للمصاريف، بالنسبة لأول وصفتين لكل مستفيد خلال فترة 3 أشهر. بعد ذلك، قد يلزم تسبيق المصاريف يليه طلب استرجاع.',
    cnas_disclaimer: 'هذا تقدير عام وإرشادي، وليس وثيقة رسمية ولا استشارة مالية أو قانونية. تعتمد النسب الفعلية على التعريفة المرجعية المتفق عليها (التي قد تختلف عن السعر المفوتر)، وعلى نظامك ووضعيتك الشخصية. تأكد دائمًا من المبلغ الدقيق لدى CNAS أو CASNOS.',

    // Outil : Vérificateur de doublons de principe actif
    drugdup_title: 'التحقق من ازدواجية الأدوية',
    drugdup_subtitle: 'تحقق مما إذا كانت بعض أدويتك هي في الواقع نفس المنتج (نفس المادة الفعالة والجرعة والشكل الدوائي) مسوّق تحت أسماء تجارية مختلفة.',
    drugdup_info: 'تقارن هذه الأداة الأدوية اعتمادًا على السجل الصيدلاني الرسمي (أكثر من 9500 دواء) وتكتشف نوعين من الحالات: علامتان تجاريتان مختلفتان هما في الواقع نفس الدواء تمامًا (نفس المادة الفعالة، نفس الجرعة، نفس الشكل)، ونفس المادة الفعالة بجرعات أو أشكال مختلفة (مثلاً دوليبران 500 ملغ ودوليبران 1000 ملغ) — قد يكون ذلك مقصودًا حسب الوصفة الطبية، لكنه يستحق التحقق. لا تكتشف الأداة تفاعلات الأدوية، ولا الحالات التي تحمل فيها نفس المادة اسمًا مختلفًا بحسب الملح الكيميائي أو طريقة الإعطاء (مثل شكل حقن مقابل قرص). في حال الشك بشأن مزج أدوية أو جرعة، اسأل دائمًا صيدليك.',
    drugdup_search_placeholder: 'ابحث عن دواء (الاسم التجاري)...',
    drugdup_type_more: 'اكتب حرفين على الأقل للبحث عن دواء.',
    drugdup_searching: 'جارٍ البحث…',
    drugdup_search_error: 'البحث غير متاح حاليًا. حاول مرة أخرى لاحقًا.',
    drugdup_none_found: 'لم يتم العثور على أي نتيجة لهذا البحث.',
    drugdup_selected_heading: 'الأدوية المختارة',
    drugdup_and: ' و ',
    drugdup_substance_label: 'المادة الفعالة: ',
    drugdup_dup_mid: ' هما في الواقع نفس الدواء (نفس المادة الفعالة والجرعة والشكل)، مسوّقان تحت اسمين تجاريين مختلفين.',
    drugdup_dup_post: ' تناولهما معًا يعرضك لخطر الجرعة الزائدة. تحقق مع صيدليك قبل الجمع بينهما.',
    drugdup_samesubstance_mid: ' تحتوي جميعها على ',
    drugdup_samesubstance_post: '، بجرعات أو أشكال مختلفة. قد يكون ذلك مقصودًا حسب الوصفة الطبية، لكن تحقق من الجرعة الإجمالية مع طبيبك أو صيدليك قبل الجمع بينها.',
    drugdup_no_duplicate: 'لم يتم رصد أي ازدواجية تامة، ولا نفس المادة الفعالة بجرعات مختلفة، بين الأدوية المختارة (وفق السجل الرسمي). هذا لا يضمن عدم وجود نفس المادة الفعالة تحت اسم مختلف (مثلاً ملح كيميائي أو طريقة إعطاء مختلفة): في حال الشك، تحقق مع صيدليك.',
    drugdup_disclaimer: 'هذه الأداة لا تغني عن تحليل كامل لتفاعلات الأدوية، والذي يجب أن يقوم به صيدلي أو طبيب — خصوصًا إذا كنت تتناول علاجات مزمنة أو عدة أدوية في نفس الوقت.',

    // Outil : Triage d'urgence
    triage_title: 'فرز الطوارئ',
    triage_subtitle: 'مؤشر أولي لمعرفة ما إذا كان يجب الاتصال بالإسعاف، استشارة سريعة، أو الانتظار.',
    triage_call_warning: 'في حال الشك أو وجود حالة طوارئ واضحة، اتصل بالإسعاف مباشرة دون انتظار هذا الاستبيان.',
    triage_civil_protection: 'الحماية المدنية — 1021',
    triage_samu: 'سامو (الإسعاف) — 14',
    triage_red_question: 'هل يوجد أحد هذه العلامات؟',
    triage_red_1: 'فقدان الوعي أو ارتباك مفاجئ',
    triage_red_2: 'صعوبة شديدة في التنفس، اختناق',
    triage_red_3: 'ألم شديد أو ضغط في الصدر',
    triage_red_4: 'نزيف غزير لا يتوقف',
    triage_red_5: 'تشنجات',
    triage_red_6: 'ضعف أو شلل مفاجئ في أحد جانبي الجسم، صعوبة في الكلام',
    triage_red_7: 'تورم في الوجه/الحلق بعد لدغة، طعام أو دواء',
    triage_red_8: 'إصابة خطيرة (سقوط شديد، حادث، جرح عميق)',
    triage_orange_question: 'أم أحد هذه بالأحرى؟',
    triage_orange_1: 'حمى مرتفعة (>39,5°م) لا تنخفض رغم العلاج',
    triage_orange_2: 'قيء أو إسهال متكرر مع علامات جفاف',
    triage_orange_3: 'ألم شديد لكن مستقر، دون العلامات أعلاه',
    triage_orange_4: 'جرح قد يتطلب غرزًا',
    triage_result_red_title: 'حالة طوارئ محتملة: اتصل بـ1021 أو 14 الآن',
    triage_result_orange_title: 'يُنصح باستشارة عاجلة، خلال 24 ساعة',
    triage_result_red_text: 'توجه إلى قسم الطوارئ في أقرب مستشفى أو اتصل بالإسعاف دون انتظار.',
    triage_result_orange_text: 'استشر طبيبًا أو مصلحة الحراسة الطبية خلال اليوم.',
    triage_call_1021: 'اتصل بـ1021',
    triage_call_14: 'اتصل بـ14',
    triage_none_title: 'لم يتم تحديد أي علامة تنبيه',
    triage_none_text: 'استشارة عادية لدى طبيب عام كافية.',
    triage_disclaimer: 'هذا الاستبيان مؤشر أولي فقط، وليس تشخيصًا. في حال الشك، من الأفضل دائمًا الاستشارة أو الاتصال بالإسعاف بدل الانتظار.',

    // Outil : Certificat médical prénuptial
    prenup_title: 'الشهادة الطبية لما قبل الزواج في الجزائر',
    prenup_subtitle: 'ما ينص عليه القانون، الفحوصات المعنية، وحقوقك — لأغراض إعلامية.',
    prenup_intro: 'منذ المرسوم التنفيذي الصادر في نوفمبر 2024، أصبحت الشهادة الطبية لما قبل الزواج إلزامية لكل زواج يُعقد في الجزائر. يجب على كل من الخطيبين تقديم شهادته الخاصة.',
    prenup_mandatory_heading: 'الفحوصات الإلزامية',
    prenup_mand_1: 'استجواب طبي مفصل (السوابق الشخصية والعائلية، الأمراض الوراثية)',
    prenup_mand_2: 'قياس ضغط الدم',
    prenup_mand_3: 'الطول والوزن، فحص سريري عام',
    prenup_mand_4: 'تحديد فصيلة الدم (ABO) والعامل الريصي',
    prenup_mand_5: 'تحاليل مصلية للتوكسوبلازما والحصبة الألمانية والزهري',
    prenup_recommended_heading: 'فحوصات موصى بها (حسب السياق)',
    prenup_rec_1: 'تحليل مصلي لالتهاب الكبد B',
    prenup_rec_2: 'تحليل مصلي لالتهاب الكبد C',
    prenup_rec_3: 'تحليل مصلي لفيروس نقص المناعة البشرية',
    prenup_rec_note: 'يمكن للطبيب أن يصف فحوصات إضافية إذا لوحظت أعراض توحي بعدوى منقولة جنسيًا.',
    prenup_right_heading: 'حق مهم',
    prenup_right_text: 'لا يمكن للموثق أو ضابط الحالة المدنية رفض إتمام الزواج بناءً على النتائج الطبية. يبقى الخطيبان حرين تمامًا في الزواج مهما كانت النتائج — فالشهادة لها دور إعلامي فقط، وليست شرطًا مانعًا.',
    prenup_validity_heading: 'الصلاحية والتسليم',
    prenup_validity_text: 'الشهادة صالحة لمدة تقل عن ثلاثة أشهر من تاريخ إصدارها. تُسلَّم لكل خطيب على حدة من قبل الطبيب الفاحص، ثم تُقدَّم للموثق أو ضابط الحالة المدنية قبل تحرير عقد الزواج.',
    prenup_disclaimer: 'تلخّص هذه الصفحة التنظيم المعمول به لأغراض إعلامية فقط؛ ولا تغني عن استشارة طبية. لإجراء هذه الفحوصات، توجه إلى طبيب عام أو مخبر تحاليل معتمد.',

    // Outil : Jeûne du Ramadan et diabète
    ramadan_title: 'صيام رمضان والسكري',
    ramadan_subtitle: 'مؤشر إرشادي مستوحى من إطار تصنيف المخاطر IDF-DAR، لتحضير النقاش مع طبيبك.',
    ramadan_info: 'تستوحي هذه الأداة من الإطار الدولي IDF-DAR لكنها ليست نسخة معتمدة منه — بعض عتبات الخوارزمية الرسمية الكاملة غير منشورة بالتفصيل. تعطي مؤشرًا للنقاش، وليس قرارًا طبيًا. يجب أن يُتخذ قرار الصيام دائمًا مع طبيبك.',
    ramadan_very_high_heading: 'حالات ذات خطورة عالية جدًا',
    ramadan_auto_1: 'حمل حالي',
    ramadan_auto_2: 'غسيل كلوي أو قصور كلوي شديد',
    ramadan_auto_3: 'حماض كيتوني أو غيبوبة فرط الأسمولية خلال الأشهر الـ3 الأخيرة',
    ramadan_auto_4: 'عدم إدراك نوبات نقص السكر (بدون علامات تحذيرية)',
    ramadan_auto_5: 'مرض حاد حاليًا (حمى، عدوى، جراحة حديثة...)',
    ramadan_auto_6: 'احتشاء، سكتة دماغية أو حدث قلبي وعائي خلال الأشهر الـ3 الأخيرة',
    ramadan_auto_7: 'اضطرابات معرفية، اعتماد وظيفي أو تقدم في السن مع ضعف',
    ramadan_type1_label: 'داء السكري من النوع 1',
    ramadan_longstanding_label: 'داء سكري معروف منذ 10 سنوات أو أكثر',
    ramadan_hypo_label: 'نوبات نقص السكر خلال الأشهر الـ3 الأخيرة',
    ramadan_hypo_none: 'لا يوجد',
    ramadan_hypo_rare: 'أقل من مرة في الأسبوع',
    ramadan_hypo_frequent: 'عدة مرات في الأسبوع',
    ramadan_hypo_severe: 'نوبة شديدة (تطلبت مساعدة شخص آخر)',
    ramadan_hba1c_label: 'آخر قياس للهيموغلوبين السكري HbA1c',
    ramadan_hba1c_lt75: 'أقل من 7.5%',
    ramadan_hba1c_mid: 'بين 7.5% و9%',
    ramadan_hba1c_high: 'أكثر من 9%',
    ramadan_treatment_label: 'العلاج الحالي',
    ramadan_treat_1: 'آخر (ميتفورمين، DPP-4، GLP-1، SGLT2، بدون أنسولين أو سلفونيل يوريا)',
    ramadan_treat_2: 'غليكلازيد، غليميبيريد أو ريباغلينيد',
    ramadan_treat_3: 'غليبنكلاميد',
    ramadan_treat_4: 'أنسولين قاعدي فقط',
    ramadan_treat_5: 'أنسولين مختلط، حقنة واحدة يوميًا',
    ramadan_treat_6: 'نظام قاعدي-بلعمي أو مضخة أنسولين',
    ramadan_treat_7: 'أنسولين مختلط، عدة حقن يوميًا',
    ramadan_see_result_btn: 'عرض مؤشر خطري',
    ramadan_band_very_high_label: 'خطورة عالية جدًا',
    ramadan_band_very_high_text: 'يُنصح بعدم الصيام. تحدث مع طبيبك حتمًا قبل اتخاذ القرار — قد تكون هناك حاجة إلى متابعة دقيقة أو تعديل العلاج.',
    ramadan_band_low_label: 'خطورة منخفضة',
    ramadan_band_low_text: 'الصيام ممكن عادةً لهذا الملف، مع مراقبة ذاتية منتظمة وخطة مُعدّة مع طبيبك.',
    ramadan_band_moderate_label: 'خطورة متوسطة',
    ramadan_band_moderate_text: 'يمكن النظر في الصيام لكن بحذر: ناقش مع طبيبك احتمال تعديل العلاج وتعزيز المراقبة.',
    ramadan_band_high_label: 'خطورة عالية',
    ramadan_band_high_text: 'الصيام على الأرجح محفوف بالمخاطر لهذا الملف. يُنصح بشدة بإجراء تقييم طبي قبل رمضان.',
    ramadan_disclaimer: 'أيًا كانت النتيجة، إذا شعرت بعلامات نقص السكر، جفاف شديد أو توعك أثناء الصيام، أفطر فورًا واتخذ التدابير اللازمة: صحتك أهم من الصيام، وهو ما تذكّر به التوصيات الدينية نفسها بالنسبة للمرضى.',

    // Outil : Auto-test de perception des couleurs
    colorperception_title: 'اختبار إدراك الألوان الذاتي',
    colorperception_subtitle: 'مؤشر أولي وترفيهي — وليس تشخيصًا لعمى الألوان.',
    colorperception_info: 'هذا الاختبار المبسط لا يغني عن اختبار إيشيهارا ولا عن فحص طب العيون. يعطيك فقط مؤشرًا أوليًا. قد يختلف عرض الألوان أيضًا حسب شاشتك.',
    colorperception_round_word: 'الجولة',
    colorperception_instruction: 'انقر على المربع الذي يختلف لونه عن البقية.',
    colorperception_correct: 'صحيح!',
    colorperception_wrong: 'ليس تمامًا — إلى التالي.',
    colorperception_score_label: 'النتيجة:',
    colorperception_restart: 'إعادة البدء',
    colorperception_result_good_label: 'لم يُرصد أي صعوبة ملحوظة',
    colorperception_result_good_text: 'ميّزت بشكل صحيح معظم الألوان المقترحة في هذا الاختبار المبسط.',
    colorperception_result_mid_label: 'بعض التردد',
    colorperception_result_mid_text: 'كانت بعض الألوان أصعب في التمييز. اختبار يجريه طبيب عيون (اختبار إيشيهارا أو ما يعادله) سيعطي رأيًا موثوقًا.',
    colorperception_result_bad_label: 'صعوبات متكررة',
    colorperception_result_bad_text: 'واجهت صعوبة في تمييز عدة ألوان متقاربة. نوصيك باستشارة طبيب عيون لإجراء اختبار كامل لرؤية الألوان.',
    colorperception_disclaimer: 'يتأكد عمى الألوان (غالبًا صعوبة في تمييز الأحمر والأخضر) عبر اختبار طبي معياري. الكشف المبكر، خصوصًا عند الطفل، يسمح بتكييف بعض التعلمات المدرسية.',

    // Outil : Auto-questionnaire de stress
    stress_title: 'استبيان التوتر الذاتي',
    stress_subtitle: 'مؤشر إرشادي حول مستوى توترك اليومي — وليس تشخيصًا سريريًا.',
    stress_info: 'هذا الاستبيان المبسط ليس مقياسًا سريريًا معتمدًا (مثل HAD أو PSS). يعطيك مؤشرًا أوليًا شخصيًا؛ فقط أخصائي رعاية صحية يمكنه تشخيص التوتر المزمن أو القلق أو الإرهاق (الاحتراق النفسي).',
    stress_intro: 'خلال الأسبوعين الأخيرين...',
    stress_q1: 'أشعر بالتوتر أو الانفعال، حتى دون سبب واضح',
    stress_q2: 'أجد صعوبة في الاسترخاء بعد انتهاء اليوم',
    stress_q3: 'أنام بشكل أقل جودة أو أستيقظ متعبًا',
    stress_q4: 'أصبحت أكثر انفعالًا من المعتاد مع المقربين',
    stress_q5: 'أجد صعوبة في التركيز على مهامي',
    stress_q6: 'أشعر بأنني مثقل بما يجب علي فعله',
    stress_q7: 'لدي طاقة أو رغبة أقل في الأشياء التي أحبها عادة',
    stress_q8: 'أشعر بتوترات جسدية (صداع، آلام، شد في الفك...)',
    stress_opt_never: 'أبدًا',
    stress_opt_sometimes: 'أحيانًا',
    stress_opt_often: 'غالبًا',
    stress_opt_almost_always: 'دائمًا تقريبًا',
    stress_see_result_btn: 'عرض نتيجتي',
    stress_band_low_label: 'توتر محدود',
    stress_band_low_text: 'لا يبدو أن حياتك اليومية متأثرة بتوتر كبير حاليًا. واصل الاعتناء بتوازنك (النوم، النشاط، وقت لنفسك).',
    stress_band_mid_label: 'توتر متوسط',
    stress_band_mid_text: 'تظهر لديك علامات توتر تستحق المراقبة. الاستراحات المنتظمة، النشاط البدني، النوم الجيد، والحديث مع المقربين أو أخصائي يمكن أن يساعد.',
    stress_band_high_label: 'توتر ملحوظ',
    stress_band_high_text: 'تشير إجاباتك إلى مستوى توتر مرتفع ومستمر. سيكون من المفيد التحدث مع طبيب أو أخصائي في الصحة النفسية، والذي يمكنه إجراء تقييم حقيقي ومرافقتك.',
    stress_help_note: 'إذا كنت تمر بفترة صعبة أو تراودك أفكار سوداء، لا تتردد في التحدث مع شخص تثق به أو أخصائي رعاية صحية — أنت لست وحدك، والمرافقة يمكن أن تساعد فعلًا.',

    // Hub des outils santé
    hub_page_title: 'أدوات صحية',
    hub_page_subtitle: 'أدوات مجانية لفهم صحتك بشكل أفضل في حياتك اليومية.',
    hub_footer_tagline: 'المنصة الجزائرية لحجز المواعيد الطبية',
    hub_disclaimer: 'توفر هذه الأدوات تقديرات لأغراض إعلامية فقط ولا تغني عن الاستشارة الطبية. في حال الشك، استشر أخصائي رعاية صحية.',
    hub_cta_discover: 'اكتشف',
    hub_badge_new: 'جديد',
    hub_badge_popular: 'شائع',
    hub_cat_emergency: 'الطوارئ والوقاية',
    hub_cat_child: 'صحة الطفل وطب الأطفال',
    hub_cat_chronic: 'الأمراض المزمنة والمتابعة اليومية',
    hub_cat_nutrition: 'التغذية والأيض',
    hub_cat_women: 'المرأة والخصوبة والحمل',
    hub_cat_wellbeing: 'الرفاهية ونمط الحياة',
    hub_cat_admin: 'الإجراءات والحقوق في الجزائر',
    hub_triage_urgence_title: 'فرز الطوارئ',
    hub_triage_urgence_desc: 'مؤشر أولي لمعرفة ما إذا كان يجب الاتصال بالإسعاف أو استشارة سريعة.',
    hub_triage_urgence_cta: 'تحقق الآن',
    hub_fievre_title: 'محوّل درجة الحرارة',
    hub_fievre_desc: 'قارن درجة الحرارة حسب طريقة القياس، والعتبات التي يجب أن تنبهك.',
    hub_fievre_cta: 'حوّل',
    hub_arret_tabac_title: 'الإقلاع عن التدخين',
    hub_arret_tabac_desc: 'مدخراتك بالدينار الجزائري والفوائد الصحية بمرور الوقت.',
    hub_arret_tabac_cta: 'احسب',
    hub_posologie_enfant_title: 'الجرعة الدوائية للأطفال',
    hub_posologie_enfant_desc: 'مؤشر جرعة الباراسيتامول والإيبوبروفين عند الطفل.',
    hub_posologie_enfant_cta: 'احسب الجرعة',
    hub_vaccination_title: 'جدول التلقيح',
    hub_vaccination_desc: 'جدول تلقيح الطفل في الجزائر، مع تواريخك المخصصة.',
    hub_vaccination_cta: 'عرض الجدول',
    hub_croissance_title: 'النمو (منحنيات منظمة الصحة العالمية)',
    hub_croissance_desc: 'وزن وطول طفلك مقارنة بمعايير منظمة الصحة العالمية، من 0 إلى 5 سنوات.',
    hub_croissance_cta: 'قارن',
    hub_deshydratation_title: 'الجفاف ومحلول الإماهة الفموي',
    hub_deshydratation_desc: 'كمية محلول الإماهة الفموي في حالة الإسهال أو القيء.',
    hub_deshydratation_cta: 'احسب',
    hub_tension_arterielle_title: 'ضغط الدم',
    hub_tension_arterielle_desc: 'مؤشر إرشادي انطلاقًا من أرقام ضغط دمك.',
    hub_tension_arterielle_cta: 'تحقق من ضغطي',
    hub_glycemie_title: 'محوّل سكر الدم',
    hub_glycemie_desc: 'تحويل ملغ/دل ↔ مليمول/ل ومعادلة مع HbA1c.',
    hub_glycemie_cta: 'حوّل',
    hub_clairance_creatinine_title: 'تصفية الكرياتينين',
    hub_clairance_creatinine_desc: 'تقدير وظيفة كليتيك (معادلة كوكروفت-غولت).',
    hub_clairance_creatinine_cta: 'قدّر',
    hub_risque_cardiovasculaire_title: 'الخطر القلبي الوعائي',
    hub_risque_cardiovasculaire_desc: 'مؤشر أولي حول عوامل الخطر القلبي الوعائي لديك.',
    hub_risque_cardiovasculaire_cta: 'قيّم خطري',
    hub_bilan_sanguin_title: 'محوّل تحليل الدم',
    hub_bilan_sanguin_desc: 'تعداد الدم وتحليل الدهون: حوّل وتعرّف على قيمك المعتادة.',
    hub_bilan_sanguin_cta: 'حوّل',
    hub_ramadan_diabete_title: 'صيام رمضان والسكري',
    hub_ramadan_diabete_desc: 'مؤشر خطر لتحضير النقاش مع طبيبك قبل الصيام.',
    hub_ramadan_diabete_cta: 'قيّم خطري',
    hub_planning_antibiotiques_title: 'جدول المضادات الحيوية',
    hub_planning_antibiotiques_desc: 'جدول جرعات حتى لا تنسى شيئًا وتُنهي علاجك.',
    hub_planning_antibiotiques_cta: 'أنشئ جدولي',
    hub_imc_title: 'حاسبة مؤشر كتلة الجسم',
    hub_imc_desc: 'احسب مؤشر كتلة جسمك وتعرّف على فئة وزنك.',
    hub_imc_cta: 'احسب مؤشري',
    hub_hydratation_title: 'حاسبة الترطيب',
    hub_hydratation_desc: 'احتياجاتك من الماء حسب وزنك والمناخ ونشاطك.',
    hub_hydratation_cta: 'احسب',
    hub_calories_title: 'الاحتياجات من السعرات الحرارية',
    hub_calories_desc: 'سعراتك الحرارية اليومية حسب هدف وزنك.',
    hub_calories_cta: 'احسب',
    hub_masse_grasse_title: 'نسبة الدهون (طريقة البحرية الأمريكية)',
    hub_masse_grasse_desc: 'تقدير نسبة الدهون في جسمك.',
    hub_masse_grasse_cta: 'قدّر',
    hub_calcium_vitamine_d_title: 'الكالسيوم وفيتامين د',
    hub_calcium_vitamine_d_desc: 'احتياجاتك اليومية الموصى بها حسب عمرك ووضعيتك.',
    hub_calcium_vitamine_d_cta: 'عرض احتياجاتي',
    hub_ovulation_title: 'حاسبة الإباضة',
    hub_ovulation_desc: 'قدّري فترة خصوبتك وتاريخ دورتك القادمة.',
    hub_ovulation_cta: 'احسبي',
    hub_grossesse_title: 'متابعة الحمل',
    hub_grossesse_desc: 'قدّري تاريخ ولادتك وتابعي تقدم حملك.',
    hub_grossesse_cta: 'تابعي حملي',
    hub_prise_poids_grossesse_title: 'زيادة الوزن أثناء الحمل',
    hub_prise_poids_grossesse_desc: 'معايير زيادة الوزن أثناء الحمل حسب مؤشر كتلة جسمك الأولي.',
    hub_prise_poids_grossesse_cta: 'تحقّقي',
    hub_bilan_prenuptial_title: 'الشهادة الطبية لما قبل الزواج',
    hub_bilan_prenuptial_desc: 'ما تنص عليه القوانين الجزائرية: الفحوصات، الصلاحية، حقوقك.',
    hub_bilan_prenuptial_cta: 'اعرف أكثر',
    hub_stress_title: 'استبيان التوتر الذاتي',
    hub_stress_desc: 'مؤشر إرشادي حول مستوى توترك اليومي.',
    hub_stress_cta: 'أجرِ الاختبار',
    hub_cycles_sommeil_title: 'دورات النوم',
    hub_cycles_sommeil_desc: 'اعثر على الوقت المثالي للنوم أو الاستيقاظ.',
    hub_cycles_sommeil_cta: 'احسب',
    hub_perception_couleurs_title: 'اختبار إدراك الألوان',
    hub_perception_couleurs_desc: 'مؤشر أولي وترفيهي — وليس تشخيصًا لعمى الألوان.',
    hub_perception_couleurs_cta: 'أجرِ الاختبار',
    hub_doublons_medicaments_title: 'ازدواجية الأدوية',
    hub_doublons_medicaments_desc: 'تحقق مما إذا كانت الأدوية التي تتناولها تشترك في نفس المادة الفعالة.',
    hub_doublons_medicaments_cta: 'تحقق',
    hub_simulateur_cnas_title: 'محاكي استرجاع مصاريف CNAS/CASNOS',
    hub_simulateur_cnas_desc: 'تقدير إرشادي لاسترجاع مصاريفك حسب نوع الرعاية.',
    hub_simulateur_cnas_cta: 'حاكِ',
    hub_conge_maternite_title: 'إجازة الأمومة والعطلة المرضية',
    hub_conge_maternite_desc: 'المدة والتعويض وفق القانون 25-08 والنظام العام لـCNAS.',
    hub_conge_maternite_cta: 'عرض تواريخي',
    // Page Incendies 2026
    incendies_page_title: 'تضامن حرائق 2026',
    incendies_hero_title: 'طبيبك بكل قلبها مع الجزائر',
    incendies_hero_text: 'أفكارنا مع العائلات المتضررة من الحرائق في جيجل وبجاية وتيزي وزو والولايات الأخرى المنكوبة في الأيام الأخيرة، وكذلك مع جميع فرق الحماية المدنية المعبأة في الميدان.',
    incendies_donate_btn: 'تبرع للهلال الأحمر الجزائري',
    incendies_emergency_title: 'أرقام الطوارئ المفيدة',
    incendies_emergency_pc: 'الحماية المدنية',
    incendies_emergency_samu: 'سامو (الإسعاف)',
    incendies_emergency_police: 'الشرطة',
    incendies_emergency_gendarmerie: 'الدرك الوطني',
    incendies_safety_title: 'نصائح الوقاية والسلامة',
    incendies_safety_alert_title: '⚠️ إذا كان الحريق يهدد منزلكم مباشرة',
    incendies_safety_alert_text: 'توصي الحماية المدنية بالإخلاء الطوعي والوقائي الفوري بمجرد اقتراب الحريق من منطقتكم، دون انتظار أمر رسمي. تعاونوا بشكل كامل مع فرق الإنقاذ الموجودة في الميدان.',
    incendies_before_title: 'قبل الحريق / الوقاية',
    incendies_before_1: 'أبلغوا فورا عن أي بداية حريق أو سلوك مشبوه على الرقم 14',
    incendies_before_2: 'لا تقوموا بأي حرق في فترات الرياح القوية أو الحرارة الشديدة',
    incendies_before_3: 'لا تخزنوا الحطب أو الوقود أو قنينات الغاز بالقرب من المنزل',
    incendies_before_4: 'زودوا مدخنة منزلكم بشبكة واقية من الشرر',
    incendies_before_5: 'قوموا بإزالة الأعشاب حول منزلكم إن أمكن',
    incendies_during_title: 'في حالة وجود دخان / حريق قريب',
    incendies_during_1: 'احموا أنفسكم من الدخان بقطعة قماش مبللة على الأنف والفم',
    incendies_during_2: 'تجنبوا أي مجهود بدني شديد، خاصة لكبار السن ومرضى الربو',
    incendies_during_3: 'أغلقوا الأبواب والنوافذ وفتحات التهوية إذا بقيتم بالداخل',
    incendies_during_4: 'أخلوا الطرقات لمرور فرق الإنقاذ، ولا تتوقفوا فيها بدافع الفضول',
    incendies_during_5: 'أبقوا هاتفكم متاحا لفرق الإنقاذ، وقللوا من المكالمات غير الضرورية',
    incendies_doctors_title: 'أطباء متوفرون في الولايات المتضررة',
    incendies_doctors_subtitle: 'تحتاجون طبيبا في جيجل أو بجاية أو تيزي وزو؟ إليكم مجموعة من المهنيين الصحيين المتوفرين على طبيبك.',
    incendies_see_all: 'عرض كل الأطباء ←',
    incendies_no_doctors: 'لم يتم العثور على أي طبيب حاليا في',
  }
};

export default translations;
